(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Hull.js"] = factory();
	else
		root["Hull.js"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!*************************!*\
  !*** ./src/hull.coffee ***!
  \*************************/
/***/ function(module, exports, __webpack_require__) {

	var Api, Channel, Client, CurrentConfig, CurrentUser, EventBus, HullRemote, Pool, Promise, Raven, _, assign, autoStartConfig, captureException, decodeHash, displayBanner, eeMethods, embeds, hull, hullReady, init, initializePlatform, logger, onEmbedComplete, onEmbedError, onInitFailure, onInitSuccess, parseHash, polyfill, ready, scriptTagConfig, shimmedMethod,
	  slice = [].slice;
	
	assign = __webpack_require__(/*! ./polyfills/assign */ 2);
	
	Promise = __webpack_require__(/*! ./utils/promises */ 3);
	
	_ = __webpack_require__(/*! ./utils/lodash */ 1);
	
	polyfill = __webpack_require__(/*! ./utils/load-polyfills */ 29);
	
	logger = __webpack_require__(/*! ./utils/logger */ 5);
	
	Raven = __webpack_require__(/*! ./utils/raven */ 30);
	
	Client = __webpack_require__(/*! ./client */ 105);
	
	CurrentUser = __webpack_require__(/*! ./client/current-user */ 97);
	
	CurrentConfig = __webpack_require__(/*! ./client/current-config */ 96);
	
	Channel = __webpack_require__(/*! ./client/channel */ 55);
	
	Api = __webpack_require__(/*! ./client/api */ 54);
	
	EventBus = __webpack_require__(/*! ./utils/eventbus */ 6);
	
	Pool = __webpack_require__(/*! ./utils/pool */ 135);
	
	HullRemote = __webpack_require__(/*! ./hull-remote */ 113);
	
	embeds = __webpack_require__(/*! ./client/embeds */ 83);
	
	scriptTagConfig = __webpack_require__(/*! ./client/script-tag-config */ 107);
	
	initializePlatform = __webpack_require__(/*! ./client/initialize-platform */ 84);
	
	decodeHash = __webpack_require__(/*! ./utils/decode-hash */ 132);
	
	displayBanner = __webpack_require__(/*! ./utils/ui/display-banner */ 61);
	
	
	/**
	 * Wraps the success callback
	 *
	 * Extends the global object
	 * Reinjects events in the live app from the pool
	 * Replays the track events
	 * @param  {function} userSuccessCallback the function that will be called if everything went well
	 * @param  {object} _hull               an partial build of the Hull object
	 * @param  {object} data                config data coming from the Remote
	 * @return {object}                     the Hull object
	 */
	
	onInitSuccess = function(userSuccessCallback, hull, data) {
	  var app, check, config, hash, me, org, orgOk, orgUrl, origin, platformOk, ref, response, snippet, snippetOrgUrl;
	  userSuccessCallback = userSuccessCallback || function() {};
	  me = data.me, app = data.app, org = data.org;
	  embeds.initialize({
	    org: org
	  });
	  hull.embed = embeds.embed;
	  hull.onEmbed = embeds.onEmbed;
	  delete hull.initRemote;
	  Pool.run('track', hull);
	  ready.resolve({
	    hull: hull,
	    me: me,
	    app: app,
	    org: org
	  });
	  EventBus.emit('hull.ready', hull, me, app, org);
	  EventBus.emit('hull.init', hull, me, app, org);
	  logger.log("Hull.js version \"" + hull.version + "\" started");
	  if (hull.config().embed !== false) {
	    if (_.isArray(app != null ? app.deployments : void 0) && app.deployments.length > 0) {
	      embeds.embed(app.deployments, {}, onEmbedComplete, onEmbedError);
	    } else {
	      onEmbedComplete();
	    }
	  }
	  hash = decodeHash();
	  snippet = hash != null ? (ref = hash.hull) != null ? ref.snippet : void 0 : void 0;
	  if (snippet) {
	    config = hull.config();
	    origin = snippet.origin;
	    platformOk = snippet.platformId === config.appId;
	    snippetOrgUrl = snippet.orgUrl.replace(/^http:/, 'https:');
	    orgUrl = config.orgUrl.replace(/^http:/, 'https:');
	    orgOk = snippetOrgUrl === orgUrl;
	    check = snippet.check;
	    window.location.hash = "";
	    if (orgOk && platformOk) {
	      opener.postMessage({
	        result: check
	      }, origin);
	      EventBus.once('hull.snippet.success', function() {
	        opener.postMessage({
	          result: check
	        }, origin);
	        return window.close();
	      });
	      displayBanner('platform');
	    } else {
	      response = {
	        code: 'invalid',
	        orgUrl: orgUrl,
	        platformId: config.appId
	      };
	      opener.postMessage({
	        error: btoa(JSON.stringify(response))
	      }, origin);
	    }
	  }
	  userSuccessCallback(hull, me, app, org);
	  return hull;
	};
	
	onInitFailure = function(err) {
	  throw err;
	};
	
	onEmbedComplete = function() {
	  EventBus.emit('hull.ships.ready');
	  return logger.log("Hull Embeds Completed successfully");
	};
	
	onEmbedError = function() {
	  var err;
	  err = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return logger.error.apply(logger, ["Failed embedding Ships"].concat(slice.call(err)));
	};
	
	parseHash = function() {
	  var hash, ref, ref1;
	  if (window.location.href.match('//.+\.hullapp\.io/.+/remote.html')) {
	    return;
	  }
	  hash = decodeHash();
	  if ((hash != null) && hash.hasOwnProperty('success')) {
	    window.location.hash = '';
	    if (((typeof window !== "undefined" && window !== null ? (ref = window.opener) != null ? ref.Hull : void 0 : void 0) != null) && (typeof window !== "undefined" && window !== null ? (ref1 = window.opener) != null ? ref1.__hull_login_status__ : void 0 : void 0)) {
	      window.opener.__hull_login_status__(hash);
	      return window.close();
	    }
	  }
	};
	
	parseHash();
	
	captureException = function(err, ctx) {
	  return Raven.captureException(err, ctx);
	};
	
	
	/**
	 * Main Hull Entry Point
	 *
	 * Will only be executed once.
	 * @param  {[type]} config={}         [description]
	 * @param  {[type]} userSuccessCallback [description]
	 * @param  {[type]} userFailureCallback [description]
	 * @return {[type]}                     [description]
	 */
	
	init = function(config, userSuccessCallback, userFailureCallback) {
	  var channel, client, currentConfig, currentUser, httpsRegex, missing, throwErr;
	  if (config == null) {
	    config = {};
	  }
	  if (!!hull._initialized) {
	    throw new Error('Hull.init can be called only once');
	    return;
	  }
	  config.version = ("0.9.0");
	  config.debug = config.debug ? {
	    enabled: true,
	    verbose: config.verbose
	  } : {};
	  logger.init(config.debug);
	  config.appId = config.appId || config.platformId || config.shipId;
	  if (config.platformId != null) {
	    delete config.platformId;
	  }
	  if (config.shipId != null) {
	    delete config.shipId;
	  }
	  missing = [];
	  if (config.orgUrl == null) {
	    missing.push("orgUrl");
	  }
	  if (config.appId == null) {
	    missing.push("platformId");
	  }
	  httpsRegex = /^https:|^\/\//;
	  if (config.jsUrl && !httpsRegex.test(config.jsUrl) && httpsRegex.test(config.jsUrl)) {
	    throw new Error("[Hull.init] jsUrl NEEDS be loaded via https if orgUrl is https");
	  }
	  if (missing.length) {
	    throw new Error("[Hull.init] You forgot to pass " + (missing.join(',')) + " needed to initialize hull properly");
	  }
	  hull._initialized = true;
	  client = {};
	  channel = {};
	  currentUser = new CurrentUser();
	  currentConfig = new CurrentConfig();
	  Raven.init(config.ravenDsn, {
	    runtime: 'hull-js',
	    orgUrl: config.orgUrl,
	    appId: config.appId || config.platformId
	  });
	  throwErr = function(err) {
	    logger.error(err.stack);
	    userFailureCallback = userFailureCallback || function() {};
	    userFailureCallback(err);
	    ready.reject(err);
	    return Raven.captureException(err);
	  };
	  return currentConfig.init(config).then(function(config) {
	    polyfill.fill(config);
	    return config;
	  }).then((function(_this) {
	    return function(currentConfig) {
	      channel = new Channel(currentUser, currentConfig);
	      return channel.promise;
	    };
	  })(this), throwErr).then((function(_this) {
	    return function(channel) {
	      return client = new Client(channel, currentUser, currentConfig);
	    };
	  })(this), onInitFailure, throwErr).then((function(_this) {
	    return function(hullClient) {
	      var data;
	      client.hull = assign(hull, client.hull);
	      data = currentConfig.getRemote('data');
	      currentUser.init(data != null ? data.me : void 0);
	      initializePlatform(data, currentConfig, client.hull);
	      return onInitSuccess(userSuccessCallback, client.hull, data);
	    };
	  })(this), throwErr)["catch"](throwErr);
	};
	
	ready = {};
	
	ready.promise = new Promise((function(_this) {
	  return function(resolve, reject) {
	    ready.reject = reject;
	    return ready.resolve = resolve;
	  };
	})(this));
	
	ready.promise["catch"](function(err) {
	  throw new Error('Hull.ready callback error', err);
	});
	
	hullReady = function(callback, errback) {
	  callback = callback || function() {};
	  errback = errback || function() {};
	  return ready.promise.then(function(res) {
	    return callback(res.hull, res.me, res.app, res.org);
	  }, errback)["catch"](function(err) {
	    return logger.error(err.message, err.stack);
	  });
	};
	
	shimmedMethod = function(method) {
	  logger.log("Hull." + method + " is only useful when Ships are sandboxed. This method does nothing here");
	  return false;
	};
	
	hull = {
	  _initialized: false,
	  initRemote: HullRemote,
	  init: init,
	  ready: hullReady,
	  version: ("0.9.0"),
	  revision: ("0134f444728e2926818126b5f7c1557e85b90aa4"),
	  track: Pool.create('track'),
	  captureException: captureException,
	  autoSize: function() {
	    return shimmedMethod("autoSize");
	  },
	  setShipStyle: function() {
	    return shimmedMethod("setShipStyle");
	  },
	  setShipSize: function() {
	    return shimmedMethod("setShipSize");
	  }
	};
	
	eeMethods = ['on', 'onAny', 'offAny', 'once', 'many', 'off', 'emit'];
	
	_.map(eeMethods, function(m) {
	  return hull[m] = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return EventBus[m].apply(EventBus, args);
	  };
	});
	
	if (window.Hull == null) {
	  autoStartConfig = scriptTagConfig();
	  if (autoStartConfig && autoStartConfig.autoStart) {
	    if (!hull._initialized) {
	      autoStartConfig && autoStartConfig.autoStart && init(autoStartConfig);
	    }
	  }
	  window.Hull = hull;
	  setTimeout(function() {
	    if ((typeof window !== "undefined" && window !== null ? window.hullAsyncInit : void 0) && _.isFunction(window.hullAsyncInit)) {
	      return window.hullAsyncInit(hull);
	    }
	  }, 0);
	} else {
	  logger.error("Hull Snippet found more than once (or you already have a global variable named window.Hull). Either way, we can't launch Hull more than once. We only use the first one in the page");
	}
	
	module.exports = hull;


/***/ },
/* 1 */
/*!*****************************!*\
  !*** ./src/utils/lodash.js ***!
  \*****************************/
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/* global require */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  compact: __webpack_require__(/*! lodash/array/compact */ 141),
	  uniq: __webpack_require__(/*! lodash/array/uniq */ 144),
	  contains: __webpack_require__(/*! lodash/collection/contains */ 146),
	  reject: __webpack_require__(/*! lodash/collection/reject */ 156),
	  toArray: __webpack_require__(/*! lodash/lang/toArray */ 211),
	  defaults: __webpack_require__(/*! lodash/object/defaults */ 213),
	  each: __webpack_require__(/*! lodash/collection/each */ 147),
	  partition: __webpack_require__(/*! lodash/collection/partition */ 153),
	  every: __webpack_require__(/*! lodash/collection/every */ 148),
	  indexOf: __webpack_require__(/*! lodash/array/indexOf */ 142),
	  isEmpty: __webpack_require__(/*! lodash/lang/isEmpty */ 207),
	  throttle: __webpack_require__(/*! lodash/function/throttle */ 160),
	  isArray: __webpack_require__(/*! lodash/lang/isArray */ 4),
	  isEqual: __webpack_require__(/*! lodash/lang/isEqual */ 208),
	  isFunction: __webpack_require__(/*! lodash/lang/isFunction */ 44),
	  isObject: __webpack_require__(/*! lodash/lang/isObject */ 7),
	  isString: __webpack_require__(/*! lodash/lang/isString */ 45),
	  isUndefined: __webpack_require__(/*! lodash/lang/isObject */ 7),
	  keys: __webpack_require__(/*! lodash/object/keys */ 16),
	  map: __webpack_require__(/*! lodash/collection/map */ 64),
	  find: __webpack_require__(/*! lodash/collection/find */ 150),
	  filter: __webpack_require__(/*! lodash/collection/filter */ 149),
	  values: __webpack_require__(/*! lodash/object/values */ 47),
	  omit: __webpack_require__(/*! lodash/object/omit */ 214),
	  pick: __webpack_require__(/*! lodash/object/pick */ 216),
	  pluck: __webpack_require__(/*! lodash/collection/pluck */ 154),
	  reduce: __webpack_require__(/*! lodash/collection/reduce */ 155),
	  some: __webpack_require__(/*! lodash/collection/some */ 157),
	  zipObject: __webpack_require__(/*! lodash/array/zipObject */ 145)
	};
	module.exports = exports["default"];

/***/ },
/* 2 */
/*!*********************************!*\
  !*** ./src/polyfills/assign.js ***!
  \*********************************/
/***/ function(module, exports) {

	"use strict";
	
	Object.assign = Object.assign || function assign(target, source) {
	  for (var index = 1, key; (index in arguments); ++index) {
	    source = arguments[index];
	
	    for (key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};
	module.exports = Object.assign;

/***/ },
/* 3 */
/*!***********************************!*\
  !*** ./src/utils/promises.coffee ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var Promise;
	
	Promise = __webpack_require__(/*! bluebird/js/browser/bluebird.core */ 93);
	
	Promise.deferred = Promise.deferred || function() {
	  var dfd;
	  dfd = {};
	  dfd.promise = new Promise((function(_this) {
	    return function(resolve, reject) {
	      dfd.resolve = resolve;
	      return dfd.reject = reject;
	    };
	  })(this));
	  return dfd;
	};
	
	module.exports = Promise;


/***/ },
/* 4 */
/*!**********************************!*\
  !*** ./~/lodash/lang/isArray.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ../internal/getNative */ 25),
	    isLength = __webpack_require__(/*! ../internal/isLength */ 14),
	    isObjectLike = __webpack_require__(/*! ../internal/isObjectLike */ 15);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 5 */
/*!*********************************!*\
  !*** ./src/utils/logger.coffee ***!
  \*********************************/
/***/ function(module, exports) {

	var enabled, error, log, verbose,
	  slice = [].slice;
	
	enabled = false;
	
	verbose = false;
	
	log = function() {
	  var args;
	  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return console.log.apply(console, args);
	};
	
	error = function() {
	  var args;
	  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	  return console.error.apply(console, args);
	};
	
	module.exports = {
	  enabled: function() {
	    return !!enabled;
	  },
	  init: function(debug) {
	    enabled = !!debug.enabled;
	    return verbose = !!debug.verbose;
	  },
	  log: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (enabled) {
	      return log.apply(null, args);
	    }
	  },
	  info: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (enabled) {
	      return log.apply(null, args);
	    }
	  },
	  verbose: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    if (enabled && verbose) {
	      return log.apply(null, args);
	    }
	  },
	  warn: function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return console.warn.apply(console, args);
	  },
	  error: error
	};


/***/ },
/* 6 */
/*!*******************************!*\
  !*** ./src/utils/eventbus.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _eventemitter2 = __webpack_require__(/*! eventemitter2 */ 63);
	
	var _eventemitter22 = _interopRequireDefault(_eventemitter2);
	
	var emitter = new _eventemitter22["default"]({
	  wildcard: true,
	  maxListeners: 200,
	  newListener: false,
	  delimiter: "."
	});
	exports["default"] = emitter;
	module.exports = exports["default"];

/***/ },
/* 7 */
/*!***********************************!*\
  !*** ./~/lodash/lang/isObject.js ***!
  \***********************************/
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 8 */
/*!****************************************************!*\
  !*** ./src/remote/services/generic-service.coffee ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, RemoteConfigStore, getWrappedRequest, jsonp,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	RemoteConfigStore = __webpack_require__(/*! ../../flux/stores/RemoteConfigStore */ 27);
	
	getWrappedRequest = __webpack_require__(/*! ../wrapped-request */ 51);
	
	jsonp = __webpack_require__(/*! browser-jsonp */ 94);
	
	GenericService = (function() {
	  GenericService.prototype.name = null;
	
	  GenericService.prototype.path = null;
	
	  function GenericService(config, gateway) {
	    this.request_jsonp = bind(this.request_jsonp, this);
	    this.config = config;
	    this.gateway = gateway;
	    this.wrappedRequest = getWrappedRequest({
	      name: this.name,
	      path: this.path
	    }, gateway);
	  }
	
	  GenericService.prototype.getSettings = function(provider) {
	    return RemoteConfigStore.getAuth(this.name || provider);
	  };
	
	  GenericService.prototype.request_jsonp = function(request) {
	    return jsonp(request);
	  };
	
	  return GenericService;
	
	})();
	
	module.exports = GenericService;


/***/ },
/* 9 */
/*!********************************!*\
  !*** ./src/utils/clone.coffee ***!
  \********************************/
/***/ function(module, exports) {

	module.exports = function(obj) {
	  if (obj == null) {
	    return obj;
	  }
	  return JSON.parse(JSON.stringify(obj));
	};


/***/ },
/* 10 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/baseCallback.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(/*! ./baseMatches */ 180),
	    baseMatchesProperty = __webpack_require__(/*! ./baseMatchesProperty */ 181),
	    bindCallback = __webpack_require__(/*! ./bindCallback */ 20),
	    identity = __webpack_require__(/*! ../utility/identity */ 48),
	    property = __webpack_require__(/*! ../utility/property */ 80);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 11 */
/*!***************************************!*\
  !*** ./~/lodash/internal/toObject.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 12 */
/*!********************************!*\
  !*** ./src/utils/throw.coffee ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	var Raven, logger;
	
	logger = __webpack_require__(/*! ./logger */ 5);
	
	Raven = __webpack_require__(/*! ./raven */ 30);
	
	module.exports = function(err) {
	  Raven.captureException(err);
	  return logger.error(err.message, err.stack);
	};


/***/ },
/* 13 */
/*!***************************************!*\
  !*** ./~/lodash/internal/baseEach.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(/*! ./baseForOwn */ 176),
	    createBaseEach = __webpack_require__(/*! ./createBaseEach */ 194);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 14 */
/*!***************************************!*\
  !*** ./~/lodash/internal/isLength.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 15 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/isObjectLike.js ***!
  \*******************************************/
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 16 */
/*!*********************************!*\
  !*** ./~/lodash/object/keys.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ../internal/getNative */ 25),
	    isArrayLike = __webpack_require__(/*! ../internal/isArrayLike */ 21),
	    isObject = __webpack_require__(/*! ../lang/isObject */ 7),
	    shimKeys = __webpack_require__(/*! ../internal/shimKeys */ 205);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 17 */
/*!***********************************************!*\
  !*** ./src/flux/constants/RemoteConstants.js ***!
  \***********************************************/
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  UPDATE_CLIENT_CONFIG: 'UPDATE_CLIENT_CONFIG',
	  UPDATE_REMOTE_CONFIG: 'UPDATE_REMOTE_CONFIG',
	  UPDATE_SERVICES: 'UPDATE_SERVICES',
	
	  SET_HEADER: 'SET_HEADER',
	
	  LOGOUT_USER: 'LOGOUT_USER',
	  UPDATE_USER: 'UPDATE_USER'
	};

/***/ },
/* 18 */
/*!*****************************!*\
  !*** ./src/utils/base64.js ***!
  \*****************************/
/***/ function(module, exports) {

	// https://code.google.com/p/stringencoders/source/browse/trunk/javascript/base64.js?r=230
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var PADCHAR = '=';
	var ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	function makeDOMException() {
	  // sadly in FF,Safari,Chrome you can't make a DOMException
	  var e, tmp;
	
	  try {
	    return new DOMException(DOMException.INVALID_CHARACTER_ERR);
	  } catch (tmp) {
	    // not available, just passback a duck-typed equiv
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error
	    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error/prototype
	    var ex = new Error("DOM Exception 5");
	
	    // ex.number and ex.description is IE-specific.
	    ex.code = ex.number = 5;
	    ex.name = ex.description = "INVALID_CHARACTER_ERR";
	
	    // Safari/Chrome output format
	    ex.toString = function () {
	      return 'Error: ' + ex.name + ': ' + ex.message;
	    };
	    return ex;
	  }
	}
	
	function getbyte64(s, i) {
	  // This is oddly fast, except on Chrome/V8.
	  // Minimal or no improvement in performance by using a
	  // object with properties mapping chars to value (eg. 'A': 0)
	  var idx = ALPHA.indexOf(s.charAt(i));
	  if (idx === -1) {
	    throw makeDOMException();
	  }
	  return idx;
	}
	
	function getbyte(s, i) {
	  var x = s.charCodeAt(i);
	  if (x > 255) {
	    throw makeDOMException();
	  }
	  return x;
	}
	
	function encode(s) {
	  if (arguments.length !== 1) {
	    throw new SyntaxError("Not enough arguments");
	  }
	  var padchar = PADCHAR;
	  var alpha = ALPHA;
	
	  var i, b10;
	  var x = [];
	
	  // convert to string
	  s = '' + s;
	
	  var imax = s.length - s.length % 3;
	
	  if (s.length === 0) {
	    return s;
	  }
	  for (i = 0; i < imax; i += 3) {
	    b10 = getbyte(s, i) << 16 | getbyte(s, i + 1) << 8 | getbyte(s, i + 2);
	    x.push(alpha.charAt(b10 >> 18));
	    x.push(alpha.charAt(b10 >> 12 & 0x3F));
	    x.push(alpha.charAt(b10 >> 6 & 0x3f));
	    x.push(alpha.charAt(b10 & 0x3f));
	  }
	  switch (s.length - imax) {
	    case 1:
	      b10 = getbyte(s, i) << 16;
	      x.push(alpha.charAt(b10 >> 18) + alpha.charAt(b10 >> 12 & 0x3F) + padchar + padchar);
	      break;
	    case 2:
	      b10 = getbyte(s, i) << 16 | getbyte(s, i + 1) << 8;
	      x.push(alpha.charAt(b10 >> 18) + alpha.charAt(b10 >> 12 & 0x3F) + alpha.charAt(b10 >> 6 & 0x3f) + padchar);
	      break;
	  }
	  return x.join('');
	}
	
	function decode(s) {
	  // convert to string
	  s = '' + s;
	  var pads, i, b10;
	  var imax = s.length;
	  if (imax === 0) {
	    return s;
	  }
	
	  if (imax % 4 !== 0) {
	    throw makeDOMException();
	  }
	
	  pads = 0;
	  if (s.charAt(imax - 1) === PADCHAR) {
	    pads = 1;
	    if (s.charAt(imax - 2) === PADCHAR) {
	      pads = 2;
	    }
	    // either way, we want to ignore this last block
	    imax -= 4;
	  }
	
	  var x = [];
	  for (i = 0; i < imax; i += 4) {
	    b10 = getbyte64(s, i) << 18 | getbyte64(s, i + 1) << 12 | getbyte64(s, i + 2) << 6 | getbyte64(s, i + 3);
	    x.push(String.fromCharCode(b10 >> 16, b10 >> 8 & 0xff, b10 & 0xff));
	  }
	
	  switch (pads) {
	    case 1:
	      b10 = getbyte64(s, i) << 18 | getbyte64(s, i + 1) << 12 | getbyte64(s, i + 2) << 6;
	      x.push(String.fromCharCode(b10 >> 16, b10 >> 8 & 0xff));
	      break;
	    case 2:
	      b10 = getbyte64(s, i) << 18 | getbyte64(s, i + 1) << 12;
	      x.push(String.fromCharCode(b10 >> 16));
	      break;
	  }
	  return x.join('');
	}
	
	function encodeURL(input) {
	  return encodeURIComponent(encode(input).replace(/\+/g, '-').replace(/\//g, '_'));
	}
	
	function decodeURL(input) {
	  return decode(decodeURIComponent(input).replace(/-/g, '+').replace(/_/g, '/'));
	}
	
	exports['default'] = {
	  encode: encode,
	  decode: decode,
	  encodeURL: encodeURL,
	  decodeURL: decodeURL
	};
	module.exports = exports['default'];

/***/ },
/* 19 */
/*!***********************************************!*\
  !*** ./src/utils/query-string-encoder.coffee ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	var Qs;
	
	Qs = __webpack_require__(/*! qs */ 218);
	
	module.exports = {
	  encode: function(data) {
	    return Qs.stringify(data);
	  },
	  decode: function() {
	    return Qs.parse(window.location.search.slice(1));
	  }
	};


/***/ },
/* 20 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/bindCallback.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(/*! ../utility/identity */ 48);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 21 */
/*!******************************************!*\
  !*** ./~/lodash/internal/isArrayLike.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(/*! ./getLength */ 34),
	    isLength = __webpack_require__(/*! ./isLength */ 14);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 22 */
/*!************************************!*\
  !*** ./~/superagent/lib/client.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(/*! emitter */ 223);
	var reduce = __webpack_require__(/*! reduce */ 224);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root = 'undefined' == typeof window
	  ? this
	  : window;
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	function getXHR() {
	  if (root.XMLHttpRequest
	    && ('file:' != root.location.protocol || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	}
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(obj[key]));
	    }
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  this.text = this.req.method !='HEAD' 
	     ? this.xhr.responseText 
	     : null;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  return parse && str && str.length
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status || 1223 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self); 
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	    }
	
	    self.callback(err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Allow for extension
	 */
	
	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new FormData();
	  this._formData.append(name, val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new FormData();
	  this._formData.append(field, file, filename);
	  return this;
	};
	
	/**
	 * Send `data`, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // querystring
	 *       request.get('/search')
	 *         .end(callback)
	 *
	 *       // multiple data "writes"
	 *       request.get('/search')
	 *         .send({ search: 'query' })
	 *         .send({ range: '1..5' })
	 *         .send({ order: 'desc' })
	 *         .end(callback)
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"})
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  if (2 == fn.length) return fn(err, res);
	  if (err) return this.emit('error', err);
	  fn(res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Origin is not allowed by Access-Control-Allow-Origin');
	  err.crossDomain = true;
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	    if (0 == xhr.status) {
	      if (self.aborted) return self.timeoutError();
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  if (xhr.upload) {
	    xhr.upload.onprogress = function(e){
	      e.percent = e.loaded / e.total * 100;
	      self.emit('progress', e);
	    };
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var serialize = request.serialize[this.getHeader('Content-Type')];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  this.emit('request', this);
	  xhr.send(data);
	  return this;
	};
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.del = function(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ },
/* 23 */
/*!*************************************************!*\
  !*** ./src/flux/dispatcher/RemoteDispatcher.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var flux = __webpack_require__(/*! flux */ 136);
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	var RemoteDispatcher = assign(new flux.Dispatcher(), {
	  handleAction: function handleAction(action) {
	    this.dispatch({ action: action });
	  }
	});
	
	module.exports = RemoteDispatcher;

/***/ },
/* 24 */
/*!********************************************!*\
  !*** ./src/flux/stores/RemoteUserStore.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 36).EventEmitter;
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 23);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 17);
	
	var CHANGE_EVENT = 'change';
	
	var state = {
	  user: null
	};
	
	var isSameId = function isSameId(value) {
	  return value === (state.user && state.user.id);
	};
	
	var isUpToDate = function isUpToDate(user) {
	  if (!user && !state.user) {
	    return true;
	  }
	  return user && state.user && user.updated_at === state.user.updated_at;
	};
	
	var RemoteUserStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange(changeEvent) {
	    this.emit(CHANGE_EVENT, changeEvent);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getState: function getState() {
	    return state;
	  },
	  isSameId: isSameId,
	  isUpToDate: isUpToDate,
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	
	    switch (action.actionType) {
	      case RemoteConstants.LOGOUT_USER:
	        state.user = null;
	        if (!action.options.silent === true) {
	          RemoteUserStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_USER:
	        if (!isUpToDate(action.user)) {
	          state.user = action.user;
	          if (!action.options.silent === true) {
	            RemoteUserStore.emitChange(action.actionType);
	          }
	        }
	        break;
	    }
	    return true;
	  })
	
	});
	
	module.exports = RemoteUserStore;

/***/ },
/* 25 */
/*!****************************************!*\
  !*** ./~/lodash/internal/getNative.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(/*! ../lang/isNative */ 209);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 26 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/isIterateeCall.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(/*! ./isArrayLike */ 21),
	    isIndex = __webpack_require__(/*! ./isIndex */ 43),
	    isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 27 */
/*!**********************************************!*\
  !*** ./src/flux/stores/RemoteConfigStore.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 36).EventEmitter;
	var _ = __webpack_require__(/*! ../../utils/lodash */ 1);
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 23);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 17);
	
	var CHANGE_EVENT = 'change';
	
	var state = {};
	
	var RemoteConfigStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange(changeEvent) {
	    this.emit(CHANGE_EVENT, changeEvent);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getAuth: function getAuth(provider) {
	    if (state && state.services && state.services.auth && state.services.auth[provider]) {
	      return state.services.auth[provider];
	    }
	    return undefined;
	  },
	  getHullToken: function getHullToken() {
	    return state.access_token;
	  },
	  getState: function getState() {
	    return state;
	  },
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	
	    switch (action.actionType) {
	      case RemoteConstants.UPDATE_REMOTE_CONFIG:
	        state = action.config;
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_SERVICES:
	        state.services = action.services;
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_USER:
	        state.access_token = action.user.access_token;
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.LOGOUT_USER:
	        delete state.access_token;
	        if (state.services && state.services.auth) {
	          _.map(state.services, function (services, type) {
	            _.map(services, function (service, key) {
	              delete service.credentials;
	              // Since Hull Storage doesnt have the same format as the others :(
	              if (type === 'storage') {
	                delete service.params;
	              }
	            });
	          });
	        }
	        if (!action.options.silent === true) {
	          RemoteConfigStore.emitChange(action.actionType);
	        }
	        break;
	
	    }
	    return true;
	  })
	
	});
	
	module.exports = RemoteConfigStore;

/***/ },
/* 28 */
/*!**********************************!*\
  !*** ./src/utils/cookies.coffee ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var COOKIES_ENABLED, Cookies;
	
	Cookies = __webpack_require__(/*! cookies-js */ 62);
	
	COOKIES_ENABLED = '_ce';
	
	module.exports = {
	  set: Cookies.set,
	  get: Cookies.get,
	  remove: Cookies.expire,
	  enabled: function() {
	    return Cookies._areEnabled();
	  }
	};


/***/ },
/* 29 */
/*!*****************************************!*\
  !*** ./src/utils/load-polyfills.coffee ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var Promise, _, domain, fill, logger, polyfills, scriptLoader, shimHTMLImports, toFill;
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	shimHTMLImports = __webpack_require__(/*! ../polyfills/shadow-css */ 86);
	
	logger = __webpack_require__(/*! ./logger */ 5);
	
	__webpack_require__(/*! ../polyfills/xhr-xdr */ 87);
	
	__webpack_require__(/*! ../utils/console-shim */ 131);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	scriptLoader = __webpack_require__(/*! ./script-loader */ 31);
	
	domain = "hull-polyfills.herokuapp.com";
	
	polyfills = {
	  "WeakMap": function() {
	    return window.WeakMap != null;
	  },
	  "Array.prototype.indexOf": function() {
	    return Array.prototype.indexOf != null;
	  },
	  "Array.prototype.map": function() {
	    return Array.prototype.map != null;
	  },
	  "Array.prototype.reduce": function() {
	    return Array.prototype.reduce != null;
	  },
	  "Array.prototype.some": function() {
	    return Array.prototype.some != null;
	  },
	  "Function.prototype.bind": function() {
	    return Function.prototype.bind != null;
	  },
	  "Object.keys": function() {
	    return Object.keys != null;
	  },
	  "MutationObserver": function() {
	    return window.MutationObserver != null;
	  },
	  "Object.defineProperty": function() {
	    return Object.defineProperty != null;
	  },
	  "URL": function() {
	    var e, error, nativeURL;
	    try {
	      if (window.URL) {
	        nativeURL = new window.URL('http://example.com');
	        if (nativeURL.href != null) {
	          return true;
	        }
	      }
	      return false;
	    } catch (error) {
	      e = error;
	      return false;
	    }
	  },
	  "HTMLImports": function() {
	    var link;
	    link = document.createElement("link");
	    return link['import'] !== void 0;
	  },
	  "Element.prototype.classList": function() {
	    return document.documentElement.classList != null;
	  },
	  "Element.prototype.cloneNode": function() {
	    var test;
	    test = function() {
	      var result;
	      test = document.createElement('input');
	      test.checked = true;
	      result = test.cloneNode();
	      return !!result.checked;
	    };
	    return (this.document != null) && (document.documentElement.cloneNode != null) && test();
	  },
	  "Xdomain": function() {
	    var xhr;
	    xhr = new window.XMLHttpRequest();
	    if (xhr.withCredentials != null) {
	      return true;
	    }
	    if (window.XMLHttpRequest.supportsXDR === true) {
	      return true;
	    }
	    return false;
	  },
	  "Event": function() {
	    var e, error;
	    if (global.Event == null) {
	      return false;
	    }
	    if (typeof global.Event === "function") {
	      return true;
	    }
	    try {
	      new Event("click");
	      return true;
	    } catch (error) {
	      e = error;
	      return false;
	    }
	  }
	};
	
	toFill = _.keys(_.pick(polyfills, function(tst) {
	  return !tst();
	}));
	
	fill = function(config) {
	  return new Promise(function(resolve, reject) {
	    var file, url;
	    if (!toFill.length) {
	      return resolve();
	    }
	    logger.verbose("Polyfilling", toFill.join(','));
	    file = config.debug ? "polyfill.js" : "polyfill.js";
	    url = "//" + domain + "/v1/" + file + "?features=" + (toFill.join(","));
	    return scriptLoader({
	      src: url,
	      document: config.document
	    }).then(function() {
	      shimHTMLImports(config.window);
	      logger.verbose("Polyfilled", toFill.join(','));
	      return true;
	    }).then(resolve, reject);
	  });
	};
	
	module.exports = {
	  fill: fill,
	  domain: domain
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 30 */
/*!********************************!*\
  !*** ./src/utils/raven.coffee ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	var _, pending, script, userContext;
	
	script = __webpack_require__(/*! ./script-loader */ 31);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	pending = [];
	
	userContext = {};
	
	module.exports = {
	  init: function(dsn, context) {
	    if (dsn && !window.Raven) {
	      return script({
	        src: 'https://cdn.ravenjs.com/2.1.1/raven.min.js'
	      }).then(function() {
	        window.Raven.config(dsn, {
	          release: ("0134f444728e2926818126b5f7c1557e85b90aa4"),
	          whitelistUrls: [/hull/]
	        }).install();
	        window.Raven.setExtraContext(context);
	        window.Raven.setUserContext(userContext);
	        return _.map(pending.splice(0), function(e) {
	          return window.Raven.captureException(e.err, e.ctx);
	        });
	      });
	    }
	  },
	  setUserContext: function(ctx) {
	    if (window.Raven && window.Raven.setUserContext) {
	      return window.Raven.setUserContext(ctx);
	    } else {
	      return userContext = ctx;
	    }
	  },
	  captureException: function(err, ctx) {
	    if (window.Raven && window.Raven.captureException) {
	      return window.Raven.captureException(err, ctx);
	    } else {
	      return pending.push({
	        err: err,
	        ctx: ctx
	      });
	    }
	  }
	};


/***/ },
/* 31 */
/*!****************************************!*\
  !*** ./src/utils/script-loader.coffee ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Promise, _, logger;
	
	Promise = __webpack_require__(/*! ./promises */ 3);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	logger = __webpack_require__(/*! ./logger */ 5);
	
	module.exports = function(opts) {
	  var doc, sc;
	  if (opts == null) {
	    opts = {};
	  }
	  doc = opts.document || window.document;
	  sc = document.createElement("script");
	  return new Promise(function(resolve, reject) {
	    var done, errorTimeout, ref;
	    errorTimeout = setTimeout(function() {
	      var error;
	      error = new Error("Error loading " + opts.src + ".\nConnectivity issue?");
	      logger.error(error, error.message, error.stack);
	      return reject(error);
	    }, 60000);
	    if (opts.attributes) {
	      _.map(opts.attributes, function(value, key) {
	        return sc.setAttribute(key, value);
	      });
	    }
	    if (opts.id) {
	      sc.id = opts.id;
	    }
	    sc.src = opts.src;
	    done = false;
	    sc.onload = sc.onreadystatechange = function() {
	      if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
	        clearTimeout(errorTimeout);
	        done = true;
	        resolve(sc);
	        return sc.onload = sc.onreadystatechange = null;
	      }
	    };
	    return (ref = doc.getElementsByTagName('head')[0]) != null ? ref.appendChild(sc) : void 0;
	  });
	};


/***/ },
/* 32 */
/*!****************************************!*\
  !*** ./~/lodash/function/restParam.js ***!
  \****************************************/
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 33 */
/*!******************************************!*\
  !*** ./~/lodash/internal/baseIndexOf.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(/*! ./indexOfNaN */ 204);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 34 */
/*!****************************************!*\
  !*** ./~/lodash/internal/getLength.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(/*! ./baseProperty */ 72);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 35 */
/*!**************************************!*\
  !*** ./~/lodash/lang/isArguments.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(/*! ../internal/isArrayLike */ 21),
	    isObjectLike = __webpack_require__(/*! ../internal/isObjectLike */ 15);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 36 */
/*!********************************************************!*\
  !*** (webpack)/~/node-libs-browser/~/events/events.js ***!
  \********************************************************/
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 37 */
/*!**********************************************!*\
  !*** ./src/flux/stores/RemoteHeaderStore.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 36).EventEmitter;
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 23);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 17);
	var RemoteUserStore = __webpack_require__(/*! ../stores/RemoteUserStore */ 24);
	
	var CHANGE_EVENT = 'change';
	var ACCESS_TOKEN_HEADER = 'Hull-Access-Token';
	var USER_ID_HEADER = 'Hull-User-Id';
	var APP_ID_HEADER = 'Hull-App-Id';
	
	var state = {
	  headers: {
	    'Accept': 'application/json',
	    'Content-Type': 'application/json'
	  }
	};
	function getHeader(header) {
	  return state.headers[header];
	}
	function setHeader(header, value) {
	  state.headers[header] = value;
	}
	function destroyHeader(header) {
	  delete state.headers[header];
	}
	
	var RemoteHeaderStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange(change) {
	    this.emit(CHANGE_EVENT, change);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getState: function getState() {
	    return state.headers;
	  },
	  getHeader: function getHeader(h) {
	    return state.headers[h];
	  },
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	    switch (action.actionType) {
	
	      case RemoteConstants.UPDATE_REMOTE_CONFIG:
	        if (action) {
	          if (action.config && action.config.appId) {
	            setHeader(APP_ID_HEADER, action.config.appId);
	          }
	        }
	        break;
	
	      case RemoteConstants.UPDATE_SETTINGS:
	        if (action && action.services && action.services.auth && action.services.auth.hull && action.services.auth.hull.credentials) {
	          setHeader(ACCESS_TOKEN_HEADER, action.services.auth.hull.credentials.access_token);
	        }
	        break;
	
	      case RemoteConstants.UPDATE_USER:
	        if (action.user.id != getHeader(USER_ID_HEADER) || action.user.access_token != getHeader(ACCESS_TOKEN_HEADER)) {
	          if (action.user && action.user.access_token) {
	            setHeader(USER_ID_HEADER, action.user.id);
	            setHeader(ACCESS_TOKEN_HEADER, action.user.access_token);
	          } else {
	            destroyHeader(ACCESS_TOKEN_HEADER);
	            destroyHeader(USER_ID_HEADER);
	          }
	          RemoteHeaderStore.emitChange(action.actionType);
	        }
	        break;
	
	      case RemoteConstants.LOGOUT_USER:
	        destroyHeader(ACCESS_TOKEN_HEADER);
	        destroyHeader(USER_ID_HEADER);
	        if (!action.options.silent === true) {
	          RemoteHeaderStore.emitChange(action.actionType);
	        }
	        break;
	
	    }
	    return true;
	  })
	
	});
	
	module.exports = RemoteHeaderStore;

/***/ },
/* 38 */
/*!******************************************!*\
  !*** ./src/client/embeds/sandbox.coffee ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var Sandbox, StyleObserver, _, assign, clone, findUrl, getIframe, setStyle, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  slice = [].slice;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	getIframe = __webpack_require__(/*! ../../utils/get-iframe */ 41);
	
	findUrl = __webpack_require__(/*! ../../utils/find-url */ 40);
	
	setStyle = __webpack_require__(/*! ../../utils/set-style */ 60);
	
	clone = __webpack_require__(/*! ../../utils/clone */ 9);
	
	StyleObserver = __webpack_require__(/*! ../style/observer */ 109);
	
	throwErr = __webpack_require__(/*! ../../utils/throw */ 12);
	
	Sandbox = (function() {
	  function Sandbox(deployment, scopeStyle) {
	    this.destroy = bind(this.destroy, this);
	    this.getDocument = bind(this.getDocument, this);
	    this.getObserver = bind(this.getObserver, this);
	    this.getShipClassName = bind(this.getShipClassName, this);
	    this.share = bind(this.share, this);
	    this.track = bind(this.track, this);
	    this.ship = deployment.ship;
	    this.shipClassName = ".ship-" + this.ship.id;
	    this.scopeStyle = scopeStyle;
	    this.deployment = deployment;
	    this.callbacks = [];
	    this._scopes = [];
	    this.hull = assign({}, window.Hull, {
	      getDocument: this.getDocument,
	      getShipClassName: this.getShipClassName,
	      track: this.track,
	      share: this.share
	    });
	  }
	
	
	  /**
	   * Performs a track that has the `ship_id` field set correctly
	   * @param  {[type]} name       [description]
	   * @param  {[type]} event={} [description]
	   * @return {[type]}            [description]
	   */
	
	  Sandbox.prototype.track = function(name, event) {
	    if (event == null) {
	      event = {};
	    }
	    event.ship_id = this.ship.id;
	    return Hull.track(name, event);
	  };
	
	  Sandbox.prototype.share = function(opts, event) {
	    if (opts == null) {
	      opts = {};
	    }
	    if (event == null) {
	      event = {};
	    }
	    opts.params = assign({}, opts.params, {
	      ship_id: this.ship.id
	    });
	    return Hull.share(opts, event);
	  };
	
	  Sandbox.prototype.getShipClassName = function() {
	    return this.shipClassName;
	  };
	
	  Sandbox.prototype.getObserver = function() {
	    this.observer || (this.observer = new StyleObserver(this.shipClassName));
	    return this.observer;
	  };
	
	  Sandbox.prototype.observe = function(target) {
	    if (!this.scopeStyle) {
	      return;
	    }
	    return this.getObserver().observe(target);
	  };
	
	  Sandbox.prototype.process = function(target) {
	    if (!(this.scopeStyle && target)) {
	      return;
	    }
	    return this.getObserver().process(target);
	  };
	
	  Sandbox.prototype.unobserve = function(target) {
	    if (!this.scopeStyle) {
	      return;
	    }
	    return this.getObserver().unobserve(target);
	  };
	
	  Sandbox.prototype.scope = function(insertion) {
	    var doc, hull, iframe, mainShare, sandbox, w;
	    iframe = insertion.iframe;
	    if (!(iframe != null ? iframe.contentDocument : void 0)) {
	      return this;
	    }
	    sandbox = Object.create(this);
	    this._scopes.push(sandbox);
	    doc = iframe.contentDocument;
	    sandbox.autoSizeInterval = null;
	    mainShare = this.share;
	    hull = assign({}, this.hull, {
	      onEmbed: (function(_this) {
	        return function() {
	          var args, callback;
	          args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	          while (args.length > 0 && !_.isFunction(callback)) {
	            callback = args.shift();
	          }
	          if (!callback) {
	            return;
	          }
	          insertion.callbacks.push(callback);
	          return _this.deployment.onEmbed();
	        };
	      })(this),
	      getDocument: (function(_this) {
	        return function() {
	          return doc;
	        };
	      })(this),
	      share: function(opts, event) {
	        if (event == null) {
	          event = {};
	        }
	        event = assign(event, {
	          target: iframe
	        });
	        return mainShare(opts, event);
	      },
	      findUrl: function() {
	        return findUrl(iframe);
	      },
	      setSize: (function(_this) {
	        return function(size) {
	          var style;
	          if (size == null) {
	            size = {};
	          }
	          style = assign({}, size);
	          if (size.width || size.height) {
	            if (size.width != null) {
	              style.width = size.width;
	            }
	            if (size.height != null) {
	              style.height = size.height;
	            }
	            setStyle.style(iframe, style);
	          } else {
	            setStyle.autoSize(iframe);
	          }
	          return true;
	        };
	      })(this),
	      setStyle: function(style) {
	        if (style == null) {
	          style = {};
	        }
	        setStyle.style(iframe, style);
	        return true;
	      },
	
	      /**
	       * autoSize method for sandboxed instances
	       * @param  {Boolean|Int} interval a refresh interval or 'false'.
	       *                                Interval : Autosize every xx milliseconds.
	       *                                False    : Turns off autoUpdating immediately.
	       *                                undefined: updates once, stops auto updating
	       * @return {Boolean} true to let ships detect if the method has an effect.
	       */
	      autoSize: (function(_this) {
	        return function(interval) {
	          if (!isNaN(parseFloat(interval))) {
	            setInterval(function() {
	              return sandbox.hull.autoSize();
	            }, interval);
	          } else {
	            clearInterval(sandbox.autoSizeInterval);
	          }
	          if (interval !== false) {
	            setStyle.autoSize(iframe);
	          }
	          return true;
	        };
	      })(this)
	    });
	    sandbox.hull = hull;
	    sandbox.hull.autoSize(300);
	    w = getIframe.window(iframe);
	    w.Hull = sandbox.hull;
	    return sandbox;
	  };
	
	  Sandbox.prototype.setDocument = function(doc) {
	    if (doc == null) {
	      return;
	    }
	    this._document = doc;
	    this.observe(doc);
	    return this.process(this._document);
	  };
	
	  Sandbox.prototype.getDocument = function() {
	    return this._document;
	  };
	
	
	  /**
	   * Adds an element to the array of elements owned by the sandbox.
	   * Monitors it for Style Tags so they can be autoprefixed
	   * @param {Node} element DOM Node
	   */
	
	  Sandbox.prototype.addElement = function(element) {
	    if (element) {
	      return this.observe(element);
	    }
	  };
	
	  Sandbox.prototype.removeElement = function(element) {
	    if (element) {
	      return this.unobserve(element);
	    }
	  };
	
	  Sandbox.prototype.get = function() {
	    return this.hull;
	  };
	
	  Sandbox.prototype.destroy = function() {
	    var i, len, ref, scope;
	    ref = this._scopes;
	    for (i = 0, len = ref.length; i < len; i++) {
	      scope = ref[i];
	      scope.hull.autoSize(false);
	    }
	    this._scopes = [];
	    return this.getObserver().destroy();
	  };
	
	  return Sandbox;
	
	})();
	
	module.exports = Sandbox;


/***/ },
/* 39 */
/*!**************************************************!*\
  !*** ./src/client/embeds/strategies/base.coffee ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseDeploymentStrategy, Import, Promise, Sandbox, _, logger, setStyle,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Promise = __webpack_require__(/*! ../../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../../utils/lodash */ 1);
	
	setStyle = __webpack_require__(/*! ../../../utils/set-style */ 60);
	
	logger = __webpack_require__(/*! ../../../utils/logger */ 5);
	
	Import = __webpack_require__(/*! ../import */ 100);
	
	Sandbox = __webpack_require__(/*! ../sandbox */ 38);
	
	BaseDeploymentStrategy = (function() {
	  BaseDeploymentStrategy.prototype.scopeStyles = false;
	
	  BaseDeploymentStrategy.prototype.ignoredTags = ['#comment', 'SCRIPT'];
	
	  BaseDeploymentStrategy.prototype.headTags = ['LINK', 'STYLE'];
	
	  function BaseDeploymentStrategy(deployment) {
	    this.destroy = bind(this.destroy, this);
	    this.embedImport = bind(this.embedImport, this);
	    this.setupSandbox = bind(this.setupSandbox, this);
	    this.deployment = deployment;
	    this.sandbox = new Sandbox(deployment, this.scopeStyles);
	    this.ready = {};
	    this.ready.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this.ready.resolve = resolve;
	        return _this.ready.reject = reject;
	      };
	    })(this));
	    this.insertions = [];
	  }
	
	  BaseDeploymentStrategy.prototype.addInsertion = function() {};
	
	  BaseDeploymentStrategy.prototype.embed = function() {};
	
	  BaseDeploymentStrategy.prototype.onEmbed = function() {};
	
	  BaseDeploymentStrategy.prototype.addShipClasses = function(el) {
	    el.classList.add("ship-" + this.deployment.ship.id, "ship-deployment-" + this.deployment.id);
	    el.setAttribute('data-hull-deployment', this.deployment.id);
	    return el.setAttribute('data-hull-ship', this.deployment.ship.id);
	  };
	
	  BaseDeploymentStrategy.prototype.setupSandbox = function(doc) {
	    return this.sandbox.setDocument(doc);
	  };
	
	
	  /**
	   * Inserts the content of a HTML import into a given dom node.
	   * @param  {Node} doc   Import Document Element
	   * @return {Node}       An Element containing a cloned instance of the Import
	   */
	
	  BaseDeploymentStrategy.prototype.cloneImport = function(doc, container) {
	    var el, err, head, hull_in_ship, msg;
	    if (container == null) {
	      container = document;
	    }
	    el = document.createElement('div');
	    hull_in_ship = doc.getElementById('hull-js-sdk');
	    if (hull_in_ship != null) {
	      msg = "It seems the ship \"" + this.deployment.ship.name + "\" is trying to load " + this.deployment.ship.index + " that contains a copy of Hull.js.\nThis can't happen. Skipping ship.";
	      err = new Error(msg);
	      logger.error(err.message);
	      return el;
	    }
	    head = container.getElementsByTagName('head')[0];
	    this.parseChildren({
	      imported: doc.body,
	      el: el,
	      ignore: this.ignoredTags,
	      move: this.headTags,
	      head: head
	    });
	    return el;
	  };
	
	
	  /**
	   * shuffles DOM elements from an Import, moves them or copy them to the right place
	   * @param  {[type]} opts={} [description]
	   * @return {[type]}           [description]
	   */
	
	  BaseDeploymentStrategy.prototype.parseChildren = function(opts) {
	    var el, head, ignore, imported, move;
	    if (opts == null) {
	      opts = {};
	    }
	    imported = opts.imported, el = opts.el, ignore = opts.ignore, head = opts.head, move = opts.move;
	    if (!imported.hasChildNodes()) {
	      return true;
	    }
	    return _.map(imported.childNodes, (function(_this) {
	      return function(child) {
	        var nodeName;
	        if (child) {
	          nodeName = child.nodeName;
	          if (!_.contains(ignore, nodeName)) {
	            if (_.contains(move, nodeName)) {
	              child.parentNode.removeChild(child);
	              return head.appendChild(child);
	            } else {
	              return el.appendChild(child.cloneNode(true));
	            }
	          }
	        }
	      };
	    })(this));
	  };
	
	
	  /**
	   * Insert an element at the right position relative to a target.
	   * @param  {Node} el     The element to insert
	   * @param  {Node} target The target where to insert the content
	   * @return {Node}        el
	   */
	
	  BaseDeploymentStrategy.prototype.insert = function(el, target) {
	    this.addShipClasses(el);
	    setStyle.style(el, {
	      width: this.deployment.settings._width || '100%',
	      height: this.deployment.settings.height
	    });
	    switch (this.deployment.settings._placement) {
	      case 'before':
	        target.parentNode.insertBefore(el, target);
	        break;
	      case 'after':
	        target.parentNode.insertBefore(el, target.nextSibling);
	        break;
	      case 'top':
	        target.insertBefore(el, target.firstChild);
	        break;
	      case 'replace':
	        if (target.nodeName === 'IMG') {
	          target.parentNode.replaceChild(el, target);
	        } else {
	          while (target.firstChild) {
	            target.removeChild(target.firstChild);
	          }
	          target.appendChild(el);
	        }
	        break;
	      default:
	        target.appendChild(el);
	    }
	    return el;
	  };
	
	
	  /**
	   * Embeds an Import into a container (iframe or main window)
	   * @param  {Node | undefined} container Where to load the HTML Import. Window or empty iframe
	   * @return {promise}          A promise resolved onLoad with the container, the newly created element
	   */
	
	  BaseDeploymentStrategy.prototype.embedImport = function(container) {
	    var imprt;
	    imprt = new Import({
	      shipId: this.deployment.ship.id,
	      href: this.deployment.ship.index,
	      container: container,
	      scoped: this.scopeStyles
	    });
	    imprt.when.loaded.then(this.ready.resolve);
	    return imprt;
	  };
	
	  BaseDeploymentStrategy.prototype.destroy = function() {
	    _.map(this.insertions, function(insertion) {
	      var ref, ref1;
	      return (ref = insertion.el) != null ? (ref1 = ref.parentNode) != null ? ref1.removeChild(insertion.el) : void 0 : void 0;
	    });
	    return this.insertions = {};
	  };
	
	  return BaseDeploymentStrategy;
	
	})();
	
	module.exports = BaseDeploymentStrategy;


/***/ },
/* 40 */
/*!***********************************!*\
  !*** ./src/utils/find-url.coffee ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var _, domWalker, getDOMUrl, getOGUrl, getPageUrl;
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	domWalker = __webpack_require__(/*! ./dom-walker */ 57);
	
	getDOMUrl = function(sourceNode) {
	  var body, link, matchingNode, node;
	  if (!domWalker.isNode(sourceNode)) {
	    return;
	  }
	  body = document.body;
	  node = sourceNode;
	  while (node && node !== body) {
	    link = domWalker.getLinkValue(node);
	    if (!link) {
	      matchingNode = _.find(domWalker.getSiblings(node), domWalker.getLinkValue);
	      link = domWalker.getLinkValue(matchingNode);
	    }
	    if (link != null) {
	      return link;
	    }
	    node = node.parentNode;
	  }
	};
	
	getPageUrl = function() {
	  return window.location.href;
	};
	
	getOGUrl = function() {
	  return domWalker.getMetaValue('og:url');
	};
	
	module.exports = function(node) {
	  var u;
	  u = getDOMUrl(node) || getOGUrl() || getPageUrl();
	  return u.replace(/[#\/]*$/, '');
	};


/***/ },
/* 41 */
/*!*************************************!*\
  !*** ./src/utils/get-iframe.coffee ***!
  \*************************************/
/***/ function(module, exports) {

	var getDocument, getWindow;
	
	getDocument = function(iframe) {
	  var doc, e, error, error1;
	  try {
	    doc = iframe.contentDocument;
	  } catch (error) {
	    e = error;
	    try {
	      doc = iframe.document;
	    } catch (error1) {
	      e = error1;
	    }
	  }
	  return doc;
	};
	
	getWindow = function(iframe) {
	  var doc, e, error, error1, error2, error3, w;
	  try {
	    w = iframe.contentWindow;
	  } catch (error) {
	    e = error;
	    try {
	      w = iframe.window;
	    } catch (error1) {
	      e = error1;
	    }
	  }
	  if (w != null) {
	    return w;
	  }
	  doc = getDocument(iframe);
	  if (doc == null) {
	    return void 0;
	  }
	  try {
	    w = doc.defaultView;
	  } catch (error2) {
	    e = error2;
	    try {
	      w = doc.parentWindow;
	    } catch (error3) {
	      e = error3;
	    }
	  }
	  if (w != null) {
	    return w;
	  }
	};
	
	module.exports = {
	  window: getWindow,
	  document: getDocument
	};


/***/ },
/* 42 */
/*!******************************************!*\
  !*** ./~/lodash/internal/baseIsEqual.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(/*! ./baseIsEqualDeep */ 177),
	    isObject = __webpack_require__(/*! ../lang/isObject */ 7),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 15);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 43 */
/*!**************************************!*\
  !*** ./~/lodash/internal/isIndex.js ***!
  \**************************************/
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 44 */
/*!*************************************!*\
  !*** ./~/lodash/lang/isFunction.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./isObject */ 7);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 45 */
/*!***********************************!*\
  !*** ./~/lodash/lang/isString.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(/*! ../internal/isObjectLike */ 15);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 46 */
/*!***********************************!*\
  !*** ./~/lodash/object/keysIn.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(/*! ../lang/isArguments */ 35),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isIndex = __webpack_require__(/*! ../internal/isIndex */ 43),
	    isLength = __webpack_require__(/*! ../internal/isLength */ 14),
	    isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 47 */
/*!***********************************!*\
  !*** ./~/lodash/object/values.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(/*! ../internal/baseValues */ 188),
	    keys = __webpack_require__(/*! ./keys */ 16);
	
	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 48 */
/*!**************************************!*\
  !*** ./~/lodash/utility/identity.js ***!
  \**************************************/
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 49 */
/*!*****************************************************************!*\
  !*** (webpack)/~/node-libs-browser/~/timers-browserify/main.js ***!
  \*****************************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(/*! process/browser.js */ 82).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! (webpack)/~/node-libs-browser/~/timers-browserify/main.js */ 49).setImmediate, __webpack_require__(/*! (webpack)/~/node-libs-browser/~/timers-browserify/main.js */ 49).clearImmediate))

/***/ },
/* 50 */
/*!*******************************************!*\
  !*** ./src/flux/actions/RemoteActions.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 23);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 17);
	var RemoteUserStore = __webpack_require__(/*! ../stores/RemoteUserStore */ 24);
	
	var RemoteSettingsActions = {
	  updateClientConfig: function updateClientConfig(config) {
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_CLIENT_CONFIG,
	      config: config
	    });
	  },
	  updateRemoteConfig: function updateRemoteConfig(config) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_REMOTE_CONFIG,
	      config: config,
	      options: options
	    });
	  },
	  updateServices: function updateServices(services) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_SERVICES,
	      services: services,
	      options: options
	    });
	  },
	  logoutUser: function logoutUser() {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.LOGOUT_USER,
	      options: options
	    });
	  },
	  updateUser: function updateUser(user) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    RemoteDispatcher.handleAction({
	      actionType: RemoteConstants.UPDATE_USER,
	      user: user,
	      options: options
	    });
	  },
	  updateUserIfMe: function updateUserIfMe(data) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // We don't know if it's a Me object. for now it's just a bundle of data from the API.
	    if (data.body && RemoteUserStore.isSameId(data.body.id)) {
	      RemoteDispatcher.handleAction({
	        actionType: RemoteConstants.UPDATE_USER,
	        user: data.body,
	        options: options
	      });
	    }
	  }
	};
	
	module.exports = RemoteSettingsActions;

/***/ },
/* 51 */
/*!***************************************!*\
  !*** ./src/remote/wrapped-request.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _utilsLodash = __webpack_require__(/*! ../utils/lodash */ 1);
	
	var _utilsLodash2 = _interopRequireDefault(_utilsLodash);
	
	var _polyfillsAssign = __webpack_require__(/*! ../polyfills/assign */ 2);
	
	var _polyfillsAssign2 = _interopRequireDefault(_polyfillsAssign);
	
	var wrappedRequest = function wrappedRequest(service, gateway) {
	  var middlewares = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	  return function query(request, callback, errback) {
	    if (!callback) {
	      callback = function () {};
	    }
	    if (!errback) {
	      errback = function () {};
	    }
	
	    var path = request.path;
	
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    path = service.name !== "hull" ? "services/#{service.path}/#{path}" : path;
	
	    if (service.name !== "hull") {
	      request.params = request.method.toLowerCase() === "delete" ? JSON.stringify(request.params || {}) : request.params;
	    }
	
	    var req = (0, _polyfillsAssign2["default"])({}, request, { path: path });
	    var handle = gateway.handle(req);
	    _utilsLodash2["default"].each(middlewares, function (m) {
	      handle = handle.then(m, m);
	    });
	
	    handle = handle.then(function (response) {
	      response = (0, _polyfillsAssign2["default"])({}, response, { provider: service.name });
	
	      if (response.status >= 200 && response.status < 300) {
	        return response;
	      } else {
	        throw response.body || response;
	      }
	    });
	
	    handle.then(callback, errback);
	
	    return handle;
	  };
	};
	
	exports["default"] = wrappedRequest;
	module.exports = exports["default"];

/***/ },
/* 52 */
/*!*******************************!*\
  !*** ./src/utils/domready.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2012 - License MIT
	  */
	'use strict';
	
	!(function (name, definition) {
	  if (true) module.exports = definition();else if (typeof define == 'function' && typeof define.amd == 'object') define(definition);else this[name] = definition();
	})('domready', function (ready, scope) {
	
	  var fns = [],
	      fn,
	      f = false,
	      doc = scope || document,
	      testEl = doc.documentElement,
	      hack = testEl.doScroll,
	      domContentLoaded = 'DOMContentLoaded',
	      addEventListener = 'addEventListener',
	      onreadystatechange = 'onreadystatechange',
	      readyState = 'readyState',
	      loadedRgx = hack ? /^loaded|^c/ : /^loaded|^i|^c/,
	      loaded = loadedRgx.test(doc[readyState]);
	
	  function flush(f) {
	    loaded = 1;
	    while (f = fns.shift()) f();
	  }
	
	  doc[addEventListener] && doc[addEventListener](domContentLoaded, fn = function () {
	    doc.removeEventListener(domContentLoaded, fn, f);
	    flush();
	  }, f);
	
	  hack && doc.attachEvent(onreadystatechange, fn = function () {
	    if (/^c/.test(doc[readyState])) {
	      doc.detachEvent(onreadystatechange, fn);
	      flush();
	    }
	  });
	
	  return ready = hack ? function (fn) {
	    self != top ? loaded ? fn() : fns.push(fn) : (function () {
	      try {
	        testEl.doScroll('left');
	      } catch (e) {
	        return setTimeout(function () {
	          ready(fn);
	        }, 50);
	      }
	      fn();
	    })();
	  } : function (fn) {
	    loaded ? fn() : fns.push(fn);
	  };
	});

/***/ },
/* 53 */
/*!**************************!*\
  !*** ./src/utils/xdm.js ***!
  \**************************/
/***/ function(module, exports) {

	/*!
	 * xdm.js – Nicolas Gallagher – MIT License
	 * easyXDM – Copyright(c) 2009-2011, Øyvind Sean Kinsey, oyvind@kinsey.no – MIT License
	 */
	
	// stores namespace under which the 'xdm' object is stored on the page
	// (empty if object is global)
	'use strict';
	
	var namespace = "";
	var xdm = {};
	// map over global xdm in case of overwrite
	var _xdm = window.xdm;
	var IFRAME_PREFIX = 'xdm_';
	
	var iframe = document.createElement('IFRAME');
	// randomize the initial id in case multiple closures are loaded
	var channelId = Math.floor(Math.random() * 10000);
	var emptyFn = Function.prototype;
	// returns groups for protocol (2), domain (3) and port (4)
	var reURI = /^((http.?:)\/\/([^:\/\s]+)(:\d+)*)/;
	// matches a foo/../ expression
	var reParent = /[\-\w]+\/\.\.\//;
	// matches `//` anywhere but in the protocol
	var reDoubleSlash = /([^:])\/\//g;
	
	/**
	 * Helper for adding and removing cross-browser event listeners
	 */
	
	var addEvent = (function () {
	    if (window.addEventListener) {
	        return function (target, type, listener) {
	            target.addEventListener(type, listener, false);
	        };
	    }
	    return function (target, type, listener) {
	        target.attachEvent('on' + type, listener);
	    };
	})();
	
	var removeEvent = (function () {
	    if (window.removeEventListener) {
	        return function (target, type, listener) {
	            target.removeEventListener(type, listener, false);
	        };
	    }
	    return function (target, type, listener) {
	        target.detachEvent('on' + type, listener);
	    };
	})();
	
	/**
	 * Build the query object from location.hash
	 */
	
	var query = (function (input) {
	    input = input.substring(1, input.length).split('&');
	    var data = {},
	        pair,
	        i = input.length;
	    while (i--) {
	        pair = input[i].split('=');
	        data[pair[0]] = decodeURIComponent(pair[1]);
	    }
	    return data;
	})(location.hash);
	
	// -------------------------------------------------------------------------
	
	/**
	 * xdm object setup
	 */
	
	xdm.version = "1.0.1";
	xdm.stack = {};
	xdm.query = query;
	xdm.checkAcl = checkAcl;
	
	/**
	 * Removes the `xdm` variable from the global scope. It also returns control
	 * of the `xdm` variable to the code that used it before.
	 *
	 * @param {String} ns A string representation of an object that will hold
	 *   an instance of xdm.
	 * @return {xdm}
	 */
	
	xdm.noConflict = function (ns) {
	    window.xdm = _xdm;
	    namespace = ns;
	    if (namespace) {
	        IFRAME_PREFIX = 'xdm_' + namespace.replace('.', '_') + '_';
	    }
	    return xdm;
	};
	
	// -------------------------------------------------------------------------
	
	/**
	 * Helper for testing if an object is an array
	 *
	 * @param {Object} obj The object to test
	 * @return {Boolean}
	 */
	
	function isArray(obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]';
	}
	
	/**
	 * Helper for testing if a variable/property is undefined
	 *
	 * @param {Object} variable The variable to test
	 * @return {Boolean}
	 */
	
	function undef(variable) {
	    return typeof variable === 'undefined';
	}
	
	/**
	 * Returns a string containing the schema, domain and if present the port
	 *
	 * @param {String} url The url to extract the location from
	 * @return {String} The location part of the url
	 */
	
	function getLocation(url) {
	    if (!url) {
	        throw new Error('url is undefined or empty');
	    }
	    var m = url.toLowerCase().match(reURI);
	    if (m) {
	        var proto = m[2],
	            domain = m[3],
	            port = m[4] || '';
	        if (proto === 'http:' && port === ':80' || proto === 'https:' && port === ':443') {
	            port = '';
	        }
	        return proto + '//' + domain + port;
	    }
	
	    return url;
	}
	
	/**
	 * Resolves a relative url into an absolute one.
	 *
	 * @param {String} url The path to resolve.
	 * @return {String} The resolved url.
	 */
	function resolveUrl(url) {
	    if (!url) {
	        throw new Error('url is undefined or empty');
	    }
	
	    // replace all `//` except the one in proto with `/`
	    url = url.replace(reDoubleSlash, '$1/');
	
	    // if the url is a valid url we do nothing
	    if (!url.match(/^(http||https):\/\//)) {
	        // If this is a relative path
	        var path = url.substring(0, 1) === '/' ? '' : location.pathname;
	        if (path.substring(path.length - 1) !== '/') {
	            path = path.substring(0, path.lastIndexOf('/') + 1);
	        }
	
	        url = location.protocol + '//' + location.host + path + url;
	    }
	
	    // reduce all 'xyz/../' to just ''
	    while (reParent.test(url)) {
	        url = url.replace(reParent, '');
	    }
	
	    return url;
	}
	
	/**
	 * Applies properties from the source object to the target object.
	 *
	 * @param {Object} destination The target of the properties.
	 * @param {Object} source The source of the properties.
	 * @param {Boolean} noOverwrite Set to True to only set non-existing properties.
	 */
	
	function merge(destination, source, noOverwrite) {
	    var member;
	    for (var prop in source) {
	        if (source.hasOwnProperty(prop)) {
	            if (prop in destination) {
	                member = source[prop];
	                if (typeof member === 'object') {
	                    merge(destination[prop], member, noOverwrite);
	                } else if (!noOverwrite) {
	                    destination[prop] = source[prop];
	                }
	            } else {
	                destination[prop] = source[prop];
	            }
	        }
	    }
	    return destination;
	}
	
	/**
	 * GUEST ONLY
	 * Check whether a host domain is allowed using an Access Control List.
	 * The ACL can contain `*` and `?` as wildcards, or can be regular expressions.
	 * If regular expressions they need to begin with `^` and end with `$`.
	 *
	 * @param {Array/String} acl The list of allowed domains
	 * @param {String} domain The domain to test.
	 * @return {Boolean} True if the domain is allowed, false if not.
	 */
	
	function checkAcl(acl, domain) {
	    // normalize into an array
	    if (typeof acl === 'string') {
	        acl = [acl];
	    }
	    var re;
	    var i = acl.length;
	    while (i--) {
	        re = acl[i];
	        re = new RegExp(re.substr(0, 1) === '^' ? re : '^' + re.replace(/(\*)/g, '.$1').replace(/\?/g, '.') + '$');
	        if (re.test(domain)) {
	            return true;
	        }
	    }
	    return false;
	}
	
	/**
	 * HOST ONLY
	 * Appends the parameters to the given url.
	 * The base url can contain existing query parameters.
	 *
	 * @param {String} url The base url.
	 * @param {Object} parameters The parameters to add.
	 * @return {String} A new valid url with the parameters appended.
	 */
	
	function appendQueryParameters(url, parameters) {
	    if (!parameters) {
	        throw new Error('parameters is undefined or null');
	    }
	
	    var indexOf = url.indexOf('#');
	    var q = [];
	    for (var key in parameters) {
	        if (parameters.hasOwnProperty(key)) {
	            q.push(key + '=' + encodeURIComponent(parameters[key]));
	        }
	    }
	
	    return url + (indexOf === -1 ? '#' : '&') + q.join('&');
	}
	
	/**
	 * HOST ONLY
	 * Creates an iframe and appends it to the DOM.
	 *
	 * @param {Object} config This iframe configuration object
	 * @return {Element} The frames DOM Element
	 */
	
	function createFrame(config) {
	    var frame = iframe.cloneNode(false);
	
	    // merge the defaults with the configuration properties
	    merge(config.props, {
	        frameBorder: 0,
	        allowTransparency: true,
	        scrolling: 'no',
	        width: '100%',
	        src: appendQueryParameters(config.remote, {
	            xdm_e: getLocation(location.href),
	            xdm_c: config.channel,
	            xdm_p: 1
	        }),
	        name: IFRAME_PREFIX + config.channel + '_provider',
	        style: {
	            margin: 0,
	            padding: 0,
	            border: 0
	        }
	    });
	
	    frame.id = config.props.name;
	    delete config.props.name;
	
	    // if no container, then we cannot proceed
	    if (!config.container) {
	        throw new Error('xdm.Rpc() configuration object missing a DOM "container" property');
	    }
	
	    // merge config properties into the frame
	    merge(frame, config.props);
	
	    config.container.appendChild(frame);
	
	    if (config.onLoad) {
	        addEvent(frame, 'load', config.onLoad);
	    }
	
	    // if we're injecting HTML directly into the iframe
	    if (config.html) {
	        frame.contentWindow.document.open();
	        frame.contentWindow.document.write(config.html);
	        frame.contentWindow.document.close();
	    }
	
	    // pass a reference to the frame around so that it can be exposed on the
	    // rpc object
	    config.iframe = frame;
	
	    return frame;
	}
	
	/**
	 * Prepares an array of stack-elements suitable for the current configuration
	 *
	 * @param {Object} config The Transports configuration.
	 * @return {Array} An array of stack-elements with the TransportElement at index 0.
	 */
	
	function prepareTransportStack(config) {
	    var stackEls;
	
	    config.isHost = config.isHost || undef(query.xdm_p);
	    config.props = config.props || {};
	
	    if (!config.isHost) {
	        config.channel = query.xdm_c.replace(/["'<>\\]/g, '');
	        config.remote = query.xdm_e.replace(/["'<>\\]/g, '');
	
	        if (config.acl && !checkAcl(config.acl, config.remote)) {
	            throw new Error('Access denied for ' + config.remote);
	        }
	    } else {
	        config.remote = resolveUrl(config.remote);
	        config.channel = config.channel || 'default' + channelId++;
	    }
	
	    stackEls = [new xdm.stack.PostMessageTransport(config)];
	    // this behavior is responsible for buffering outgoing messages
	    stackEls.push(new xdm.stack.QueueBehavior(true));
	
	    return stackEls;
	}
	
	/**
	 * Chains all the separate stack elements into a single usable stack.
	 * If an element is missing a necessary method then it will have a pass-through method applied.
	 *
	 * @param {Array} stackElements An array of stack elements to be linked.
	 * @return {xdm.stack.StackElement} The last element in the chain.
	 */
	
	function chainStack(stackElements) {
	    var stackEl;
	    var i;
	    var len = stackElements.length;
	
	    var defaults = {
	        incoming: function incoming(message, origin) {
	            this.up.incoming(message, origin);
	        },
	        outgoing: function outgoing(message, recipient) {
	            this.down.outgoing(message, recipient);
	        },
	        callback: function callback(success) {
	            this.up.callback(success);
	        },
	        init: function init() {
	            this.down.init();
	        },
	        destroy: function destroy() {
	            this.down.destroy();
	        }
	    };
	
	    for (i = 0; i < len; i++) {
	        stackEl = stackElements[i];
	        merge(stackEl, defaults, true);
	
	        if (i !== 0) {
	            stackEl.down = stackElements[i - 1];
	        }
	
	        if (i !== len - 1) {
	            stackEl.up = stackElements[i + 1];
	        }
	    }
	
	    return stackEl;
	}
	
	/**
	 * This will remove a stackelement from its stack while leaving the stack functional.
	 *
	 * @param {Object} element The elment to remove from the stack.
	 */
	
	function removeFromStack(element) {
	    element.up.down = element.down;
	    element.down.up = element.up;
	    element.up = element.down = null;
	}
	
	/**
	 * xdm.Rpc
	 *
	 * Creates a proxy object that can be used to call methods implemented on the
	 * remote end of the channel, and also to provide the implementation of methods
	 * to be called from the remote end.
	 *
	 * The instantiated object will have methods matching those specified in
	 * `config.remote`.
	 *
	 * @param {Object} config The underlying transport configuration.
	 *   remote: The remote window's location
	 *   html: HTML to inject into a sourceless iframe
	 *   container: The iframe's container DOM element
	 *   props: Object of the properties that should be set on the frame
	 *   acl: An array of domains to add to the Access Control List
	 *   onReady: A function to call when communication has been established
	 *   onLoad: A function to called – with the iframe's `contentWindow` as
	 *     the argument – when the frame is fully loaded
	 * @param {Object} jsonRpcConfig The description of the interface to implement.
	 */
	
	xdm.Rpc = function (config, jsonRpcConfig) {
	    var member;
	
	    // expand shorthand notation
	    if (jsonRpcConfig.local) {
	        for (var method in jsonRpcConfig.local) {
	            if (jsonRpcConfig.local.hasOwnProperty(method)) {
	                member = jsonRpcConfig.local[method];
	                if (typeof member === 'function') {
	                    jsonRpcConfig.local[method] = {
	                        method: member
	                    };
	                }
	            }
	        }
	    }
	
	    // create the stack
	    var stack = chainStack(prepareTransportStack(config).concat([new xdm.stack.RpcBehavior(this, jsonRpcConfig), {
	        callback: function callback(success) {
	            if (config.onReady) config.onReady(success);
	        }
	    }]));
	
	    // set the origin
	    this.origin = getLocation(config.remote);
	
	    // initiates the destruction of the stack.
	    this.destroy = function () {
	        stack.destroy();
	    };
	
	    stack.init();
	
	    // store a reference to the iframe that is created
	    this.iframe = config.iframe;
	};
	
	/**
	 * xdm.stack.PostMessageTransport
	 *
	 * PostMessageTransport uses HTML5 postMessage for communication.
	 *
	 * @param {Object} config The transports configuration.
	 */
	
	xdm.stack.PostMessageTransport = function (config) {
	    var pub;
	    var frame;
	    var callerWindow;
	    var targetOrigin;
	
	    /**
	     * This is the main implementation for the onMessage event.
	     * It checks the validity of the origin and passes the message on if appropriate.
	     *
	     * @param {Object} event The message event
	     */
	
	    function checkOrigin(origin, target) {
	        return origin === targetOrigin || /^file/.test(targetOrigin);
	    }
	
	    function _windowOnMessage(event) {
	        var origin = getLocation(event.origin);
	        var dataIsString = typeof event.data === 'string';
	        if (checkOrigin(origin, targetOrigin) && dataIsString && event.data.substring(0, config.channel.length + 1) === config.channel + ' ') {
	            pub.up.incoming(event.data.substring(config.channel.length + 1), origin);
	        }
	    }
	
	    pub = {
	        outgoing: function outgoing(message, domain, fn) {
	            callerWindow.postMessage(config.channel + ' ' + message, domain || targetOrigin);
	            if (fn) {
	                fn();
	            }
	        },
	
	        destroy: function destroy() {
	            removeEvent(window, 'message', _windowOnMessage);
	            if (frame) {
	                callerWindow = null;
	                frame.parentNode.removeChild(frame);
	                frame = null;
	            }
	        },
	
	        init: function init() {
	            targetOrigin = getLocation(config.remote);
	            if (config.isHost) {
	                // add the event handler for listening
	                var waitForReady = function waitForReady(event) {
	                    if (frame && event.data === config.channel + '-ready') {
	                        if ('postMessage' in frame.contentWindow) {
	                            callerWindow = frame.contentWindow;
	                        } else {
	                            callerWindow = frame.contentWindow.document;
	                        }
	
	                        // replace the eventlistener
	                        removeEvent(window, 'message', waitForReady);
	                        addEvent(window, 'message', _windowOnMessage);
	
	                        setTimeout(function () {
	                            pub.up.callback(true);
	                        }, 0);
	                    }
	                };
	
	                addEvent(window, 'message', waitForReady);
	                frame = createFrame(config);
	            } else {
	                // add the event handler for listening
	                addEvent(window, 'message', _windowOnMessage);
	                if ('postMessage' in window.parent) {
	                    callerWindow = window.parent;
	                } else {
	                    callerWindow = window.parent.document;
	                }
	
	                callerWindow.postMessage(config.channel + '-ready', targetOrigin);
	
	                setTimeout(function () {
	                    pub.up.callback(true);
	                }, 0);
	            }
	        }
	    };
	
	    return pub;
	};
	
	/**
	 * xdm.stack.QueueBehavior
	 *
	 * This is a behavior that enables queueing of messages.
	 * It will buffer incoming messages and dispach these as fast as the underlying transport allows.
	 *
	 * @param {Boolean} remove If true, it will remove from the stack
	 */
	
	xdm.stack.QueueBehavior = function (remove) {
	    var pub;
	    var queue = [];
	    var waiting = true;
	    var incoming = '';
	    var destroying;
	
	    function dispatch() {
	        var message;
	
	        if (remove === true && queue.length === 0) {
	            removeFromStack(pub);
	            return;
	        }
	        if (waiting || queue.length === 0 || destroying) {
	            return;
	        }
	
	        waiting = true;
	        message = queue.shift();
	
	        pub.down.outgoing(message.data, message.origin, function (success) {
	            waiting = false;
	            if (message.callback) {
	                setTimeout(function () {
	                    message.callback(success);
	                }, 0);
	            }
	            dispatch();
	        });
	    }
	
	    pub = {
	        init: function init() {
	            pub.down.init();
	        },
	
	        callback: function callback(success) {
	            waiting = false;
	            // in case dispatch calls removeFromStack
	            var up = pub.up;
	            dispatch();
	            up.callback(success);
	        },
	
	        incoming: function incoming(message, origin) {
	            pub.up.incoming(message, origin);
	        },
	
	        outgoing: function outgoing(message, origin, fn) {
	            queue.push({
	                data: message,
	                origin: origin,
	                callback: fn
	            });
	
	            dispatch();
	        },
	
	        destroy: function destroy() {
	            destroying = true;
	            pub.down.destroy();
	        }
	    };
	
	    return pub;
	};
	
	/**
	 * xdm.stack.RpcBehavior
	 *
	 * This uses JSON-RPC 2.0 to expose local methods and to invoke remote methods
	 * and have responses returned over the the string based transport stack.
	 *
	 * Exposed methods can return values synchronously, asynchronously, or not at all.
	 *
	 * @param {Object} proxy The object to apply the methods to.
	 * @param {Object} config The definition of the local and remote interface to implement.
	 *   local: The local interface to expose.
	 *   remote: The remote methods to expose through the proxy.
	 */
	
	xdm.stack.RpcBehavior = function (proxy, config) {
	    var pub;
	    var _callbackCounter = 0;
	    var _callbacks = {};
	
	    /**
	     * Serializes and sends the message
	     *
	     * @param {Object} data The JSON-RPC message to be sent. The jsonrpc property will be added.
	     */
	
	    function _send(data) {
	        data.jsonrpc = '2.0';
	        pub.down.outgoing(JSON.stringify(data));
	    }
	
	    /**
	     * Creates a method that implements the given definition
	     *
	     * @param {Object} definition The method configuration
	     * @param {String} method The name of the method
	     * @return {Function} A stub capable of proxying the requested method call
	     */
	
	    function _createMethod(definition, method) {
	        var slice = Array.prototype.slice;
	
	        return function () {
	            var l = arguments.length;
	            var callback;
	            var message = {
	                method: method
	            };
	
	            if (l > 0 && typeof arguments[l - 1] === 'function') {
	                // one callback, procedure
	                if (l > 1 && typeof arguments[l - 2] === 'function') {
	                    // two callbacks, success and error
	                    callback = {
	                        success: arguments[l - 2],
	                        error: arguments[l - 1]
	                    };
	                    message.params = slice.call(arguments, 0, l - 2);
	                } else {
	                    // single callback, success
	                    callback = {
	                        success: arguments[l - 1]
	                    };
	                    message.params = slice.call(arguments, 0, l - 1);
	                }
	                _callbacks['' + ++_callbackCounter] = callback;
	                message.id = _callbackCounter;
	            } else {
	                // no callbacks, a notification
	                message.params = slice.call(arguments, 0);
	            }
	
	            if (definition.namedParams && message.params.length === 1) {
	                message.params = message.params[0];
	            }
	            // Send the method request
	            _send(message);
	        };
	    }
	
	    /**
	     * Executes the exposed method
	     *
	     * @param {String} method The name of the method
	     * @param {Number} id The callback id to use
	     * @param {Function} fn The exposed implementation
	     * @param {Array} params The parameters supplied by the remote end
	     */
	
	    function _executeMethod(method, id, fn, params) {
	        if (!fn) {
	            if (id) {
	                _send({
	                    id: id,
	                    error: {
	                        code: -32601,
	                        message: 'Procedure not found.'
	                    }
	                });
	            }
	            return;
	        }
	
	        var success;
	        var error;
	
	        if (id) {
	            success = function (result) {
	                success = emptyFn;
	                _send({
	                    id: id,
	                    result: result
	                });
	            };
	
	            error = function (message, data) {
	                error = emptyFn;
	                var msg = {
	                    id: id,
	                    error: {
	                        code: -32099,
	                        message: message
	                    }
	                };
	
	                if (data) {
	                    msg.error.data = data;
	                }
	                _send(msg);
	            };
	        } else {
	            success = error = emptyFn;
	        }
	
	        // call local method
	        if (!isArray(params)) {
	            params = [params];
	        }
	
	        try {
	            var result = fn.method.apply(fn.scope, params.concat([success, error]));
	            if (!undef(result)) {
	                success(result);
	            }
	        } catch (ex1) {
	            error(ex1.message);
	        }
	    }
	
	    pub = {
	        incoming: function incoming(message, origin) {
	            var data = JSON.parse(message);
	            var callback;
	
	            if (data.method) {
	                // a method call from the remote end
	                if (config.handle) {
	                    config.handle(data, _send);
	                } else {
	                    _executeMethod(data.method, data.id, config.local[data.method], data.params);
	                }
	            } else {
	                // a method response from the other end
	                callback = _callbacks[data.id];
	                if (data.error && callback.error) {
	                    callback.error(data.error);
	                } else if (callback.success) {
	                    callback.success(data.result);
	                }
	                delete _callbacks[data.id];
	            }
	        },
	
	        init: function init() {
	            if (config.remote) {
	                // implement the remote sides exposed methods
	                for (var method in config.remote) {
	                    if (config.remote.hasOwnProperty(method)) {
	                        proxy[method] = _createMethod(config.remote[method], method);
	                    }
	                }
	            }
	            pub.down.init();
	        },
	
	        destroy: function destroy() {
	            for (var method in config.remote) {
	                if (config.remote.hasOwnProperty(method) && proxy.hasOwnProperty(method)) {
	                    delete proxy[method];
	                }
	            }
	            pub.down.destroy();
	        }
	    };
	
	    return pub;
	};
	
	module.exports = xdm;

/***/ },
/* 54 */
/*!*******************************!*\
  !*** ./src/client/api.coffee ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	var Api, EventBus, Promise, channel, logger, parseOpts,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	parseOpts = __webpack_require__(/*! ./parse-opts */ 106);
	
	channel = __webpack_require__(/*! ./channel */ 55);
	
	Api = (function() {
	  function Api(channel, currentUser, currentConfig) {
	    this.updateCurrentUserCookies = bind(this.updateCurrentUserCookies, this);
	    this._updateCurrentUser = bind(this._updateCurrentUser, this);
	    this.updateCurrentUser = bind(this.updateCurrentUser, this);
	    this.refreshUser = bind(this.refreshUser, this);
	    this.message = bind(this.message, this);
	    var authScope, data, ref;
	    this.channel = channel;
	    this.currentConfig = currentConfig;
	    this.currentUser = currentUser;
	    EventBus.on('hull.settings.update', function(settings) {
	      return currentConfig.setRemote(settings, 'settings');
	    });
	    data = this.currentConfig.getRemote('data');
	    authScope = ((ref = data.headers) != null ? ref['Hull-Auth-Scope'] : void 0) ? data.headers['Hull-Auth-Scope'].split(":")[0] : '';
	    if ((data.headers != null)) {
	      this.currentUser.setCookies(data.headers, currentConfig.get('appId'));
	    }
	    this._message = (function(_this) {
	      return function(params, userSuccessCallback, userErrorCallback) {};
	    })(this);
	  }
	
	
	  /*
	   * Sends the message described by @params to xdm
	   * @param {Object} contains the provider, uri and parameters for the message
	   * @param {Function} optional a success callback
	   * @param {Function} optional an error callback
	   * @return {Promise}
	   */
	
	  Api.prototype.message = function() {
	    var callback, errback, opts, ref;
	    if (!this.channel.rpc) {
	      return logger.error("Hull Api is not initialized yet. You should run your app from the callback of Hull.ready()");
	    }
	    ref = parseOpts(Array.prototype.slice.call(arguments)), opts = ref.opts, callback = ref.callback, errback = ref.errback;
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var onError, onSuccess;
	        onSuccess = function(res) {
	          if (res == null) {
	            res = {};
	          }
	          return _this.updateCurrentUser(res).then(function() {
	            _this.updateCurrentUserCookies(res.headers, res.provider);
	            callback(res.body);
	            return resolve(res.body);
	          });
	        };
	        onError = function(response, error) {
	          errback(response.message, error);
	          return reject(response.message, error);
	        };
	        return _this.channel.rpc.message(opts, onSuccess, onError);
	      };
	    })(this));
	  };
	
	  Api.prototype.refreshUser = function() {
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var onError, onSuccess;
	        onSuccess = function(response) {
	          if (response == null) {
	            response = {};
	          }
	          _this.currentUser.set(response.me);
	          _this.currentConfig.setRemote(response.services, 'services');
	          _this.updateCurrentUserCookies(response.headers, 'hull');
	          return resolve(response.me);
	        };
	        onError = function(err) {
	          if (err == null) {
	            err = {};
	          }
	          return reject(err);
	        };
	        return _this.channel.rpc.refreshUser(onSuccess, onError);
	      };
	    })(this));
	  };
	
	  Api.prototype.updateCurrentUser = function(response) {
	    var header, p, ref, ref1, u;
	    header = (ref = response.headers) != null ? ref['Hull-User-Id'] : void 0;
	    p = Promise.resolve();
	    if (header == null) {
	      return p;
	    }
	    if (((ref1 = response.body) != null ? ref1.id : void 0) === header) {
	      this.currentUser.set(response.body);
	    } else {
	      u = this.currentUser.get();
	      if (!u || u.id !== header) {
	        p = this.refreshUser();
	      }
	    }
	    return p;
	  };
	
	  Api.prototype._updateCurrentUser = function(user, headers) {
	    var header;
	    if (user == null) {
	      user = {};
	    }
	    if (headers == null) {
	      headers = {};
	    }
	    header = headers != null ? headers['Hull-User-Id'] : void 0;
	    if (header && (user != null ? user.id : void 0) === header) {
	      return this.currentUser.set(user);
	    }
	  };
	
	  Api.prototype.updateCurrentUserCookies = function(headers, provider) {
	    if ((headers != null) && provider === 'hull') {
	      return this.currentUser.setCookies(headers, this.currentConfig.get('appId'));
	    }
	  };
	
	  return Api;
	
	})();
	
	module.exports = Api;


/***/ },
/* 55 */
/*!***********************************!*\
  !*** ./src/client/channel.coffee ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var Channel, EventBus, Promise, _, domready, hiddenFrameStyle, logger, rpcFrameInitStyle, shownFrameStyle, xdm,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  slice = [].slice;
	
	xdm = __webpack_require__(/*! ../utils/xdm */ 53);
	
	domready = __webpack_require__(/*! ../utils/domready */ 52);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	hiddenFrameStyle = {
	  top: '-20px',
	  left: '-20px',
	  bottom: 'auto',
	  right: 'auto',
	  width: '1px',
	  height: '1px',
	  display: 'block',
	  position: 'fixed',
	  zIndex: void 0,
	  overflow: 'hidden'
	};
	
	shownFrameStyle = {
	  top: '0px',
	  left: '0px',
	  right: '0px',
	  bottom: '0px',
	  width: '100%',
	  height: '100%',
	  display: 'block',
	  position: 'fixed',
	  zIndex: 10000,
	  overflow: 'auto'
	};
	
	rpcFrameInitStyle = {
	  tabIndex: -1,
	  height: "0",
	  width: "1px",
	  style: {
	    position: 'fixed',
	    width: "1px",
	    height: "1px",
	    top: '-20px',
	    left: '-20px',
	    overflow: 'hidden'
	  }
	};
	
	Channel = (function() {
	  function Channel(currentUser, currentConfig) {
	    this.applyFrameStyle = bind(this.applyFrameStyle, this);
	    this.userUpdate = bind(this.userUpdate, this);
	    this.configUpdate = bind(this.configUpdate, this);
	    this.emitTrackEvent = bind(this.emitTrackEvent, this);
	    this.hideIframe = bind(this.hideIframe, this);
	    this.showIframe = bind(this.showIframe, this);
	    this.getClientConfig = bind(this.getClientConfig, this);
	    this.ready = bind(this.ready, this);
	    this.loadingFailed = bind(this.loadingFailed, this);
	    this.loadError = bind(this.loadError, this);
	    this.startRpc = bind(this.startRpc, this);
	    this.allowRetry = true;
	    this.retryCount = 0;
	    this.currentConfig = currentConfig;
	    this.currentUser = currentUser;
	    this.timeout = null;
	    this.rpc = null;
	    this._ready = {};
	    this.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this._ready.resolve = resolve;
	        return _this._ready.reject = reject;
	      };
	    })(this));
	    domready(this.startRpc);
	  }
	
	  Channel.prototype.startRpc = function() {
	    this.retryCount += 1;
	    this.timeout = setTimeout(this.loadingFailed, this.retryCount * 10000);
	    this.rpc = new xdm.Rpc({
	      remote: this.currentConfig.getRemoteUrl(),
	      container: document.body,
	      channel: [this.currentConfig.get('appId'), this.retryCount].join("-"),
	      props: rpcFrameInitStyle
	    }, {
	      remote: {
	        message: {},
	        ready: {},
	        refreshUser: {},
	        resetIdentify: {}
	      },
	      local: {
	        message: this.onMessage,
	        ready: this.ready,
	        loadError: this.loadError,
	        userUpdate: this.userUpdate,
	        configUpdate: this.configUpdate,
	        show: this.showIframe,
	        hide: this.hideIframe,
	        track: this.emitTrackEvent,
	        getClientConfig: this.getClientConfig
	      }
	    });
	    return this.rpc;
	  };
	
	  Channel.prototype.loadError = function(err) {
	    window.clearTimeout(this.timeout);
	    this.allowRetry = false;
	    return this._ready.reject(new Error(err));
	  };
	
	  Channel.prototype.loadingFailed = function(err) {
	    this.rpc && this.rpc.destroy();
	    if (this.allowRetry && this.retryCount < 4) {
	      return this.startRpc();
	    } else {
	      return this._ready.reject(new Error('Remote loading has failed. Please check "orgUrl" and "appId" in your configuration. This may also be about connectivity.'));
	    }
	  };
	
	  Channel.prototype.onMessage = function(e) {
	    if (e.error) {
	      return this._ready.reject(e.error);
	    } else {
	      return logger.log("RPC Message", arguments);
	    }
	  };
	
	  Channel.prototype.ready = function(remoteConfig) {
	    var err, error;
	    try {
	      window.clearTimeout(this.timeout);
	      this.currentConfig.initRemote(remoteConfig);
	      return this._ready.resolve(this);
	    } catch (error) {
	      err = error;
	      return this._ready.reject(err);
	    }
	  };
	
	  Channel.prototype.getClientConfig = function() {
	    return this.currentConfig.get();
	  };
	
	  Channel.prototype.showIframe = function() {
	    return this.applyFrameStyle(shownFrameStyle);
	  };
	
	  Channel.prototype.hideIframe = function() {
	    return this.applyFrameStyle(hiddenFrameStyle);
	  };
	
	  Channel.prototype.emitTrackEvent = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return EventBus.emit.apply(EventBus, ['hull.track'].concat(slice.call(args)));
	  };
	
	  Channel.prototype.configUpdate = function(config) {
	    return this.currentConfig.setRemote(config);
	  };
	
	  Channel.prototype.userUpdate = function(me) {
	    return this.currentUser.set(me);
	  };
	
	  Channel.prototype.applyFrameStyle = function(styles) {
	    return _.map(styles, (function(_this) {
	      return function(v, k) {
	        return _this.rpc.iframe.style[k] = v;
	      };
	    })(this));
	  };
	
	  return Channel;
	
	})();
	
	module.exports = Channel;


/***/ },
/* 56 */
/*!*************************************************!*\
  !*** ./src/client/embeds/strategies/raw.coffee ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseDeploymentStrategy, RawDeploymentStrategy, _, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(/*! ../../../utils/lodash */ 1);
	
	throwErr = __webpack_require__(/*! ../../../utils/throw */ 12);
	
	BaseDeploymentStrategy = __webpack_require__(/*! ./base */ 39);
	
	RawDeploymentStrategy = (function(superClass) {
	  extend(RawDeploymentStrategy, superClass);
	
	  function RawDeploymentStrategy() {
	    this.destroy = bind(this.destroy, this);
	    this.onEmbed = bind(this.onEmbed, this);
	    this.addInsertion = bind(this.addInsertion, this);
	    return RawDeploymentStrategy.__super__.constructor.apply(this, arguments);
	  }
	
	  RawDeploymentStrategy.prototype.scopeStyles = false;
	
	  RawDeploymentStrategy.prototype.ignoredTags = ['#comment', 'SCRIPT'];
	
	  RawDeploymentStrategy.prototype.headTags = ['LINK', 'STYLE'];
	
	
	  /**
	   * Raw : Directly in the page
	   * @return {promises} a promise that will resolve when all elements have been loaded.
	   */
	
	  RawDeploymentStrategy.prototype.embed = function(targets) {
	    this.insertions = [];
	    this["import"] = this.embedImport();
	    this["import"].when.ready.then((function(_this) {
	      return function(doc) {
	        var el, i, len, results, target;
	        _this.document = doc;
	        _this.setupSandbox(doc);
	        el = _this.cloneImport(doc);
	        results = [];
	        for (i = 0, len = targets.length; i < len; i++) {
	          target = targets[i];
	          results.push(_this.addInsertion(_this.insert(el.cloneNode(true), target)));
	        }
	        return results;
	      };
	    })(this))["catch"](throwErr);
	    this["import"].when.loaded["catch"](throwErr);
	    return this["import"].when.loaded;
	  };
	
	  RawDeploymentStrategy.prototype.addInsertion = function(el, iframe, doc) {
	    this.sandbox.addElement(el);
	    return this.insertions.push({
	      el: el,
	      iframe: iframe,
	      doc: doc,
	      ready: false,
	      callbacks: []
	    });
	  };
	
	  RawDeploymentStrategy.prototype.onEmbed = function() {
	    return this.ready.promise.then((function(_this) {
	      return function() {
	        var callbacks;
	        callbacks = _this.document._hullCallbacks || [];
	        return _.map(_this.insertions, function(insertion) {
	          return _.map(callbacks, function(callback) {
	            if (!_.find(insertion.callbacks, function(d) {
	              return d === callback;
	            })) {
	              insertion.callbacks.push(callback);
	              return callback(insertion.el, _this.deployment.getPublicData(), _this.sandbox.hull);
	            }
	          });
	        });
	      };
	    })(this))["catch"](throwErr);
	  };
	
	  RawDeploymentStrategy.prototype.destroy = function() {
	    this["import"].destroy();
	    this.sandbox.destroy();
	    return RawDeploymentStrategy.__super__.destroy.call(this);
	  };
	
	  return RawDeploymentStrategy;
	
	})(BaseDeploymentStrategy);
	
	module.exports = RawDeploymentStrategy;


/***/ },
/* 57 */
/*!*************************************!*\
  !*** ./src/utils/dom-walker.coffee ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var _, getChildren, getLinkValue, getMetaValue, getSiblings, isNode;
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	getLinkValue = function(node) {
	  var ref;
	  if (node == null) {
	    return;
	  }
	  return ((ref = node.dataset) != null ? ref.hullLink : void 0) || (node.nodeName === 'A' && node.href);
	};
	
	getMetaValue = function(name) {
	  var meta, metas;
	  metas = document.getElementsByTagName('meta');
	  meta = _.find(metas, function(meta) {
	    return meta.getAttribute('property') === name || meta.getAttribute('name') === name;
	  });
	  if (meta == null) {
	    return;
	  }
	  return meta.content;
	};
	
	isNode = function(o) {
	  if (typeof Node === "object") {
	    return o instanceof Node;
	  } else {
	    return o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName === "string";
	  }
	};
	
	getChildren = function(n, skipMe) {
	  var r;
	  r = [];
	  while (n && (n = n.nextSibling)) {
	    if (n.nodeType === 1 && n !== skipMe) {
	      r.push(n);
	    }
	  }
	  return r;
	};
	
	getSiblings = function(n) {
	  return getChildren(n.parentNode.firstChild, n);
	};
	
	module.exports = {
	  getSiblings: getSiblings,
	  getChildren: getChildren,
	  getMetaValue: getMetaValue,
	  getLinkValue: getLinkValue,
	  isNode: isNode
	};


/***/ },
/* 58 */
/*!**********************************!*\
  !*** ./src/utils/get-key.coffee ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var _, clone;
	
	clone = __webpack_require__(/*! ./clone */ 9);
	
	_ = __webpack_require__(/*! ./lodash */ 1);
	
	module.exports = function(hash, key) {
	  if (!(key && _.isObject(hash))) {
	    return hash;
	  }
	  _.each(key.split('.'), function(k) {
	    if (hash === void 0) {
	      return hash;
	    }
	    if (_.contains(_.keys(hash), k)) {
	      return hash = hash[k];
	    } else {
	      return hash = void 0;
	    }
	  });
	  return clone(hash);
	};


/***/ },
/* 59 */
/*!************************************!*\
  !*** ./src/utils/is-mobile.coffee ***!
  \************************************/
/***/ function(module, exports) {

	var isMobile;
	
	isMobile = function() {
	  var n;
	  n = navigator.userAgent || navigator.vendor || window.opera;
	  return !!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(n) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(n.substr(0, 4));
	};
	
	module.exports = isMobile;


/***/ },
/* 60 */
/*!************************************!*\
  !*** ./src/utils/set-style.coffee ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var _, getDocHeight, setDimension;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	getDocHeight = function(doc) {
	  var body, html;
	  if (!doc) {
	    return;
	  }
	  body = doc.body;
	  html = doc.documentElement;
	  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	};
	
	setDimension = function(el, dim, val) {
	  if (val != null) {
	    if (/[0-9]+$/.test(val.toString())) {
	      val = val + "px";
	    }
	    return el.style[dim] = val;
	  }
	};
	
	module.exports = {
	  autoSize: function(iframe) {
	    var contentHeight, ref, target;
	    if (iframe == null) {
	      return;
	    }
	    target = iframe.contentDocument || ((ref = iframe.contentWindow) != null ? ref.document : void 0);
	    contentHeight = getDocHeight(target);
	    if (contentHeight !== iframe.offsetHeight) {
	      iframe.style.visibility = 'hidden';
	      iframe.style.height = contentHeight + "px";
	      return iframe.style.visibility = 'visible';
	    }
	  },
	  style: function(el, style) {
	    if (_.isObject(style)) {
	      return _.map(style, function(value, key) {
	        return setDimension(el, key, value);
	      });
	    }
	  }
	};


/***/ },
/* 61 */
/*!********************************************!*\
  !*** ./src/utils/ui/display-banner.coffee ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var _, banners, captcha, platform, platformCss;
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	platform = __webpack_require__(/*! html!./platform.html */ 140);
	
	captcha = __webpack_require__(/*! html!./captcha.html */ 139);
	
	platformCss = __webpack_require__(/*! raw!inline-style!./platform.css */ 222);
	
	banners = {
	  platform: {
	    html: platform,
	    css: platformCss
	  },
	  captcha: {
	    html: captcha,
	    css: platformCss
	  }
	};
	
	module.exports = function(banner, root) {
	  var a, css, element, elements, html, i, len, node, ref, ref1, selector, style;
	  if (root == null) {
	    root = document.body;
	  }
	  node = document.createElement('div');
	  html = (ref = banners[banner]) != null ? ref.html : void 0;
	  css = (ref1 = banners[banner]) != null ? ref1.css : void 0;
	  node.innerHTML = html;
	  for (selector in css) {
	    style = css[selector];
	    elements = node.querySelectorAll(selector);
	    for (i = 0, len = elements.length; i < len; i++) {
	      element = elements[i];
	      element.setAttribute('style', style);
	    }
	  }
	  a = node.getElementsByTagName('a');
	  _.each(a, function(element) {
	    var intent;
	    intent = element.getAttribute('data-hull-intent');
	    return element.addEventListener('click', function(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      return Hull.emit(intent);
	    });
	  });
	  if (root) {
	    root.appendChild(node);
	  }
	  return node;
	};


/***/ },
/* 62 */
/*!**************************************!*\
  !*** ./~/cookies-js/dist/cookies.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Cookies.js - 1.2.2
	 * https://github.com/ScottHamper/Cookies
	 *
	 * This is free and unencumbered software released into the public domain.
	 */
	(function (global, undefined) {
	    'use strict';
	
	    var factory = function (window) {
	        if (typeof window.document !== 'object') {
	            throw new Error('Cookies.js requires a `window` with a `document` object');
	        }
	
	        var Cookies = function (key, value, options) {
	            return arguments.length === 1 ?
	                Cookies.get(key) : Cookies.set(key, value, options);
	        };
	
	        // Allows for setter injection in unit tests
	        Cookies._document = window.document;
	
	        // Used to ensure cookie keys do not collide with
	        // built-in `Object` properties
	        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
	        
	        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');
	
	        Cookies.defaults = {
	            path: '/',
	            secure: false
	        };
	
	        Cookies.get = function (key) {
	            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
	                Cookies._renewCache();
	            }
	            
	            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];
	
	            return value === undefined ? undefined : decodeURIComponent(value);
	        };
	
	        Cookies.set = function (key, value, options) {
	            options = Cookies._getExtendedOptions(options);
	            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);
	
	            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);
	
	            return Cookies;
	        };
	
	        Cookies.expire = function (key, options) {
	            return Cookies.set(key, undefined, options);
	        };
	
	        Cookies._getExtendedOptions = function (options) {
	            return {
	                path: options && options.path || Cookies.defaults.path,
	                domain: options && options.domain || Cookies.defaults.domain,
	                expires: options && options.expires || Cookies.defaults.expires,
	                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
	            };
	        };
	
	        Cookies._isValidDate = function (date) {
	            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
	        };
	
	        Cookies._getExpiresDate = function (expires, now) {
	            now = now || new Date();
	
	            if (typeof expires === 'number') {
	                expires = expires === Infinity ?
	                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
	            } else if (typeof expires === 'string') {
	                expires = new Date(expires);
	            }
	
	            if (expires && !Cookies._isValidDate(expires)) {
	                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
	            }
	
	            return expires;
	        };
	
	        Cookies._generateCookieString = function (key, value, options) {
	            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
	            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
	            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
	            options = options || {};
	
	            var cookieString = key + '=' + value;
	            cookieString += options.path ? ';path=' + options.path : '';
	            cookieString += options.domain ? ';domain=' + options.domain : '';
	            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
	            cookieString += options.secure ? ';secure' : '';
	
	            return cookieString;
	        };
	
	        Cookies._getCacheFromString = function (documentCookie) {
	            var cookieCache = {};
	            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];
	
	            for (var i = 0; i < cookiesArray.length; i++) {
	                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);
	
	                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
	                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
	                }
	            }
	
	            return cookieCache;
	        };
	
	        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
	            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
	            var separatorIndex = cookieString.indexOf('=');
	
	            // IE omits the "=" when the cookie value is an empty string
	            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;
	
	            var key = cookieString.substr(0, separatorIndex);
	            var decodedKey;
	            try {
	                decodedKey = decodeURIComponent(key);
	            } catch (e) {
	                if (console && typeof console.error === 'function') {
	                    console.error('Could not decode cookie with key "' + key + '"', e);
	                }
	            }
	            
	            return {
	                key: decodedKey,
	                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
	            };
	        };
	
	        Cookies._renewCache = function () {
	            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
	            Cookies._cachedDocumentCookie = Cookies._document.cookie;
	        };
	
	        Cookies._areEnabled = function () {
	            var testKey = 'cookies.js';
	            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
	            Cookies.expire(testKey);
	            return areEnabled;
	        };
	
	        Cookies.enabled = Cookies._areEnabled();
	
	        return Cookies;
	    };
	
	    var cookiesExport = typeof global.document === 'object' ? factory(global) : factory;
	
	    // AMD support
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return cookiesExport; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    // CommonJS/Node.js support
	    } else if (typeof exports === 'object') {
	        // Support Node.js specific `module.exports` (which can be a function)
	        if (typeof module === 'object' && typeof module.exports === 'object') {
	            exports = module.exports = cookiesExport;
	        }
	        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
	        exports.Cookies = cookiesExport;
	    } else {
	        global.Cookies = cookiesExport;
	    }
	})(typeof window === 'undefined' ? this : window);

/***/ },
/* 63 */
/*!**********************************************!*\
  !*** ./~/eventemitter2/lib/eventemitter2.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter2
	 * https://github.com/hij1nx/EventEmitter2
	 *
	 * Copyright (c) 2013 hij1nx
	 * Licensed under the MIT license.
	 */
	;!function(undefined) {
	
	  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	  var defaultMaxListeners = 10;
	
	  function init() {
	    this._events = {};
	    if (this._conf) {
	      configure.call(this, this._conf);
	    }
	  }
	
	  function configure(conf) {
	    if (conf) {
	
	      this._conf = conf;
	
	      conf.delimiter && (this.delimiter = conf.delimiter);
	      conf.maxListeners && (this._events.maxListeners = conf.maxListeners);
	      conf.wildcard && (this.wildcard = conf.wildcard);
	      conf.newListener && (this.newListener = conf.newListener);
	
	      if (this.wildcard) {
	        this.listenerTree = {};
	      }
	    }
	  }
	
	  function EventEmitter(conf) {
	    this._events = {};
	    this.newListener = false;
	    configure.call(this, conf);
	  }
	
	  //
	  // Attention, function return type now is array, always !
	  // It has zero elements if no any matches found and one or more
	  // elements (leafs) if there are matches
	  //
	  function searchListenerTree(handlers, type, tree, i) {
	    if (!tree) {
	      return [];
	    }
	    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
	        typeLength = type.length, currentType = type[i], nextType = type[i+1];
	    if (i === typeLength && tree._listeners) {
	      //
	      // If at the end of the event(s) list and the tree has listeners
	      // invoke those listeners.
	      //
	      if (typeof tree._listeners === 'function') {
	        handlers && handlers.push(tree._listeners);
	        return [tree];
	      } else {
	        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
	          handlers && handlers.push(tree._listeners[leaf]);
	        }
	        return [tree];
	      }
	    }
	
	    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
	      //
	      // If the event emitted is '*' at this part
	      // or there is a concrete match at this patch
	      //
	      if (currentType === '*') {
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
	          }
	        }
	        return listeners;
	      } else if(currentType === '**') {
	        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
	        if(endReached && tree._listeners) {
	          // The next element has a _listeners, add it to the handlers.
	          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
	        }
	
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            if(branch === '*' || branch === '**') {
	              if(tree[branch]._listeners && !endReached) {
	                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
	              }
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            } else if(branch === nextType) {
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
	            } else {
	              // No match on this one, shift into the tree but not in the type array.
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            }
	          }
	        }
	        return listeners;
	      }
	
	      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
	    }
	
	    xTree = tree['*'];
	    if (xTree) {
	      //
	      // If the listener tree will allow any match for this part,
	      // then recursively explore all branches of the tree
	      //
	      searchListenerTree(handlers, type, xTree, i+1);
	    }
	
	    xxTree = tree['**'];
	    if(xxTree) {
	      if(i < typeLength) {
	        if(xxTree._listeners) {
	          // If we have a listener on a '**', it will catch all, so add its handler.
	          searchListenerTree(handlers, type, xxTree, typeLength);
	        }
	
	        // Build arrays of matching next branches and others.
	        for(branch in xxTree) {
	          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
	            if(branch === nextType) {
	              // We know the next element will match, so jump twice.
	              searchListenerTree(handlers, type, xxTree[branch], i+2);
	            } else if(branch === currentType) {
	              // Current node matches, move into the tree.
	              searchListenerTree(handlers, type, xxTree[branch], i+1);
	            } else {
	              isolatedBranch = {};
	              isolatedBranch[branch] = xxTree[branch];
	              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
	            }
	          }
	        }
	      } else if(xxTree._listeners) {
	        // We have reached the end and still on a '**'
	        searchListenerTree(handlers, type, xxTree, typeLength);
	      } else if(xxTree['*'] && xxTree['*']._listeners) {
	        searchListenerTree(handlers, type, xxTree['*'], typeLength);
	      }
	    }
	
	    return listeners;
	  }
	
	  function growListenerTree(type, listener) {
	
	    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	
	    //
	    // Looks for two consecutive '**', if so, don't add the event at all.
	    //
	    for(var i = 0, len = type.length; i+1 < len; i++) {
	      if(type[i] === '**' && type[i+1] === '**') {
	        return;
	      }
	    }
	
	    var tree = this.listenerTree;
	    var name = type.shift();
	
	    while (name) {
	
	      if (!tree[name]) {
	        tree[name] = {};
	      }
	
	      tree = tree[name];
	
	      if (type.length === 0) {
	
	        if (!tree._listeners) {
	          tree._listeners = listener;
	        }
	        else if(typeof tree._listeners === 'function') {
	          tree._listeners = [tree._listeners, listener];
	        }
	        else if (isArray(tree._listeners)) {
	
	          tree._listeners.push(listener);
	
	          if (!tree._listeners.warned) {
	
	            var m = defaultMaxListeners;
	
	            if (typeof this._events.maxListeners !== 'undefined') {
	              m = this._events.maxListeners;
	            }
	
	            if (m > 0 && tree._listeners.length > m) {
	
	              tree._listeners.warned = true;
	              console.error('(node) warning: possible EventEmitter memory ' +
	                            'leak detected. %d listeners added. ' +
	                            'Use emitter.setMaxListeners() to increase limit.',
	                            tree._listeners.length);
	              console.trace();
	            }
	          }
	        }
	        return true;
	      }
	      name = type.shift();
	    }
	    return true;
	  }
	
	  // By default EventEmitters will print a warning if more than
	  // 10 listeners are added to it. This is a useful default which
	  // helps finding memory leaks.
	  //
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.
	
	  EventEmitter.prototype.delimiter = '.';
	
	  EventEmitter.prototype.setMaxListeners = function(n) {
	    this._events || init.call(this);
	    this._events.maxListeners = n;
	    if (!this._conf) this._conf = {};
	    this._conf.maxListeners = n;
	  };
	
	  EventEmitter.prototype.event = '';
	
	  EventEmitter.prototype.once = function(event, fn) {
	    this.many(event, 1, fn);
	    return this;
	  };
	
	  EventEmitter.prototype.many = function(event, ttl, fn) {
	    var self = this;
	
	    if (typeof fn !== 'function') {
	      throw new Error('many only accepts instances of Function');
	    }
	
	    function listener() {
	      if (--ttl === 0) {
	        self.off(event, listener);
	      }
	      fn.apply(this, arguments);
	    }
	
	    listener._origin = fn;
	
	    this.on(event, listener);
	
	    return self;
	  };
	
	  EventEmitter.prototype.emit = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	      if (!this._events.newListener) { return false; }
	    }
	
	    // Loop through the *_all* functions and invoke them.
	    if (this._all) {
	      var l = arguments.length;
	      var args = new Array(l - 1);
	      for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
	      for (i = 0, l = this._all.length; i < l; i++) {
	        this.event = type;
	        this._all[i].apply(this, args);
	      }
	    }
	
	    // If there is no 'error' event listener then throw.
	    if (type === 'error') {
	
	      if (!this._all &&
	        !this._events.error &&
	        !(this.wildcard && this.listenerTree.error)) {
	
	        if (arguments[1] instanceof Error) {
	          throw arguments[1]; // Unhandled 'error' event
	        } else {
	          throw new Error("Uncaught, unspecified 'error' event.");
	        }
	        return false;
	      }
	    }
	
	    var handler;
	
	    if(this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    }
	    else {
	      handler = this._events[type];
	    }
	
	    if (typeof handler === 'function') {
	      this.event = type;
	      if (arguments.length === 1) {
	        handler.call(this);
	      }
	      else if (arguments.length > 1)
	        switch (arguments.length) {
	          case 2:
	            handler.call(this, arguments[1]);
	            break;
	          case 3:
	            handler.call(this, arguments[1], arguments[2]);
	            break;
	          // slower
	          default:
	            var l = arguments.length;
	            var args = new Array(l - 1);
	            for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
	            handler.apply(this, args);
	        }
	      return true;
	    }
	    else if (handler) {
	      var l = arguments.length;
	      var args = new Array(l - 1);
	      for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
	
	      var listeners = handler.slice();
	      for (var i = 0, l = listeners.length; i < l; i++) {
	        this.event = type;
	        listeners[i].apply(this, args);
	      }
	      return (listeners.length > 0) || !!this._all;
	    }
	    else {
	      return !!this._all;
	    }
	
	  };
	
	  EventEmitter.prototype.on = function(type, listener) {
	
	    if (typeof type === 'function') {
	      this.onAny(type);
	      return this;
	    }
	
	    if (typeof listener !== 'function') {
	      throw new Error('on only accepts instances of Function');
	    }
	    this._events || init.call(this);
	
	    // To avoid recursion in the case that type == "newListeners"! Before
	    // adding it to the listeners, first emit "newListeners".
	    this.emit('newListener', type, listener);
	
	    if(this.wildcard) {
	      growListenerTree.call(this, type, listener);
	      return this;
	    }
	
	    if (!this._events[type]) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      this._events[type] = listener;
	    }
	    else if(typeof this._events[type] === 'function') {
	      // Adding the second element, need to change to array.
	      this._events[type] = [this._events[type], listener];
	    }
	    else if (isArray(this._events[type])) {
	      // If we've already got an array, just append.
	      this._events[type].push(listener);
	
	      // Check for listener leak
	      if (!this._events[type].warned) {
	
	        var m = defaultMaxListeners;
	
	        if (typeof this._events.maxListeners !== 'undefined') {
	          m = this._events.maxListeners;
	        }
	
	        if (m > 0 && this._events[type].length > m) {
	
	          this._events[type].warned = true;
	          console.error('(node) warning: possible EventEmitter memory ' +
	                        'leak detected. %d listeners added. ' +
	                        'Use emitter.setMaxListeners() to increase limit.',
	                        this._events[type].length);
	          console.trace();
	        }
	      }
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.onAny = function(fn) {
	
	    if (typeof fn !== 'function') {
	      throw new Error('onAny only accepts instances of Function');
	    }
	
	    if(!this._all) {
	      this._all = [];
	    }
	
	    // Add the function to the event listener collection.
	    this._all.push(fn);
	    return this;
	  };
	
	  EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	  EventEmitter.prototype.off = function(type, listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('removeListener only takes instances of Function');
	    }
	
	    var handlers,leafs=[];
	
	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	    }
	    else {
	      // does not use listeners(), so no side effect of creating _events[type]
	      if (!this._events[type]) return this;
	      handlers = this._events[type];
	      leafs.push({_listeners:handlers});
	    }
	
	    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	      var leaf = leafs[iLeaf];
	      handlers = leaf._listeners;
	      if (isArray(handlers)) {
	
	        var position = -1;
	
	        for (var i = 0, length = handlers.length; i < length; i++) {
	          if (handlers[i] === listener ||
	            (handlers[i].listener && handlers[i].listener === listener) ||
	            (handlers[i]._origin && handlers[i]._origin === listener)) {
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0) {
	          continue;
	        }
	
	        if(this.wildcard) {
	          leaf._listeners.splice(position, 1);
	        }
	        else {
	          this._events[type].splice(position, 1);
	        }
	
	        if (handlers.length === 0) {
	          if(this.wildcard) {
	            delete leaf._listeners;
	          }
	          else {
	            delete this._events[type];
	          }
	        }
	        return this;
	      }
	      else if (handlers === listener ||
	        (handlers.listener && handlers.listener === listener) ||
	        (handlers._origin && handlers._origin === listener)) {
	        if(this.wildcard) {
	          delete leaf._listeners;
	        }
	        else {
	          delete this._events[type];
	        }
	      }
	    }
	
	    return this;
	  };
	
	  EventEmitter.prototype.offAny = function(fn) {
	    var i = 0, l = 0, fns;
	    if (fn && this._all && this._all.length > 0) {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++) {
	        if(fn === fns[i]) {
	          fns.splice(i, 1);
	          return this;
	        }
	      }
	    } else {
	      this._all = [];
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
	
	  EventEmitter.prototype.removeAllListeners = function(type) {
	    if (arguments.length === 0) {
	      !this._events || init.call(this);
	      return this;
	    }
	
	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	
	      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	        var leaf = leafs[iLeaf];
	        leaf._listeners = null;
	      }
	    }
	    else {
	      if (!this._events[type]) return this;
	      this._events[type] = null;
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.listeners = function(type) {
	    if(this.wildcard) {
	      var handlers = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
	      return handlers;
	    }
	
	    this._events || init.call(this);
	
	    if (!this._events[type]) this._events[type] = [];
	    if (!isArray(this._events[type])) {
	      this._events[type] = [this._events[type]];
	    }
	    return this._events[type];
	  };
	
	  EventEmitter.prototype.listenersAny = function() {
	
	    if(this._all) {
	      return this._all;
	    }
	    else {
	      return [];
	    }
	
	  };
	
	  if (true) {
	     // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return EventEmitter;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    exports.EventEmitter2 = EventEmitter;
	  }
	  else {
	    // Browser global.
	    window.EventEmitter2 = EventEmitter;
	  }
	}();


/***/ },
/* 64 */
/*!************************************!*\
  !*** ./~/lodash/collection/map.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(/*! ../internal/arrayMap */ 66),
	    baseCallback = __webpack_require__(/*! ../internal/baseCallback */ 10),
	    baseMap = __webpack_require__(/*! ../internal/baseMap */ 179),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	 * `sum`, `uniq`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @alias collect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function timesThree(n) {
	 *   return n * 3;
	 * }
	 *
	 * _.map([1, 2], timesThree);
	 * // => [3, 6]
	 *
	 * _.map({ 'a': 1, 'b': 2 }, timesThree);
	 * // => [3, 6] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee, thisArg) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	  return func(collection, iteratee);
	}
	
	module.exports = map;


/***/ },
/* 65 */
/*!******************************************!*\
  !*** ./~/lodash/internal/arrayFilter.js ***!
  \******************************************/
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 66 */
/*!***************************************!*\
  !*** ./~/lodash/internal/arrayMap.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 67 */
/*!****************************************!*\
  !*** ./~/lodash/internal/arraySome.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 68 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/baseFilter.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./baseEach */ 13);
	
	/**
	 * The base implementation of `_.filter` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 69 */
/*!******************************************!*\
  !*** ./~/lodash/internal/baseFlatten.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(/*! ./arrayPush */ 165),
	    isArguments = __webpack_require__(/*! ../lang/isArguments */ 35),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 21),
	    isObjectLike = __webpack_require__(/*! ./isObjectLike */ 15);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 70 */
/*!**************************************!*\
  !*** ./~/lodash/internal/baseFor.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(/*! ./createBaseFor */ 195);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 71 */
/*!**************************************!*\
  !*** ./~/lodash/internal/baseGet.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 72 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/baseProperty.js ***!
  \*******************************************/
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 73 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/cacheIndexOf.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 74 */
/*!******************************************!*\
  !*** ./~/lodash/internal/createCache.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(/*! ./SetCache */ 161),
	    getNative = __webpack_require__(/*! ./getNative */ 25);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 75 */
/*!************************************!*\
  !*** ./~/lodash/internal/isKey.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 76 */
/*!*************************************************!*\
  !*** ./~/lodash/internal/isStrictComparable.js ***!
  \*************************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 77 */
/*!******************************************!*\
  !*** ./~/lodash/internal/pickByArray.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties specified
	 * by `props`.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function pickByArray(object, props) {
	  object = toObject(object);
	
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index];
	    if (key in object) {
	      result[key] = object[key];
	    }
	  }
	  return result;
	}
	
	module.exports = pickByArray;


/***/ },
/* 78 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/pickByCallback.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(/*! ./baseForIn */ 175);
	
	/**
	 * A specialized version of `_.pick` which picks `object` properties `predicate`
	 * returns truthy for.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Object} Returns the new object.
	 */
	function pickByCallback(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key, object) {
	    if (predicate(value, key, object)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = pickByCallback;


/***/ },
/* 79 */
/*!*************************************!*\
  !*** ./~/lodash/internal/toPath.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(/*! ./baseToString */ 186),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 80 */
/*!**************************************!*\
  !*** ./~/lodash/utility/property.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(/*! ../internal/baseProperty */ 72),
	    basePropertyDeep = __webpack_require__(/*! ../internal/basePropertyDeep */ 182),
	    isKey = __webpack_require__(/*! ../internal/isKey */ 75);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 81 */
/*!***************************!*\
  !*** ./~/qs/lib/utils.js ***!
  \***************************/
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 82 */
/*!**********************************************************!*\
  !*** (webpack)/~/node-libs-browser/~/process/browser.js ***!
  \**********************************************************/
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 83 */
/*!************************************!*\
  !*** ./src/client/embeds/index.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*global require, module*/
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _utilsLodash = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	var _utilsLodash2 = _interopRequireDefault(_utilsLodash);
	
	var _utilsThrow = __webpack_require__(/*! ../../utils/throw */ 12);
	
	var _utilsThrow2 = _interopRequireDefault(_utilsThrow);
	
	var _utilsLogger = __webpack_require__(/*! ../../utils/logger */ 5);
	
	var _utilsLogger2 = _interopRequireDefault(_utilsLogger);
	
	var _utilsPromises = __webpack_require__(/*! ../../utils/promises */ 3);
	
	var _utilsPromises2 = _interopRequireDefault(_utilsPromises);
	
	var _utilsGetCurrentScript = __webpack_require__(/*! ../../utils/get-current-script */ 90);
	
	var _utilsGetCurrentScript2 = _interopRequireDefault(_utilsGetCurrentScript);
	
	var _deployment = __webpack_require__(/*! ./deployment */ 98);
	
	var _deployment2 = _interopRequireDefault(_deployment);
	
	var _initialized = false;
	var _context = {};
	var _callbacks = {};
	
	function attachCallback(doc, callback) {
	  doc._hullCallbacks = doc._hullCallbacks || [];
	  if (!_utilsLodash2["default"].contains(doc._hullCallbacks, callback)) {
	    doc._hullCallbacks.push(callback);
	  }
	}
	
	function embedDeployments(deployments, opts, callback, errback) {
	  if (opts === undefined) opts = {};
	
	  if (!deployments || !deployments.length) {
	    return;
	  }
	  if (opts.reset !== false) {
	    _deployment2["default"].resetDeployments();
	  }
	
	  var embeds = [];
	  var promises = [];
	
	  _utilsLogger2["default"].log('Embedding Deployments', deployments);
	  for (var d = 0, l = deployments.length; d < l; d++) {
	    var dpl = new _deployment2["default"](deployments[d], _context);
	    promises.push(dpl.embed({ refresh: true }));
	  }
	
	  _utilsPromises2["default"].all(promises).then(function (deployments) {
	    _utilsLogger2["default"].log('Deployments resolved', deployments);
	    if (_utilsLodash2["default"].isFunction(callback)) {
	      callback(_utilsLodash2["default"].pluck(deployments, 'value'));
	    }
	  }, errback)["catch"](_utilsThrow2["default"]);
	}
	
	module.exports = {
	  initialize: function initialize(context) {
	    _initialized = true;
	    _context = context;
	  },
	  embed: function embed(deployments, opts, callback, errback) {
	    embedDeployments(deployments, opts, callback, errback);
	  },
	  onEmbed: function onEmbed() {
	    var args = Array.prototype.slice.call(arguments);
	    var callback = undefined;
	
	    while (args.length > 0 && !_utilsLodash2["default"].isFunction(callback)) {
	      callback = args.shift();
	    }
	
	    if (!_utilsLodash2["default"].isFunction(callback)) return false;
	
	    var detectedScript = (0, _utilsGetCurrentScript2["default"])();
	    var currentScript = document.currentScript || detectedScript;
	    var _currentScript = document._currentScript || {};
	    var ownerDocument = _currentScript.ownerDocument || currentScript.ownerDocument || {};
	
	    _utilsLogger2["default"].verbose('detectedScript', detectedScript, 'currentScript', currentScript);
	
	    // detectedScript is null on Chrome. Use this to use either the polyfill or the native implementation.
	    // Fallback to script detection (how will this work ?)
	
	    // Detect JS embed mode first.
	    var shipId = currentScript.getAttribute("data-hull-ship-script");
	
	    if (!shipId) {
	      // we're inside an Import
	      shipId = ownerDocument.shipId;
	      attachCallback(ownerDocument, callback);
	    }
	
	    _utilsLogger2["default"].verbose('detected shipId', shipId);
	    _utilsLogger2["default"].verbose('######################################');
	
	    var deployments = _deployment2["default"].getDeployments(shipId);
	    // In JS-mode, callbacks are passed down to the DeploymentStrategy,
	    // In theother modes, they are ignored because we retreive the callbacks from the import document.
	    if (deployments && deployments.length) {
	      for (var i = deployments.length - 1; i >= 0; i--) {
	        if (deployments[i]) {
	          deployments[i].onEmbed(callback);
	        }
	      };
	    }
	  }
	};

/***/ },
/* 84 */
/*!*******************************************!*\
  !*** ./src/client/initialize-platform.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsEmptyFunction = __webpack_require__(/*! ../utils/empty-function */ 89);
	
	var _utilsEmptyFunction2 = _interopRequireDefault(_utilsEmptyFunction);
	
	var _superagent = __webpack_require__(/*! superagent */ 22);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function initializeShopifyPlatform(context, currentConfig, hull) {
	  var _currentConfig$get = currentConfig.get();
	
	  var customerId = _currentConfig$get.customerId;
	  var accessToken = _currentConfig$get.accessToken;
	  var callbackUrl = _currentConfig$get.callbackUrl;
	
	  try {
	    var _document$location = document.location;
	    var pathname = _document$location.pathname;
	    var search = _document$location.search;
	    var hash = _document$location.hash;
	
	    var _ref = context.app && context.app.settings || {};
	
	    var domain = _ref.domain;
	    var domain_redirect = _ref.domain_redirect;
	    var ssl_enabled = _ref.ssl_enabled;
	
	    if (domain_redirect && domain && pathname.match(/^\/account\/login/) && domain !== document.location.host) {
	
	      var protocol = ssl_enabled ? 'https:' : 'http:';
	      document.location.href = [protocol, '//', domain, pathname, search, hash].join('');
	    }
	  } catch (err) {}
	
	  var currentUser = hull.currentUser();
	
	  if (!customerId && currentUser) {
	    hull.api('services/shopify/login', { return_to: document.location.href }).then(function (r) {
	      // If the platform has multipass enabled and we are NOT inside the customizer
	      // we can log the customer in without knowing his password.
	
	      var _ref2 = currentConfig.identifySession() || {};
	
	      var inits_count = _ref2.inits_count;
	
	      if (r.auth === 'multipass' && inits_count < 2) {
	        if (!(callbackUrl || "").match('__hull_proxy__')) {
	          var l = 'https://' + document.location.host + '/account/login/multipass/' + r.token;
	          window.location = l;
	        }
	      } else {
	        hull.logout();
	      }
	    });
	  } else if (/^[0-9]+$/.test(customerId) && (!accessToken || !currentUser)) {
	    hull.api('services/shopify/customers/' + customerId, 'put');
	  }
	
	  if (customerId) {
	    Hull.on('hull.user.logout', function () {
	      document.location = '/account/logout';
	    });
	  }
	
	  function aliasCart() {
	    var cart = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    if (cart.token) {
	      (function () {
	        var CART_ALIAS_KEY = 'cartAliasToken';
	        var aliasToken = [cart.token, customerId].join('-');
	        if (aliasToken !== currentConfig.storageGet(CART_ALIAS_KEY)) {
	          hull.api('services/shopify/cart', { cart: cart }, 'post').then(function () {
	            currentConfig.storageSet(CART_ALIAS_KEY, aliasToken);
	          });
	        }
	      })();
	    }
	  }
	
	  if (window.HullShopify && window.HullShopify.cart && window.HullShopify.cart.token) {
	    aliasCart(window.HullShopify.cart);
	  } else {
	    var browser = {};
	    try {
	      browser = currentConfig.identifyBrowser();
	    } catch (err) {
	      browser = {};
	    }
	    _superagent2['default'].post('/cart.js').send({}).set('Accept', 'application/json').end(function (res) {
	      aliasCart(JSON.parse(res.text));
	    });
	  }
	}
	
	function getPlatformInitializer(platform) {
	  if (platform.type === 'platforms/shopify_shop') {
	    return initializeShopifyPlatform;
	  } else {
	    return _utilsEmptyFunction2['default'];
	  }
	}
	
	function initializePlatform(context, currentConfig, hull) {
	  var initializer = getPlatformInitializer(context.app);
	  return initializer(context, currentConfig, hull);
	}
	
	exports['default'] = initializePlatform;
	module.exports = exports['default'];

/***/ },
/* 85 */
/*!**********************************************!*\
  !*** ./src/flux/stores/ClientConfigStore.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(/*! events */ 36).EventEmitter;
	var assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	var RemoteDispatcher = __webpack_require__(/*! ../dispatcher/RemoteDispatcher */ 23);
	var RemoteConstants = __webpack_require__(/*! ../constants/RemoteConstants */ 17);
	
	var CHANGE_EVENT = 'change';
	
	var state = {};
	
	var ClientConfigStore = assign({}, EventEmitter.prototype, {
	  emitChange: function emitChange() {
	    this.emit(CHANGE_EVENT);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  },
	  getState: function getState() {
	    return state;
	  },
	
	  dispatcherIndex: RemoteDispatcher.register(function (payload) {
	    var action = payload.action;
	    var text;
	
	    switch (action.actionType) {
	      case RemoteConstants.UPDATE_CLIENT_CONFIG:
	        state = action.config;
	        ClientConfigStore.emitChange();
	        break;
	    }
	    return true;
	  })
	
	});
	
	module.exports = ClientConfigStore;

/***/ },
/* 86 */
/*!*************************************!*\
  !*** ./src/polyfills/shadow-css.js ***!
  \*************************************/
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (scope) {
	  scope = scope || window;
	  if (scope.HTMLImports && scope.HTMLImports.importer && !scope.HTMLImports.useNative) {
	
	    var LINK_STYLE_SELECTOR = 'link[rel=stylesheet]';
	    var importsPreloadSelectors = scope.HTMLImports.importer.importsPreloadSelectors || '';
	
	    scope.HTMLImports.importer.importsPreloadSelectors = importsPreloadSelectors + ',' + LINK_STYLE_SELECTOR;
	
	    var originalParseGeneric = scope.HTMLImports.parser.parseGeneric;
	    scope.HTMLImports.parser.parseGeneric = function (elt) {
	      var style = elt.__importElement || elt;
	      if ((style.nodeName == 'STYLE' || style.nodeName == 'LINK' && style.getAttribute('rel') === 'stylesheet') && (style.ownerDocument !== document || this.rootImportForElement(style).getAttribute('rel') === 'import')) {
	        this.markParsingComplete(style);
	        this.parseNext();
	      } else {
	        originalParseGeneric.call(this, elt);
	      }
	    };
	
	    var hasResource = scope.HTMLImports.parser.hasResource;
	    scope.HTMLImports.parser.hasResource = function (node) {
	      if (node.localName === 'link' && node.hasAttribute('rel') && node.getAttribute('rel') === 'stylesheet') {
	        // Need to check for actual undefined || null, because if style is "" then it's considered falsy...
	        // Style can be "" if no CORS and query failed.
	        return node.__resource !== undefined && node.__resource !== null;
	      } else {
	        return hasResource.call(this, node);
	      }
	    };
	  }
	  true;
	};

/***/ },
/* 87 */
/*!**********************************!*\
  !*** ./src/polyfills/xhr-xdr.js ***!
  \**********************************/
/***/ function(module, exports) {

	/*
	
	 xhr-xdr-adapter
	
	 Use XDomainRequest on IE 8 and IE 9 for cross-origin requests only.
	 Default to standard XMLHttpRequest otherwise.
	
	 Include this file on IE 8 & 9 before making cross-origin ajax requests
	 using libraries or frameworks such as jQuery or AngularJS.  This will allow
	 you to do things like AJAX GET templates/assets from a CDN at run time using
	 the standard XMLHttpRequest API on IE 8/9, or do simple cross-domain POSTs.
	
	 But it doesn't get around the basic limitations of IE 8 & 9's XDomainRequest:
	 * No authentication or cookies can be sent
	 * POST or GET only
	 * No custom headers can be sent
	 * text/plain contentType only
	
	
	 The MIT License (MIT)
	
	 Copyright (c) 2014 Intuit Inc.
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in all
	 copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 SOFTWARE.
	 */
	
	'use strict';
	
	(function () {
	    "use strict";
	    // Ignore everything below if not on IE 8 or IE 9.
	    if (!window.XDomainRequest) {
	        // typeof XDomainRequest is 'object' in IE 8, 'function' in IE 9
	        return;
	    }
	    if ('withCredentials' in new window.XMLHttpRequest()) {
	        return;
	    }
	    if (window.XMLHttpRequest.supportsXDR === true) {
	        // already set up
	        return;
	    }
	
	    var OriginalXMLHttpRequest = window.XMLHttpRequest;
	    var urlRegEx = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
	    var httpRegEx = /^https?:\/\//i;
	    var getOrPostRegEx = /^get|post$/i;
	    var sameSchemeRegEx = new RegExp('^' + location.protocol, 'i');
	
	    // Determine whether XDomainRequest should be used for a given request
	    var useXDR = function useXDR(method, url, async) {
	        var remoteUrl = url;
	        var baseHref;
	        var myLocationParts;
	        var remoteLocationParts;
	        var crossDomain;
	
	        try {
	            // account for the possibility of a <base href="..."> setting, which could make a URL that looks relative actually be cross-domain
	            if (remoteUrl && remoteUrl.indexOf("://") < 0 && document.getElementsByTagName('base').length > 0) {
	                baseHref = document.getElementsByTagName('base')[0].href;
	                if (baseHref) {
	                    remoteUrl = baseHref + remoteUrl;
	                }
	            }
	
	            myLocationParts = urlRegEx.exec(location.href);
	            remoteLocationParts = urlRegEx.exec(remoteUrl);
	            crossDomain = myLocationParts[2].toLowerCase() !== remoteLocationParts[2].toLowerCase();
	
	            // XDomainRequest can only be used for async get/post requests across same scheme, which must be http: or https:
	            return crossDomain && async && getOrPostRegEx.test(method) && httpRegEx.test(remoteUrl) && sameSchemeRegEx.test(remoteUrl);
	        } catch (ex) {
	            return false;
	        }
	    };
	
	    window.XMLHttpRequest = function () {
	        var self = this;
	        this._setReadyState = function (readyState) {
	            if (self.readyState !== readyState) {
	                self.readyState = readyState;
	                if (typeof self.onreadystatechange === "function") {
	                    self.onreadystatechange();
	                }
	                self._runCallbacks('readystatechange');
	            }
	        };
	        this._callbacks = {};
	        this.readyState = 0;
	        this.responseText = "";
	        this.status = 0;
	        this.statusText = "";
	        this.withCredentials = false;
	    };
	
	    window.XMLHttpRequest.prototype._runCallbacks = function (event, args) {
	        var self = this;
	        var callbacks = (self._callbacks[event] || []).slice();
	        var cb = callbacks.pop();
	        while (cb) {
	            cb.apply(self, args);
	            cb = callbacks.pop();
	        }
	    };
	
	    window.XMLHttpRequest.prototype.addEventListener = function (event, callback) {
	        var self = this;
	        this._callbacks[event] = this._callbacks[event] || [];
	        this._callbacks[event].push(callback);
	    };
	
	    window.XMLHttpRequest.prototype.open = function (method, url, async) {
	        var self = this;
	        var request;
	
	        if (useXDR(method, url, async)) {
	
	            // Use XDR
	            request = new XDomainRequest();
	            request._xdr = true;
	            request.onerror = function () {
	                self.status = 400;
	                self.statusText = "Error";
	                self._setReadyState(4);
	                if (self.onerror) {
	                    self.onerror();
	                    self._runCallbacks('error');
	                }
	            };
	            request.ontimeout = function () {
	                self.status = 408;
	                self.statusText = "Timeout";
	                self._setReadyState(2);
	                if (self.ontimeout) {
	                    self.ontimeout();
	                }
	                self._runCallbacks('timeout');
	            };
	            request.onload = function () {
	                self.responseText = request.responseText;
	                self.status = 200;
	                self.statusText = "OK";
	                self._setReadyState(4);
	                if (self.onload) {
	                    self.onload();
	                }
	                self._runCallbacks('load', [].slice.call(arguments));
	            };
	            request.onprogress = function () {
	                if (self.onprogress) {
	                    self.onprogress.apply(self, arguments);
	                }
	                self._runCallbacks('progress', [].slice.call(arguments));
	            };
	        } else {
	
	            // Use standard XHR
	            request = new OriginalXMLHttpRequest();
	            request.withCredentials = this.withCredentials;
	            request.onreadystatechange = function () {
	                if (request.readyState === 4) {
	                    try {
	                        self.status = request.status;
	                        self.statusText = request.statusText;
	                        self.responseText = request.responseText;
	                        self.responseXML = request.responseXML;
	                    } catch (e) {}
	                }
	                self._setReadyState(request.readyState);
	            };
	            request.onabort = function () {
	                if (self.onabort) {
	                    self.onabort.apply(self, arguments);
	                }
	            };
	            request.onerror = function () {
	                if (self.onerror) {
	                    self.onerror.apply(self, arguments);
	                }
	            };
	            request.onload = function () {
	                if (self.onload) {
	                    self.onload.apply(self, arguments);
	                }
	            };
	            request.onloadend = function () {
	                if (self.onloadend) {
	                    self.onloadend.apply(self, arguments);
	                }
	            };
	            request.onloadstart = function () {
	                if (self.onloadstart) {
	                    self.onloadstart.apply(self, arguments);
	                }
	            };
	            request.onprogress = function () {
	                if (self.onprogress) {
	                    self.onprogress.apply(self, arguments);
	                }
	            };
	        }
	
	        this._request = request;
	        request.open.apply(request, arguments);
	        this._setReadyState(1);
	    };
	
	    window.XMLHttpRequest.prototype.abort = function () {
	        this._request.abort();
	        this._setReadyState(0);
	        this.onreadystatechange = null;
	    };
	
	    window.XMLHttpRequest.prototype.send = function (body) {
	        var self = this;
	        this._request.withCredentials = this.withCredentials;
	
	        if (this._request._xdr) {
	            setTimeout(function () {
	                self._request.send(body);
	            }, 0);
	        } else {
	            this._request.send(body);
	        }
	
	        if (this._request.readyState === 4) {
	            // when async==false the browser is blocked until the transfer is complete and readyState becomes 4
	            // onreadystatechange should not get called in this case
	            this.status = this._request.status;
	            this.statusText = this._request.statusText;
	            this.responseText = this._request.responseText;
	            this.readyState = this._request.readyState;
	        } else {
	            this._setReadyState(2);
	        }
	    };
	
	    window.XMLHttpRequest.prototype.setRequestHeader = function () {
	        if (this._request.setRequestHeader) {
	            this._request.setRequestHeader.apply(this._request, arguments);
	        }
	    };
	
	    window.XMLHttpRequest.prototype.getAllResponseHeaders = function () {
	        if (this._request.getAllResponseHeaders) {
	            return this._request.getAllResponseHeaders();
	        } else {
	            return "Content-Length: " + this.responseText.length + "\r\nContent-Type:" + this._request.contentType;
	        }
	    };
	
	    window.XMLHttpRequest.prototype.getResponseHeader = function (header) {
	        if (this._request.getResponseHeader) {
	            return this._request.getResponseHeader.apply(this._request, arguments);
	        }
	        if (typeof header !== "string") {
	            return;
	        }
	        header = header.toLowerCase();
	        if (header === "content-type") {
	            return this._request.contentType;
	        } else if (header === "content-length") {
	            return this.responseText.length;
	        }
	    };
	
	    window.XMLHttpRequest.supportsXDR = true;
	})();

/***/ },
/* 88 */
/*!*********************************!*\
  !*** ./src/utils/dom-events.js ***!
  \*********************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	
	function addEvent(node, eventName, handler) {
	  if (node.attachEvent) {
	    node.attachEvent('on' + eventName, handler);
	  } else {
	    node.addEventListener(eventName, handler, false);
	  }
	}
	
	function removeEvent(node, eventName, handler) {
	  if (node.detachEvent) {
	    node.detachEvent('on' + eventName, handler);
	  } else {
	    node.removeEventListener(eventName, handler, false);
	  }
	}

/***/ },
/* 89 */
/*!*************************************!*\
  !*** ./src/utils/empty-function.js ***!
  \*************************************/
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function emptyFunction() {}
	
	exports['default'] = emptyFunction;
	module.exports = exports['default'];

/***/ },
/* 90 */
/*!*****************************************!*\
  !*** ./src/utils/get-current-script.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _lodash = __webpack_require__(/*! ./lodash */ 1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var URL_REGEX = /(data:text\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\/\/[\/]?.+?\/[^:\)]*?)(?::\d+)(?::\d+)?/;
	
	function getErrorStack() {
	  var e = new Error();
	  var stack = e.stack;
	  if (typeof stack !== 'string' || !stack) {
	    try {
	      throw e;
	    } catch (err) {
	      stack = err.stack;
	    }
	  }
	  return stack;
	}
	function getUrlFromStack() {
	  var stack = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
	
	  var lines = stack.split('\n');
	  var urls = _lodash2["default"].reduce(lines, function (u, line) {
	    var t = line.match(URL_REGEX);
	    if (t) {
	      u.push(t[1]);
	    }
	    return u;
	  }, []);
	  // Eliminate Hull.js from the stack, get next closest URL
	  return _lodash2["default"].uniq(urls)[1];
	}
	function getCurrentScriptFromUrl(url, scripts) {
	  var i,
	      script = null;
	
	  if (typeof url === "string" && url) {
	    for (i = scripts.length; i--;) {
	      if (scripts[i].src === url) {
	        script = scripts[i];
	        break;
	      }
	    }
	  }
	  return script;
	}
	function getCurrentScript() {
	  var scripts = document.getElementsByTagName("script");
	  var stack = getErrorStack();
	  var url = getUrlFromStack(stack);
	  return getCurrentScriptFromUrl(url, scripts);
	}
	
	module.exports = getCurrentScript;

/***/ },
/* 91 */
/*!****************************!*\
  !*** ./src/utils/utils.js ***!
  \****************************/
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = {
	  cookies: __webpack_require__(/*! cookies-js */ 62),
	  eventemitter2: __webpack_require__(/*! eventemitter2 */ 63),
	  assign: __webpack_require__(/*! ../polyfills/assign */ 2),
	  _: __webpack_require__(/*! ./lodash */ 1),
	  isMobile: __webpack_require__(/*! ./is-mobile */ 59),
	  uuid: __webpack_require__(/*! ./uuid */ 92),
	  domready: __webpack_require__(/*! ./domready */ 52),
	  Promise: __webpack_require__(/*! ./promises */ 3),
	  superagent: __webpack_require__(/*! superagent */ 22)
	};

/***/ },
/* 92 */
/*!***************************!*\
  !*** ./src/utils/uuid.js ***!
  \***************************/
/***/ function(module, exports) {

	"use strict";
	/*global module*/
	
	// Private array of chars to use
	var CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
	
	var uuid = function uuid(len, radix) {
	  var chars = CHARS,
	      uu = [],
	      i;
	  radix = radix || chars.length;
	
	  if (len) {
	    // Compact form
	    for (i = 0; i < len; i++) {
	      uu[i] = chars[0 | Math.random() * radix];
	    }
	  } else {
	    // rfc4122, version 4 form
	    var r;
	
	    // rfc4122 requires these characters
	    uu[8] = uu[13] = uu[18] = uu[23] = "-";
	    uu[14] = "4";
	
	    // Fill in random data.  At i==19 set the high bits of clock sequence as
	    // per rfc4122, sec. 4.1.5
	    for (i = 0; i < 36; i++) {
	      if (!uu[i]) {
	        r = 0 | Math.random() * 16;
	        uu[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
	      }
	    }
	  }
	
	  return uu.join("");
	};
	
	// A more performant, but slightly bulkier, RFC4122v4 solution.  We boost performance
	// by minimizing calls to random()
	var uuidFast = function uuidFast() {
	  var chars = CHARS,
	      uu = new Array(36),
	      rnd = 0,
	      r;
	  for (var i = 0; i < 36; i++) {
	    if (i === 8 || i === 13 || i === 18 || i === 23) {
	      uu[i] = "-";
	    } else if (i === 14) {
	      uu[i] = "4";
	    } else {
	      if (rnd <= 0x02) {
	        rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
	      }
	      r = rnd & 0xf;
	      rnd = rnd >> 4;
	      uu[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
	    }
	  }
	  return uu.join("");
	};
	
	// A more compact, but less performant, RFC4122v4 solution:
	var uuidCompact = function uuidCompact() {
	  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0,
	        v = c === "x" ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	};
	
	module.exports = { uuid: uuid, uuidFast: uuidFast, uuidCompact: uuidCompact };

/***/ },
/* 93 */
/*!************************************************!*\
  !*** ./~/bluebird/js/browser/bluebird.core.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 3.3.3
	 * Features enabled: core
	 * Features disabled: race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule");
	var Queue = _dereq_("./queue");
	var util = _dereq_("./util");
	
	function Async() {
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	},{"./queue":17,"./schedule":18,"./util":21}],2:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};
	
	},{}],3:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise":15}],4:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise.isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent.isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this.isCancellable()) return;
	
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this.isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};
	
	},{"./util":21}],5:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util");
	var getKeys = _dereq_("./es5").keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};
	
	},{"./es5":10,"./util":21}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};
	
	},{}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = _dereq_("./errors").Warning;
	var util = _dereq_("./util");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (true ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        var event = document.createEvent("CustomEvent");
	        event.initCustomEvent("testingtheevent", false, true, {});
	        util.global.dispatchEvent(event);
	        return function(name, event) {
	            var domEvent = document.createEvent("CustomEvent");
	            domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
	            return !util.global.dispatchEvent(domEvent);
	        };
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this.isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	
	        if (name) name = name + " ";
	        var msg = "a promise was created in a " + name +
	            "handler but was not returned from it";
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	},{"./errors":9,"./util":21}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};
	
	},{}],9:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5":10,"./util":21}],10:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],11:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, tryConvertToPromise) {
	var util = _dereq_("./util");
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise.isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	return PassThroughHandlerContext;
	};
	
	},{"./util":21}],12:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise) {           \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    promise._pushContext();                                  \n\
	                    var callback = this.fn;                                  \n\
	                    var ret = tryCatch(callback)([ThePassedArguments]);      \n\
	                    promise._popContext();                                   \n\
	                    if (ret === errorObj) {                                  \n\
	                        promise._rejectCallback(ret.e, false);               \n\
	                    } else {                                                 \n\
	                        promise._resolveCallback(ret);                       \n\
	                    }                                                        \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise);                                      \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", code)
	                           (tryCatch, errorObj, Promise);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                if (!ret._isFateSealed()) {
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var args = [].slice.call(arguments);;
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util":21}],13:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = _dereq_("./util");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util":21}],14:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors");
	var OperationalError = errors.OperationalError;
	var es5 = _dereq_("./es5");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var args = [].slice.call(arguments, 1);;
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;
	
	},{"./errors":9,"./es5":10,"./util":21}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = _dereq_("./util");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = _dereq_("./es5");
	var Async = _dereq_("./async");
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = _dereq_("./errors");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array")(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = _dereq_("./context")(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = _dereq_("./debuggability")(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    _dereq_("./finally")(Promise, tryConvertToPromise);
	var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);
	var nodebackForPromise = _dereq_("./nodeback");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	    if (self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	}
	
	function Promise(executor) {
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    if (executor !== INTERNAL) {
	        check(this, executor);
	        this._resolveFromExecutor(executor);
	    }
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    var prev = async._schedule;
	    async._schedule = fn;
	    return prev;
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" && domain.bind(handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	_dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);
	_dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);
	_dereq_("./direct_resolve")(Promise);
	_dereq_("./synchronous_inspection")(Promise);
	_dereq_("./join")(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, debug);
	Promise.Promise = Promise;
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	},{"./async":1,"./bind":2,"./cancel":4,"./catch_filter":5,"./context":6,"./debuggability":7,"./direct_resolve":8,"./errors":9,"./es5":10,"./finally":11,"./join":12,"./method":13,"./nodeback":14,"./promise_array":16,"./synchronous_inspection":19,"./thenables":20,"./util":21}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = _dereq_("./util");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise.isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util":21}],17:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],18:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util");
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	          toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	          toggleScheduled = true;
	          div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	          var o = new MutationObserver(function() {
	            o.disconnect();
	            fn();
	          });
	          o.observe(div, opts);
	          scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":21}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled =
	Promise.prototype._isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype.isCancelled = function() {
	    return this._target()._isCancelled();
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],20:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    return hasProp.call(obj, "_promise0");
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util":21}],21:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5");
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string";
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	function env(key, def) {
	    return isNode ? ({"NODE_ENV":"production"})[key] : def;
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    env: env,
	    global: globalObject
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5":10}]},{},[3])(3)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! (webpack)/~/node-libs-browser/~/process/browser.js */ 82), (function() { return this; }()), __webpack_require__(/*! (webpack)/~/node-libs-browser/~/timers-browserify/main.js */ 49).setImmediate))

/***/ },
/* 94 */
/*!**************************************!*\
  !*** ./~/browser-jsonp/lib/jsonp.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	  var JSONP, computedUrl, createElement, encode, noop, objectToURI, random, randomString;
	
	  createElement = function(tag) {
	    return window.document.createElement(tag);
	  };
	
	  encode = window.encodeURIComponent;
	
	  random = Math.random;
	
	  JSONP = function(options) {
	    var callback, callbackFunc, callbackName, done, head, params, script;
	    options = options ? options : {};
	    params = {
	      data: options.data || {},
	      error: options.error || noop,
	      success: options.success || noop,
	      beforeSend: options.beforeSend || noop,
	      complete: options.complete || noop,
	      url: options.url || ''
	    };
	    params.computedUrl = computedUrl(params);
	    if (params.url.length === 0) {
	      throw new Error('MissingUrl');
	    }
	    done = false;
	    if (params.beforeSend({}, params) !== false) {
	      callbackName = options.callbackName || 'callback';
	      callbackFunc = options.callbackFunc || 'jsonp_' + randomString(15);
	      callback = params.data[callbackName] = callbackFunc;
	      window[callback] = function(data) {
	        window[callback] = null;
	        params.success(data, params);
	        return params.complete(data, params);
	      };
	      script = createElement('script');
	      script.src = computedUrl(params);
	      script.async = true;
	      script.onerror = function(evt) {
	        params.error({
	          url: script.src,
	          event: evt
	        });
	        return params.complete({
	          url: script.src,
	          event: evt
	        }, params);
	      };
	      script.onload = script.onreadystatechange = function() {
	        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
	          done = true;
	          script.onload = script.onreadystatechange = null;
	          if (script && script.parentNode) {
	            script.parentNode.removeChild(script);
	          }
	          return script = null;
	        }
	      };
	      head = head || window.document.getElementsByTagName('head')[0] || window.document.documentElement;
	      head.insertBefore(script, head.firstChild);
	    }
	    return {
	      abort: function() {
	        window[callback] = function() {
	          return window[callback] = null;
	        };
	        done = true;
	        if (script && script.parentNode) {
	          script.onload = script.onreadystatechange = null;
	          if (script && script.parentNode) {
	            script.parentNode.removeChild(script);
	          }
	          return script = null;
	        }
	      }
	    };
	  };
	
	  noop = function() {
	    return void 0;
	  };
	
	  computedUrl = function(params) {
	    var url;
	    url = params.url;
	    url += params.url.indexOf('?') < 0 ? '?' : '&';
	    url += objectToURI(params.data);
	    return url;
	  };
	
	  randomString = function(length) {
	    var str;
	    str = '';
	    while (str.length < length) {
	      str += random().toString(36)[2];
	    }
	    return str;
	  };
	
	  objectToURI = function(obj) {
	    var data, key, value;
	    data = [];
	    for (key in obj) {
	      value = obj[key];
	      data.push(encode(key) + '=' + encode(value));
	    }
	    return data.join('&');
	  };
	
	  if (("function" !== "undefined" && __webpack_require__(/*! !webpack amd define */ 225) !== null) && __webpack_require__(/*! !webpack amd options */ 226)) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return JSONP;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module !== "undefined" && module !== null) && module.exports) {
	    module.exports = JSONP;
	  } else {
	    this.JSONP = JSONP;
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../webpack/buildin/module.js */ 227)(module)))

/***/ },
/* 95 */
/*!********************************!*\
  !*** ./src/client/auth.coffee ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	var Auth, EventBus, Promise, _, assign, getNoUserPromise, getUser, isMobile, logger, parseParams, postForm,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 2);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	isMobile = __webpack_require__(/*! ../utils/is-mobile */ 59);
	
	getNoUserPromise = function() {
	  return Promise.reject({
	    reason: 'no_current_user',
	    message: 'User must be logged in to perform this action'
	  });
	};
	
	getUser = function() {
	  var user;
	  user = Hull.currentUser();
	  return !!user && (user.id != null);
	};
	
	parseParams = function(argsArray) {
	  var base, base1, callback, errback, login, next, opts, password;
	  opts = {};
	  while ((next = argsArray.shift())) {
	    if (_.isString(next)) {
	      if (!login) {
	        login = next;
	      } else {
	        password = next;
	      }
	    } else if (_.isFunction(next)) {
	      if (!callback) {
	        callback = next;
	      } else {
	        errback = next;
	      }
	    } else if (_.isObject(next) && !_.isEmpty(next)) {
	      if (!login && !password) {
	        opts = next;
	      } else {
	        opts.params = assign(next, opts.params || {});
	      }
	    }
	  }
	  if (login) {
	    opts = password ? assign(opts, {
	      login: login,
	      password: password
	    }) : assign(opts, {
	      provider: login
	    });
	  }
	  opts.params = opts.params || {};
	  callback = callback || function() {};
	  errback = errback || function() {};
	  if (isMobile()) {
	    (base = opts.params).display || (base.display = 'touch');
	  }
	  if (opts.provider === 'facebook') {
	    (base1 = opts.params).display || (base1.display = opts.strategy === 'redirect' ? 'page' : 'popup');
	  }
	  if (opts.password != null) {
	    delete opts.params;
	  }
	  return {
	    options: opts,
	    callback: callback,
	    errback: errback
	  };
	};
	
	postForm = function(path, method, params) {
	  var form, hiddenField, key;
	  if (method == null) {
	    method = 'post';
	  }
	  if (params == null) {
	    params = {};
	  }
	  form = document.createElement("form");
	  form.setAttribute("method", method);
	  form.setAttribute("action", path);
	  for (key in params) {
	    if (params.hasOwnProperty(key)) {
	      hiddenField = document.createElement("input");
	      hiddenField.setAttribute("type", "hidden");
	      hiddenField.setAttribute("name", key);
	      hiddenField.setAttribute("value", params[key]);
	      form.appendChild(hiddenField);
	    }
	  }
	  document.body.appendChild(form);
	  return form.submit();
	};
	
	Auth = (function() {
	  function Auth(api, currentUser, currentConfig) {
	    this.completeLoginPromiseChain = bind(this.completeLoginPromiseChain, this);
	    this.unlinkIdentity = bind(this.unlinkIdentity, this);
	    this.linkIdentity = bind(this.linkIdentity, this);
	    this.signup = bind(this.signup, this);
	    this.confirmEmail = bind(this.confirmEmail, this);
	    this.resetPassword = bind(this.resetPassword, this);
	    this.logout = bind(this.logout, this);
	    this.login = bind(this.login, this);
	    this.loginWithProvider = bind(this.loginWithProvider, this);
	    this.onAuthComplete = bind(this.onAuthComplete, this);
	    this.createAuthCallback = bind(this.createAuthCallback, this);
	    this.api = api;
	    this.currentUser = currentUser;
	    this.currentConfig = currentConfig;
	    this._popupInterval = null;
	    this._authenticating = null;
	    this.authServices = _.keys(this.currentConfig.get('services.auth'));
	  }
	
	  Auth.prototype.isAuthenticating = function() {
	    return this._authenticating != null;
	  };
	
	  Auth.prototype.generateAuthUrl = function(opts) {
	    var params, querystring;
	    if (opts == null) {
	      opts = {};
	    }
	    this.createAuthCallback();
	    params = opts.params || {};
	    params.app_id = this.currentConfig.get('appId');
	    params.callback_url = opts.redirect_url || params.callback_url || this.currentConfig.get('callback_url') || this.currentConfig.get('callbackUrl') || document.location.toString();
	    params.auth_referer = document.location.toString();
	    params.version = this.currentConfig.get('version');
	    params._bid = this.currentConfig.identifyBrowser().id;
	    params._sid = this.currentConfig.identifySession().id;
	    querystring = _.map(params, function(v, k) {
	      return encodeURIComponent(k) + '=' + encodeURIComponent(v);
	    }).join('&');
	    return (this.currentConfig.get('orgUrl')) + "/auth/" + opts.provider + "?" + querystring;
	  };
	
	  Auth.prototype.createAuthCallback = function() {
	    return window.__hull_login_status__ = (function(_this) {
	      return function(hash) {
	        window.__hull_login_status__ = null;
	        return _this.onAuthComplete(hash);
	      };
	    })(this);
	  };
	
	  Auth.prototype.popupAuthWindow = function(path, opts) {
	    var height, openerString, ref, ref1, w, width;
	    if (opts == null) {
	      opts = {};
	    }
	    ref = opts.provider === 'facebook' && opts.params.display === 'popup' ? [500, 400] : [1030, 550], width = ref[0], height = ref[1];
	    openerString = "location=0,status=0,width=" + width + ",height=" + height;
	    w = window.open(path, "_auth", openerString);
	    if ((ref1 = window.device) != null ? ref1.cordova : void 0) {
	      if (w != null) {
	        w.addEventListener('loadstart', function(event) {
	          var hash;
	          hash = (function() {
	            try {
	              return JSON.parse(Base64.decode(event.url.split('#')[1]));
	            } catch (undefined) {}
	          })();
	          if (hash) {
	            window.__hull_login_status__(hash);
	            return w.close();
	          }
	        });
	      }
	    }
	    setTimeout((function(_this) {
	      return function() {
	        return _this.onAuthComplete({
	          success: false,
	          error: {
	            reason: 'timeout',
	            message: 'Timeout for login (after 30 seconds), User never finished the auth'
	          }
	        });
	      };
	    })(this), 90000);
	    return this._popupInterval = (w != null) && setInterval((function(_this) {
	      return function() {
	        if (w != null ? w.closed : void 0) {
	          return _this.onAuthComplete({
	            success: false,
	            error: {
	              reason: 'window_closed',
	              message: 'User closed the window before finishing. He might have canceled'
	            }
	          });
	        }
	      };
	    })(this), 200);
	  };
	
	  Auth.prototype.onAuthComplete = function(hash) {
	    var error, k, ref, ref1, v;
	    if (!this._authenticating) {
	      return;
	    }
	    if (hash.success) {
	      this._authenticating.resolve({});
	    } else {
	      error = new Error("Login failed : " + (hash != null ? (ref = hash.error) != null ? ref.reason : void 0 : void 0));
	      ref1 = hash.error;
	      for (k in ref1) {
	        v = ref1[k];
	        error[k] = v;
	      }
	      this._authenticating.reject(error);
	    }
	    this._authenticating = null;
	    clearInterval(this._popupInterval);
	    this._popupInterval = null;
	    return void 0;
	  };
	
	  Auth.prototype.loginWithProvider = function(opts) {
	    var authUrl, isAuthenticating, promise;
	    isAuthenticating = this.isAuthenticating();
	    if (isAuthenticating) {
	      return isAuthenticating;
	    }
	    this._authenticating = {};
	    promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this._authenticating.resolve = resolve;
	        return _this._authenticating.reject = reject;
	      };
	    })(this));
	    if (!~(_.indexOf(this.authServices, opts.provider))) {
	      this._authenticating.reject({
	        message: "No authentication service " + opts.provider + " configured for the app",
	        reason: 'no_such_service'
	      });
	      return promise;
	    }
	    this._authenticating.provider = opts.provider.toLowerCase();
	    authUrl = this.generateAuthUrl(opts);
	    if (opts.strategy === 'redirect') {
	      window.location.href = authUrl;
	    } else {
	      this.popupAuthWindow(authUrl, opts);
	    }
	    return promise;
	  };
	
	  Auth.prototype.login = function() {
	    var callback, errback, msg, op, options, postUrl, promise, provider, ref;
	    if (this.isAuthenticating()) {
	      msg = "Login in progress. Use `Hull.on('hull.user.login', callback)` to call `callback` when done.";
	      logger.info(msg);
	      return Promise.reject({
	        error: {
	          reason: 'in_progress',
	          message: 'Login already in progress'
	        }
	      });
	    }
	    ref = parseParams(Array.prototype.slice.call(arguments)), options = ref.options, callback = ref.callback, errback = ref.errback;
	    if (!(((options != null ? options.provider : void 0) != null) || (options.login != null) || (options.access_token != null))) {
	      if (!((options.login != null) && (options.password != null))) {
	        msg = 'Seems like something is wrong in your Hull.login() call, We need a login and password fields to login. Read up here: http://www.hull.io/docs/references/hull_js/#user-signup-and-login';
	        logger.warn(msg);
	        return Promise.reject({
	          error: {
	            reason: 'missing_parameters',
	            message: 'Empty login or password'
	          }
	        });
	      }
	    }
	    if (options.provider != null) {
	      if (options.access_token != null) {
	        provider = assign({}, options);
	        delete provider.provider;
	        op = {};
	        op[options.provider] = provider;
	        promise = this.api.message('users', 'post', op);
	      } else {
	        promise = this.loginWithProvider(options);
	      }
	    } else {
	      promise = this.api.message('users/login', 'post', _.pick(options, 'login', 'password', 'access_token'));
	      if (options.strategy === 'redirect' || !this.currentConfig.getRemote('cookiesEnabled')) {
	        postUrl = this.currentConfig.get('orgUrl') + '/api/v1/users/login';
	        options.redirect_url || (options.redirect_url = window.location.href);
	        promise = promise.then(function() {
	          return postForm(postUrl, 'post', options);
	        });
	      }
	    }
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.logout = function(options, callback, errback) {
	    var b, logoutUrl, promise, redirect_url;
	    if (options == null) {
	      options = {};
	    }
	    this.currentConfig.resetIdentify();
	    this.api.channel.rpc.resetIdentify();
	    promise = this.api.message('logout');
	    if (options.strategy === 'redirect' || !this.currentConfig.getRemote('cookiesEnabled')) {
	      redirect_url = options.redirect_url || document.location.href;
	      b = new Date().getTime();
	      logoutUrl = this.currentConfig.get('orgUrl') + '/api/v1/logout?b=' + b + '&redirect_url=' + encodeURIComponent(redirect_url);
	      promise.then(function() {
	        return document.location = logoutUrl;
	      });
	    }
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.resetPassword = function(email, callback, errback) {
	    var promise;
	    if (email == null) {
	      email = this.currentUser.get('email');
	    }
	    promise = this.api.message('/users/request_password_reset', 'post', {
	      email: email
	    });
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.confirmEmail = function(email, callback, errback) {
	    var promise;
	    if (email == null) {
	      email = this.currentUser.get('email');
	    }
	    promise = this.api.message('/users/request_confirmation_email', 'post', {
	      email: email
	    });
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.signup = function(attrs, callback, errback) {
	    var postUrl, promise;
	    promise = this.api.message('users', 'POST', attrs);
	    if (!this.currentConfig.getRemote('cookiesEnabled')) {
	      postUrl = this.currentConfig.get('orgUrl') + '/api/v1/users/login';
	      promise = promise.then(function(user) {
	        var params;
	        params = {
	          redirect_url: window.location.href,
	          access_token: user.access_token
	        };
	        return postForm(postUrl, 'post', params);
	      });
	    }
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	
	  /**
	   * link an Identity to a Hull User
	   * @param  {options} An options Hash
	   * @param  {callback} Success callback
	   * @param  {errback} error callback
	   * @return {Promise} A promise
	   */
	
	  Auth.prototype.linkIdentity = function() {
	    var callback, errback, options, ref;
	    if (!getUser()) {
	      return getNoUserPromise();
	    }
	    ref = parseParams(Array.prototype.slice.call(arguments)), options = ref.options, callback = ref.callback, errback = ref.errback;
	    options.params.mode = 'connect';
	    return this.login(options, callback, errback);
	  };
	
	
	  /**
	   * unlink an Identity from a Hull User
	   * @param  {options} An options Hash
	   * @param  {callback} Success callback
	   * @param  {errback} error callback
	   * @return {Promise} A promise
	   *
	   */
	
	  Auth.prototype.unlinkIdentity = function() {
	    var callback, errback, options, promise, ref;
	    if (!getUser()) {
	      return getNoUserPromise();
	    }
	    ref = parseParams(Array.prototype.slice.call(arguments)), options = ref.options, callback = ref.callback, errback = ref.errback;
	    promise = this.api.message("me/identities/" + options.provider, 'delete');
	    return this.completeLoginPromiseChain(promise, callback, errback);
	  };
	
	  Auth.prototype.completeLoginPromiseChain = function(promise, callback, errback) {
	    var p;
	    if (promise && promise.then) {
	      callback = callback || function() {};
	      errback = errback || function() {};
	      p = promise.then(this.api.refreshUser, this.emitLoginFailure);
	      p.then(callback, errback);
	      return p;
	    }
	  };
	
	  Auth.prototype.emitLoginFailure = function(err) {
	    EventBus.emit("hull.user.fail", err);
	    err;
	    throw err;
	  };
	
	  return Auth;
	
	})();
	
	module.exports = Auth;


/***/ },
/* 96 */
/*!******************************************!*\
  !*** ./src/client/current-config.coffee ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var Base64, CurrentConfig, EventBus, Promise, _, assign, checkConfig, clone, extractDomainFromUrl, extractUtmTags, formatTrackConfig, getKey, getReferralContext, getRemoteUrl, localstorage, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	localstorage = __webpack_require__(/*! putainde-localstorage */ 217);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	clone = __webpack_require__(/*! ../utils/clone */ 9);
	
	throwErr = __webpack_require__(/*! ../utils/throw */ 12);
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 18);
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 2);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	getKey = __webpack_require__(/*! ../utils/get-key */ 58);
	
	getReferralContext = function() {
	  return {
	    initial_url: document.location.href,
	    initial_referrer: document.referrer || '$direct',
	    initial_referring_domain: extractDomainFromUrl(document.referrer) || '$direct',
	    initial_utm_tags: extractUtmTags(),
	    first_seen_at: new Date().getTime()
	  };
	};
	
	getRemoteUrl = function(config, identifiers) {
	  var url;
	  url = config.orgUrl + "/api/v1/" + config.appId + "/remote.html?v=" + ("0.9.0");
	  url += "&r=" + (encodeURIComponent(document.referrer));
	  if (config.jsUrl) {
	    url += "&js=" + config.jsUrl;
	  }
	  if (config.uid) {
	    url += "&uid=" + config.uid;
	  }
	  if (config.debugRemote) {
	    url += "&debug_remote=true";
	  }
	  if (config.accessToken != null) {
	    url += "&access_token=" + config.accessToken;
	  }
	  if (config.userHash !== void 0) {
	    url += "&user_hash=" + config.userHash;
	  }
	  if (identifiers != null ? identifiers.bid : void 0) {
	    url += "&_bid=" + identifiers.bid;
	  }
	  if (identifiers != null ? identifiers.sid : void 0) {
	    url += "&_sid=" + identifiers.sid;
	  }
	  if (config.ravenDsn) {
	    url += "&ravenDsn=" + config.ravenDsn;
	  }
	  return url;
	};
	
	formatTrackConfig = function(config) {
	  var m;
	  if (config == null) {
	    config = {};
	  }
	  switch ((Object.prototype.toString.call(config).match(/^\[object (.*)\]$/)[1])) {
	    case "Object":
	      if (config.only != null) {
	        config = {
	          only: (function() {
	            var i, len, ref, results;
	            ref = config.only;
	            results = [];
	            for (i = 0, len = ref.length; i < len; i++) {
	              m = ref[i];
	              results.push(m.toString());
	            }
	            return results;
	          })()
	        };
	      } else if (config.ignore != null) {
	        config = {
	          ignore: (function() {
	            var i, len, ref, results;
	            ref = config.ignore;
	            results = [];
	            for (i = 0, len = ref.length; i < len; i++) {
	              m = ref[i];
	              results.push(m.toString());
	            }
	            return results;
	          })()
	        };
	      } else {
	        config;
	      }
	      break;
	    case "RegExp":
	      config = {
	        only: config.toString()
	      };
	      break;
	    case "Array":
	      config = {
	        only: (function() {
	          var i, len, results;
	          results = [];
	          for (i = 0, len = config.length; i < len; i++) {
	            m = config[i];
	            results.push(m.toString());
	          }
	          return results;
	        })()
	      };
	  }
	  if (typeof document !== "undefined" && document !== null ? document.referrer : void 0) {
	    config.referrer = document.referrer;
	  }
	  return config;
	};
	
	checkConfig = function(config) {
	  var promise;
	  config = clone(config);
	  config.track = formatTrackConfig(config.track);
	  promise = new Promise((function(_this) {
	    return function(resolve, reject) {
	      var msg, readMore;
	      msg = "You need to pass some keys to Hull to start it: ";
	      readMore = "Read more about this here : http://www.hull.io/docs/references/hull_js/#hull-init-params-cb-errb";
	      if (config.orgUrl && config.appId) {
	        if (config.orgUrl.match(/^\/\//)) {
	          reject(new Error(" You specified orgUrl as " + config.orgUrl + ". We do not support protocol-relative URLs in organization URLs yet."));
	        }
	        if (!config.orgUrl.match(/^http[s]?:\/\//)) {
	          config.orgUrl = "https://" + config.orgUrl;
	        }
	        return resolve(config);
	      } else {
	        if (!config.orgUrl) {
	          reject(new Error(msg + " We couldn't find `orgUrl` in the config object you passed to `Hull.init`\n " + readMore));
	        }
	        if (!config.appId) {
	          return reject(new Error(msg + " We couldn't find `platformId` in the config object you passed to `Hull.init`\n " + readMore));
	        }
	      }
	    };
	  })(this));
	  promise.then(null, throwErr);
	  return promise;
	};
	
	extractDomainFromUrl = function(url) {
	  var u;
	  if (!(url && url.length)) {
	    return;
	  }
	  u = url.match(/^(https?:\/\/)?([\da-z\.-]+)([\/\w \.-]*)*\/?/);
	  if (u) {
	    return u[2];
	  }
	};
	
	extractUtmTags = function() {
	  return _.reduce(document.location.search.slice(1).split('&'), function(tags, t) {
	    var k, ref, v;
	    ref = t.split('=', 2), k = ref[0], v = ref[1];
	    if (/^utm_/.test(k)) {
	      tags[k.replace(/^utm_/, '')] = v;
	    }
	    return tags;
	  }, {});
	};
	
	CurrentConfig = (function() {
	  function CurrentConfig() {
	    this.onUpdate = bind(this.onUpdate, this);
	    this.identify = bind(this.identify, this);
	    this.storageGet = bind(this.storageGet, this);
	    this.storageSet = bind(this.storageSet, this);
	    this.identifyBrowser = bind(this.identifyBrowser, this);
	    this.identifySession = bind(this.identifySession, this);
	    this.getRemoteUrl = bind(this.getRemoteUrl, this);
	    this.get = bind(this.get, this);
	  }
	
	  CurrentConfig.prototype.init = function(config) {
	    this._remoteConfig = {};
	    this._clientConfig = {};
	    return checkConfig(config).then((function(_this) {
	      return function(config) {
	        var ns, org;
	        org = extractDomainFromUrl(config.orgUrl);
	        ns = ['hull'].concat(org.split('.')).join('_');
	        _this.storage = localstorage.create({
	          namespace: ns
	        });
	        _this._clientConfig = config;
	        return _this;
	      };
	    })(this), throwErr);
	  };
	
	  CurrentConfig.prototype.initRemote = function(cfg) {
	    if (cfg == null) {
	      cfg = {};
	    }
	    this.identifyBrowser(cfg.identify.browser, {
	      count: true
	    });
	    this.identifySession(cfg.identify.session, {
	      count: true
	    });
	    return this._remoteConfig = cfg;
	  };
	
	  CurrentConfig.prototype.set = function(config, key) {
	    if (key != null) {
	      return this._clientConfig[key] = config;
	    } else {
	      return this._clientConfig = config;
	    }
	  };
	
	  CurrentConfig.prototype.setSettings = function() {};
	
	  CurrentConfig.prototype.setRemote = function(hash, key) {
	    var previousConfig;
	    if (key) {
	      previousConfig = this._remoteConfig[key];
	      this._remoteConfig[key] = assign({}, this._remoteConfig[key], hash);
	    } else {
	      previousConfig = this._remoteConfig;
	      this._remoteConfig = assign({}, this._remoteConfig, hash);
	    }
	    if (!_.isEqual(previousConfig, hash)) {
	      return this.onUpdate();
	    }
	  };
	
	  CurrentConfig.prototype.get = function(key) {
	    var hash;
	    hash = clone(this._clientConfig);
	    hash.services = clone(this._remoteConfig.services);
	    return getKey(hash, key);
	  };
	
	  CurrentConfig.prototype.getRemote = function(key) {
	    return getKey(this._remoteConfig, key);
	  };
	
	  CurrentConfig.prototype.getRemoteUrl = function() {
	    var browser, session;
	    browser = this.identifyBrowser(this._clientConfig.anonymousId || this._clientConfig.browserId);
	    session = this.identifySession(this._clientConfig.sessionId);
	    return getRemoteUrl(this._clientConfig, {
	      bid: browser.id,
	      sid: session.id
	    });
	  };
	
	  CurrentConfig.prototype.identifySession = function(id, options) {
	    var session;
	    if (options == null) {
	      options = {};
	    }
	    session = this.identify('session', id, assign({}, options, {
	      expires: 60 * 1000 * 30
	    }));
	    this._clientConfig.sessionId = session.id;
	    return session;
	  };
	
	  CurrentConfig.prototype.identifyBrowser = function(id, options) {
	    var browser;
	    if (options == null) {
	      options = {};
	    }
	    browser = this.identify('browser', id, options);
	    this._clientConfig.browserId = browser.id;
	    this._clientConfig.anonymousId = browser.id;
	    return browser;
	  };
	
	  CurrentConfig.prototype.storageSet = function(key, value) {
	    var e, error;
	    try {
	      return this.storage.set(key, value);
	    } catch (error) {
	      e = error;
	      return null;
	    }
	  };
	
	  CurrentConfig.prototype.storageGet = function(key) {
	    var e, error;
	    try {
	      return this.storage.get(key);
	    } catch (error) {
	      e = error;
	      return null;
	    }
	  };
	
	  CurrentConfig.prototype.resetIdentify = function() {
	    try {
	      return this.storage.clear();
	    } catch (undefined) {}
	  };
	
	  CurrentConfig.prototype.identify = function(key, id, options) {
	    var ident, now;
	    if (options == null) {
	      options = {};
	    }
	    ident = this.storageGet(key);
	    now = new Date().getTime();
	    if (options.expires) {
	      if (!ident || ident.expires_at < now) {
	        ident = getReferralContext();
	      }
	      ident.expires_at = now + options.expires;
	    } else {
	      if (ident == null) {
	        ident = getReferralContext();
	      }
	    }
	    if (id != null) {
	      ident.id = id;
	    }
	    if (options.count) {
	      ident.inits_count = (ident.inits_count || 0) + 1;
	    }
	    this.storageSet(key, ident);
	    return ident;
	  };
	
	  CurrentConfig.prototype.onUpdate = function() {
	    return EventBus.emit('hull.config.update', this.get());
	  };
	
	  return CurrentConfig;
	
	})();
	
	module.exports = CurrentConfig;


/***/ },
/* 97 */
/*!****************************************!*\
  !*** ./src/client/current-user.coffee ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Base64, CurrentUser, EventBus, Raven, _, clone, cookies, fixCookies, getKey, setUserContext,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 28);
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 18);
	
	clone = __webpack_require__(/*! ../utils/clone */ 9);
	
	getKey = __webpack_require__(/*! ../utils/get-key */ 58);
	
	Raven = __webpack_require__(/*! ../utils/raven */ 30);
	
	fixCookies = function(userSig) {
	  var e, error;
	  try {
	    if (window.jQuery && _.isFunction(window.jQuery.fn.ajaxSend)) {
	      return window.jQuery(document).ajaxSend(function(e, xhr, opts) {
	        if (userSig && !opts.crossDomain) {
	          return xhr.setRequestHeader('Hull-User-Sig', userSig);
	        }
	      });
	    }
	  } catch (error) {
	    e = error;
	  }
	};
	
	setUserContext = function(user) {
	  var e, error;
	  try {
	    if (user && user.id) {
	      return Raven.setUserContext({
	        id: user.id,
	        email: user.email
	      });
	    }
	  } catch (error) {
	    e = error;
	  }
	};
	
	CurrentUser = (function() {
	  function CurrentUser() {
	    this.set = bind(this.set, this);
	    this.init = bind(this.init, this);
	    this.setLoginStatus = bind(this.setLoginStatus, this);
	    this.hasIdentity = bind(this.hasIdentity, this);
	    this.clear = bind(this.clear, this);
	    this.get = bind(this.get, this);
	    this.clear();
	  }
	
	  CurrentUser.prototype.get = function(key) {
	    if (!key && !this.me) {
	      return null;
	    }
	    return getKey(this.me, key);
	  };
	
	  CurrentUser.prototype.clear = function() {
	    return this.me = null;
	  };
	
	  CurrentUser.prototype.hasIdentity = function(identity) {
	    var identities, ref;
	    if (identity == null) {
	      return false;
	    }
	    identities = (ref = this.me) != null ? ref.identities : void 0;
	    identity = identity.toLowerCase();
	    if (!(identities && identity)) {
	      return false;
	    }
	    return _.some(identities, function(i) {
	      return i.provider.toLowerCase() === identity;
	    });
	  };
	
	  CurrentUser.prototype.setLoginStatus = function(me, provider) {
	    var ref;
	    this.me = me;
	    if ((me != null ? (ref = me.stats) != null ? ref.sign_in_count : void 0 : void 0) == null) {
	      EventBus.emit('hull.user.create', me);
	    }
	    return EventBus.emit('hull.user.login', me, provider);
	  };
	
	  CurrentUser.prototype.init = function(me) {
	    this.me = me;
	    setUserContext(me);
	    return me;
	  };
	
	  CurrentUser.prototype.set = function(me) {
	    var prevId, prevUpdatedAt, ref, ref1;
	    prevUpdatedAt = (ref = this.me) != null ? ref.updated_at : void 0;
	    prevId = (ref1 = this.me) != null ? ref1.id : void 0;
	    this.me = me;
	    setUserContext(me);
	    if (prevUpdatedAt !== (me != null ? me.updated_at : void 0)) {
	      EventBus.emit('hull.user.update', me);
	    }
	    if (me != null ? me.id : void 0) {
	      if (prevId !== me.id) {
	        this.setLoginStatus(me);
	      }
	    } else {
	      if (prevId) {
	        EventBus.emit('hull.user.logout');
	      }
	    }
	    return me;
	  };
	
	  CurrentUser.prototype.setCookies = function(headers, appId) {
	    var cookieName, val;
	    if (headers == null) {
	      headers = {};
	    }
	    cookieName = "hull_" + appId;
	    if (headers && headers['Hull-User-Id'] && headers['Hull-User-Sig']) {
	      val = Base64.encode(JSON.stringify(headers));
	      this.signature = val;
	      fixCookies(val);
	      return cookies.set(cookieName, val, {
	        path: "/"
	      });
	    } else {
	      this.signature = false;
	      return cookies.remove(cookieName, {
	        path: "/"
	      });
	    }
	  };
	
	  return CurrentUser;
	
	})();
	
	module.exports = CurrentUser;


/***/ },
/* 98 */
/*!*********************************************!*\
  !*** ./src/client/embeds/deployment.coffee ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var Deployment, IframeDeploymentStrategy, JSDeploymentStrategy, Promise, RawDeploymentStrategy, ScopeDeploymentStrategy, _, assign, clone, deploymentRegistry, getDeployment, getDeployments, logger, resetDeployments, shipRegistry, throwErr,
	  hasProp = {}.hasOwnProperty,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	clone = __webpack_require__(/*! ../../utils/clone */ 9);
	
	throwErr = __webpack_require__(/*! ../../utils/throw */ 12);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 5);
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 3);
	
	RawDeploymentStrategy = __webpack_require__(/*! ./strategies/raw */ 56);
	
	ScopeDeploymentStrategy = __webpack_require__(/*! ./strategies/scope */ 103);
	
	IframeDeploymentStrategy = __webpack_require__(/*! ./strategies/iframe */ 101);
	
	JSDeploymentStrategy = __webpack_require__(/*! ./strategies/js */ 102);
	
	deploymentRegistry = {};
	
	shipRegistry = {};
	
	resetDeployments = function() {
	  var deployment, key;
	  for (key in deploymentRegistry) {
	    if (!hasProp.call(deploymentRegistry, key)) continue;
	    deployment = deploymentRegistry[key];
	    deployment.destroy();
	  }
	  shipRegistry = {};
	  return deploymentRegistry = {};
	};
	
	getDeployment = function(id) {
	  return deploymentRegistry[id];
	};
	
	getDeployments = function(id) {
	  return _.values(shipRegistry[id]);
	};
	
	Deployment = (function() {
	  Deployment.resetDeployments = resetDeployments;
	
	  Deployment.getDeployment = getDeployment;
	
	  Deployment.getDeployments = getDeployments;
	
	  function Deployment(dpl, context) {
	    this.destroy = bind(this.destroy, this);
	    this.onEmbed = bind(this.onEmbed, this);
	    this.boot = bind(this.boot, this);
	    this.embed = bind(this.embed, this);
	    this.getDeploymentStrategy = bind(this.getDeploymentStrategy, this);
	    this.getPublicData = bind(this.getPublicData, this);
	    var name;
	    if (deploymentRegistry[dpl.id]) {
	      return deploymentRegistry[dpl.id];
	    }
	    deploymentRegistry[dpl.id] = this;
	    this.id = dpl.id;
	    this.name = dpl.ship.name;
	    this.organization = assign({}, context.org);
	    this.platform = dpl.platform;
	    this.ship = dpl.ship;
	    shipRegistry[name = dpl.ship.id] || (shipRegistry[name] = {});
	    shipRegistry[dpl.ship.id][dpl.id] = this;
	    this.onUpdate = dpl.onUpdate;
	    this.settings = dpl.settings;
	  }
	
	
	  /**
	   * Fetches all targets specified in a deployment
	   * @param  {object} opts options object. opts.refresh = true|false // Force Refresh
	   * @return {Nodes Array} A memoized array of Nodes matching the Query Selector (this.targets)
	   */
	
	  Deployment.prototype.getTargets = function(opts) {
	    var target, targets;
	    if (opts == null) {
	      opts = {};
	    }
	    if (this.targets && !opts.refresh) {
	      return this.targets;
	    }
	    if (!this.settings._selector) {
	      return [];
	    }
	    targets = this.settings._multi ? document.querySelectorAll(this.settings._selector) : (target = document.querySelector(this.settings._selector), target ? [target] : []);
	    if (!targets.length) {
	      logger.info("No deployment targets for selector " + this.settings._selector, this);
	    }
	    return targets;
	  };
	
	  Deployment.prototype.getPublicData = function() {
	    return assign(clone({
	      ship: this.ship,
	      organization: this.organization,
	      platform: this.platform,
	      settings: this.settings
	    }), {
	      onUpdate: this.onUpdate || function() {}
	    });
	  };
	
	  Deployment.prototype.getDeploymentStrategy = function() {
	    var DS;
	    if (this.deploymentStrategy != null) {
	      return this.deploymentStrategy;
	    }
	    DS = this.ship.index.match(/\.js$/) ? JSDeploymentStrategy : this.settings._sandbox === 'raw' ? RawDeploymentStrategy : !!this.settings._sandbox ? IframeDeploymentStrategy : ScopeDeploymentStrategy;
	    this.deploymentStrategy = new DS(this);
	    return this.deploymentStrategy;
	  };
	
	  Deployment.prototype.embed = function(opts) {
	    var ds;
	    if (opts == null) {
	      opts = {};
	    }
	    this.targets = this.getTargets(opts);
	    ds = this.getDeploymentStrategy();
	    if (this.targets.length) {
	      return ds.embed(this.targets, opts).then((function(_this) {
	        return function() {
	          return _this.onEmbed();
	        };
	      })(this), throwErr)["catch"](throwErr);
	    } else {
	      return Promise.resolve();
	    }
	  };
	
	  Deployment.prototype.boot = function() {
	    if (this.targets.length) {
	      return this.getDeploymentStrategy().boot();
	    }
	  };
	
	  Deployment.prototype.onEmbed = function(callback) {
	    if (this.targets.length) {
	      return this.getDeploymentStrategy().onEmbed(callback);
	    }
	  };
	
	  Deployment.prototype.destroy = function() {
	    if (this.targets.length) {
	      this.getDeploymentStrategy().destroy();
	      return this.deploymentStrategy = null;
	    }
	  };
	
	  return Deployment;
	
	})();
	
	module.exports = Deployment;


/***/ },
/* 99 */
/*!*****************************************!*\
  !*** ./src/client/embeds/iframe.coffee ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Iframe, getIframe, logger, polyfill, sandbox,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	polyfill = __webpack_require__(/*! ../../utils/load-polyfills */ 29);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 5);
	
	getIframe = __webpack_require__(/*! ../../utils/get-iframe */ 41);
	
	sandbox = __webpack_require__(/*! ./sandbox */ 38);
	
	Iframe = (function() {
	  function Iframe(opts, callback) {
	    if (opts == null) {
	      opts = {};
	    }
	    this.onIframeReady = bind(this.onIframeReady, this);
	    this.src = opts.src;
	    this.id = opts.id;
	    this.iframe = this.buildIframe();
	    if (opts.hidden) {
	      this.hide();
	    }
	    this.onIframeReady(this.iframe, callback);
	  }
	
	  Iframe.prototype.hide = function() {
	    this.iframe.width = '1px';
	    this.iframe.height = '1px';
	    this.iframe.style.position = "fixed";
	    this.iframe.style.width = "1px";
	    this.iframe.style.height = "1px";
	    this.iframe.style.top = "-20px";
	    this.iframe.style.left = "-20px";
	    this.iframe.style.overflow = "hidden";
	    this.iframe.style.margin = "0px";
	    this.iframe.style.padding = "0px";
	    return this.iframe.style.border = "0px";
	  };
	
	  Iframe.prototype.buildIframe = function(target, src) {
	    this.iframe = document.createElement('iframe');
	    this.iframe.name = "ship_" + this.id;
	    if (src != null) {
	      this.iframe.src = src;
	    }
	    this.iframe.vspace = 0;
	    this.iframe.hspace = 0;
	    this.iframe.marginWidth = 0;
	    this.iframe.marginHeight = 0;
	    this.iframe.scrolling = 'no';
	    this.iframe.border = 0;
	    this.iframe.frameBorder = 0;
	    return this.iframe;
	  };
	
	  Iframe.prototype.getIframe = function() {
	    return this.iframe;
	  };
	
	  Iframe.prototype.onIframeReady = function(iframe, callback) {
	    var doc, w;
	    doc = getIframe.document(iframe);
	    if (doc && doc.readyState === 'complete') {
	      logger.verbose("Iframe Ready");
	      w = getIframe.window(iframe);
	      w.location.href = '/';
	      doc.open();
	      doc.write('<!DOCTYPE html><html><head><script>window.HTMLImports={flags:{load:true, parse:true, debug:true}}</script></head><body></body></html>');
	      doc.close();
	      return this.polyfill(doc, w).then(function() {
	        logger.verbose("Iframe Polyfilled");
	        return callback(iframe);
	      });
	    } else {
	      return setTimeout((function(_this) {
	        return function() {
	          return _this.onIframeReady(iframe, callback);
	        };
	      })(this), 10);
	    }
	  };
	
	  Iframe.prototype.polyfill = function(doc, w) {
	    return polyfill.fill({
	      document: doc,
	      window: w,
	      debug: Hull.config().debug
	    });
	  };
	
	  return Iframe;
	
	})();
	
	module.exports = Iframe;


/***/ },
/* 100 */
/*!*****************************************!*\
  !*** ./src/client/embeds/import.coffee ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Import, Promise, _, fjs, logger,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 5);
	
	fjs = document.getElementsByTagName("script")[0];
	
	Import = (function() {
	  function Import(opts) {
	    var container, href, protocol, scoped, shipId;
	    if (opts == null) {
	      opts = {};
	    }
	    this.destroy = bind(this.destroy, this);
	    this.doImport = bind(this.doImport, this);
	    href = opts.href, shipId = opts.shipId, container = opts.container, scoped = opts.scoped;
	    this.shipId = shipId;
	    protocol = document.location.protocol;
	    this.href = href.replace(/^https?:/, protocol);
	    this.scoped = scoped;
	    if (container) {
	      this.window = container.contentWindow;
	      this.document = container.contentDocument;
	    } else {
	      this.window = window;
	      this.document = document;
	    }
	    this.ready = {};
	    this.ready.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this.ready.resolve = resolve;
	        return _this.ready.reject = reject;
	      };
	    })(this));
	    this.load = {};
	    this.load.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this.load.resolve = resolve;
	        return _this.load.reject = reject;
	      };
	    })(this));
	    this.when = {
	      ready: this.ready.promise,
	      loaded: this.load.promise
	    };
	    this.doImport();
	  }
	
	  Import.prototype.doImport = function() {
	    var importInterval, onLoad, onReady, ref;
	    this.el = this.document.querySelector("link[rel=\"import\"][href=\"" + this.href + "\"]");
	    if (!this.el) {
	      this.el = this.document.createElement('link');
	      if (!!this.scoped) {
	        this.el.setAttribute('scoped', this.scoped);
	      }
	      this.el.rel = 'import';
	      this.el.href = this.href;
	      this.el.async = true;
	      this.document.getElementsByTagName('head')[0].appendChild(this.el);
	    }
	    onReady = (function(_this) {
	      return function(doc) {
	        var ready;
	        if (!ready) {
	          logger.verbose("Import " + _this.href + " Ready");
	          _this.el['import'].removeEventListener('DOMContentLoaded', onReady);
	          ready = true;
	          return _this.ready.resolve(_this.el['import']);
	        }
	      };
	    })(this);
	    onLoad = (function(_this) {
	      return function(ev) {
	        onReady();
	        logger.verbose("Import " + _this.href + " Loaded");
	        _this.el.removeEventListener('load', onLoad);
	        return _this.load.resolve(_this.el['import'].body);
	      };
	    })(this);
	    if (this.el['import'] && (((ref = this.el['import']) != null ? ref.body : void 0) != null)) {
	      this.el['import'].shipId = this.shipId;
	      onLoad();
	    } else {
	      this.el.addEventListener('load', onLoad);
	      importInterval = setInterval((function(_this) {
	        return function() {
	          if (_this.el['import']) {
	            _this.el['import'].shipId = _this.shipId;
	            _this.el['import'].addEventListener('DOMContentLoaded', onReady);
	            return clearInterval(importInterval);
	          }
	        };
	      })(this), 10);
	    }
	    return this.el;
	  };
	
	  Import.prototype.destroy = function() {
	    var ref, ref1;
	    return (ref = this.el) != null ? (ref1 = ref.parentNode) != null ? ref1.removeChild(this.el) : void 0 : void 0;
	  };
	
	  return Import;
	
	})();
	
	module.exports = Import;


/***/ },
/* 101 */
/*!****************************************************!*\
  !*** ./src/client/embeds/strategies/iframe.coffee ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseDeploymentStrategy, Iframe, IframeDeploymentStrategy, Promise, Sandbox, _, getIframe, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Promise = __webpack_require__(/*! ../../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../../utils/lodash */ 1);
	
	throwErr = __webpack_require__(/*! ../../../utils/throw */ 12);
	
	getIframe = __webpack_require__(/*! ../../../utils/get-iframe */ 41);
	
	Sandbox = __webpack_require__(/*! ../sandbox */ 38);
	
	Iframe = __webpack_require__(/*! ../iframe */ 99);
	
	BaseDeploymentStrategy = __webpack_require__(/*! ./base */ 39);
	
	IframeDeploymentStrategy = (function(superClass) {
	  extend(IframeDeploymentStrategy, superClass);
	
	  function IframeDeploymentStrategy() {
	    this.destroy = bind(this.destroy, this);
	    this.embedIframe = bind(this.embedIframe, this);
	    this.onEmbed = bind(this.onEmbed, this);
	    return IframeDeploymentStrategy.__super__.constructor.apply(this, arguments);
	  }
	
	  IframeDeploymentStrategy.prototype.scopeStyles = false;
	
	
	  /**
	   * Sandboxed : Multiple Iframes, one for each target, completely isolated
	   * @return {promises} a promise that will resolve when all imports have been loaded in each iframe
	   */
	
	  IframeDeploymentStrategy.prototype.embed = function(targets) {
	    var readyPromises;
	    this.insertions = [];
	    this.setupSandbox();
	    readyPromises = _.map(targets, (function(_this) {
	      return function(target) {
	        return _this.embedIframe(target).then(function(iframe) {
	          var imprt, insertion;
	          insertion = {
	            iframe: iframe,
	            ready: false,
	            callbacks: []
	          };
	          insertion.sandbox = _this.sandbox.scope(insertion);
	          imprt = _this.embedImport(iframe);
	          imprt.when.ready.then(function(doc) {
	            var el, iframeDoc;
	            insertion.doc = doc;
	            iframeDoc = getIframe.document(iframe);
	            el = _this.cloneImport(doc, iframeDoc);
	            insertion.el = el;
	            iframeDoc.body.appendChild(el);
	            return _this.insertions.push(insertion);
	          })["catch"](throwErr);
	          imprt.when.loaded["catch"](throwErr);
	          return imprt.when.loaded;
	        })["catch"](throwErr);
	      };
	    })(this));
	    return Promise.all(readyPromises);
	  };
	
	  IframeDeploymentStrategy.prototype.onEmbed = function() {
	    return this.ready.promise.then((function(_this) {
	      return function() {
	        return _.map(_this.insertions, function(insertion) {
	          var callback, results;
	          results = [];
	          while (callback = insertion.callbacks.shift()) {
	            results.push(callback(insertion.el, _this.deployment.getPublicData(), insertion.sandbox.hull));
	          }
	          return results;
	        });
	      };
	    })(this))["catch"](throwErr);
	  };
	
	
	  /**
	   * Embeds an iframe in a DOM container or directly in the Body
	   *
	   * @param  {Node|NodeArray} targets A single node or an array of Nodes
	   * @return {object}         an object containing a promise for when the import is loaded, the elements created and the target node(s)
	   */
	
	  IframeDeploymentStrategy.prototype.embedIframe = function(container) {
	    var embed;
	    embed = {};
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var iframe;
	        iframe = new Iframe({
	          id: _this.deployment.id,
	          hidden: !_this.deployment.settings._sandbox
	        }, function(iframe) {
	          _this.addShipClasses(iframe);
	          getIframe.document(iframe).shipId = _this.deployment.ship.id;
	          return resolve(iframe);
	        });
	        if (container) {
	          return _this.insert(iframe.getIframe(), container);
	        } else {
	          return document.body.appendChild(iframe.getIframe());
	        }
	      };
	    })(this));
	  };
	
	  IframeDeploymentStrategy.prototype.destroy = function() {
	    var i, insertion, len, ref, ref1, ref2;
	    ref = this.insertions;
	    for (i = 0, len = ref.length; i < len; i++) {
	      insertion = ref[i];
	      if ((ref1 = insertion.iframe) != null) {
	        if ((ref2 = ref1.parentNode) != null) {
	          ref2.removeChild(insertion.iframe);
	        }
	      }
	    }
	    this.insertions = [];
	    this.sandbox.destroy();
	    return IframeDeploymentStrategy.__super__.destroy.call(this);
	  };
	
	  return IframeDeploymentStrategy;
	
	})(BaseDeploymentStrategy);
	
	module.exports = IframeDeploymentStrategy;


/***/ },
/* 102 */
/*!************************************************!*\
  !*** ./src/client/embeds/strategies/js.coffee ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	var BaseDeploymentStrategy, JSDeploymentStrategy, Promise, _, getScript, scriptLoader, scripts, setScript, throwErr,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	Promise = __webpack_require__(/*! ../../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../../utils/lodash */ 1);
	
	throwErr = __webpack_require__(/*! ../../../utils/throw */ 12);
	
	scriptLoader = __webpack_require__(/*! ../../../utils/script-loader */ 31);
	
	BaseDeploymentStrategy = __webpack_require__(/*! ./base */ 39);
	
	scripts = {};
	
	getScript = function(deployment) {
	  return scripts[deployment.ship.id];
	};
	
	setScript = function(deployment, sc) {
	  return scripts[deployment.ship.id] = sc;
	};
	
	JSDeploymentStrategy = (function(superClass) {
	  extend(JSDeploymentStrategy, superClass);
	
	  function JSDeploymentStrategy() {
	    this.onEmbed = bind(this.onEmbed, this);
	    this.addInsertion = bind(this.addInsertion, this);
	    return JSDeploymentStrategy.__super__.constructor.apply(this, arguments);
	  }
	
	  JSDeploymentStrategy.prototype.scopeStyles = false;
	
	
	  /**
	   * Embeds a Script in the page
	   * @return {promise} a promise for the onLoad event
	   */
	
	  JSDeploymentStrategy.prototype.embed = function(targets) {
	    var attributes, el, i, len, sc, target;
	    this.elements = [];
	    this.setupSandbox();
	    for (i = 0, len = targets.length; i < len; i++) {
	      target = targets[i];
	      el = document.createElement('div');
	      this.addInsertion(this.insert(el, target));
	    }
	    sc = document.querySelector("[data-hull-ship-script=\"" + this.deployment.ship.id + "\"]");
	    if (!getScript(this.deployment)) {
	      setScript(this.deployment, true);
	      attributes = {
	        'data-hull-deployment': this.deployment.id,
	        'data-hull-ship-script': this.deployment.ship.id
	      };
	      return scriptLoader({
	        src: this.deployment.ship.index,
	        attributes: attributes
	      }).then((function(_this) {
	        return function() {
	          var args, ref;
	          args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	          return (ref = _this.ready).resolve.apply(ref, args);
	        };
	      })(this))["catch"]((function(_this) {
	        return function(err) {
	          _this.ready.reject(err);
	          return throwErr(err);
	        };
	      })(this));
	    } else {
	      return new Promise((function(_this) {
	        return function(resolve, reject) {
	          _this.ready.resolve();
	          return resolve();
	        };
	      })(this));
	    }
	  };
	
	  JSDeploymentStrategy.prototype.addInsertion = function(el) {
	    this.sandbox.addElement(el);
	    return this.insertions.push({
	      el: el,
	      ready: false,
	      callbacks: []
	    });
	  };
	
	  JSDeploymentStrategy.prototype.onEmbed = function(callback) {
	    if (callback) {
	      return this.ready.promise.then((function(_this) {
	        return function() {
	          return _.map(_this.insertions, function(insertion) {
	            return callback(insertion.el, _this.deployment.getPublicData(), _this.sandbox.hull);
	          });
	        };
	      })(this))["catch"](throwErr);
	    }
	  };
	
	  return JSDeploymentStrategy;
	
	})(BaseDeploymentStrategy);
	
	module.exports = JSDeploymentStrategy;


/***/ },
/* 103 */
/*!***************************************************!*\
  !*** ./src/client/embeds/strategies/scope.coffee ***!
  \***************************************************/
/***/ function(module, exports, __webpack_require__) {

	var RawDeploymentStrategy, ScopeDeploymentStrategy, _,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	_ = __webpack_require__(/*! ../../../utils/lodash */ 1);
	
	RawDeploymentStrategy = __webpack_require__(/*! ./raw */ 56);
	
	ScopeDeploymentStrategy = (function(superClass) {
	  extend(ScopeDeploymentStrategy, superClass);
	
	  function ScopeDeploymentStrategy() {
	    return ScopeDeploymentStrategy.__super__.constructor.apply(this, arguments);
	  }
	
	  ScopeDeploymentStrategy.prototype.scopeStyles = true;
	
	  ScopeDeploymentStrategy.prototype.ignoredTags = ['#comment', 'SCRIPT', 'LINK', 'STYLE'];
	
	  ScopeDeploymentStrategy.prototype.headTags = [];
	
	  return ScopeDeploymentStrategy;
	
	})(RawDeploymentStrategy);
	
	module.exports = ScopeDeploymentStrategy;


/***/ },
/* 104 */
/*!**************************************!*\
  !*** ./src/client/flag/index.coffee ***!
  \**************************************/
/***/ function(module, exports) {

	module.exports = function(api) {
	  return function(id) {
	    return api({
	      provider: "hull",
	      path: [id, 'flag'].join('/')
	    }, 'post');
	  };
	};


/***/ },
/* 105 */
/*!*********************************!*\
  !*** ./src/client/index.coffee ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	var Api, Auth, Client, Entity, EventBus, Flag, Sharer, Tracker, Traits, _, clone, findUrl, logger, utils,
	  slice = [].slice;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	clone = __webpack_require__(/*! ../utils/clone */ 9);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	Entity = __webpack_require__(/*! ../utils/entity */ 133);
	
	findUrl = __webpack_require__(/*! ../utils/find-url */ 40);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	Api = __webpack_require__(/*! ./api */ 54);
	
	Auth = __webpack_require__(/*! ./auth */ 95);
	
	Flag = __webpack_require__(/*! ./flag/index */ 104);
	
	Tracker = __webpack_require__(/*! ./track/index */ 111);
	
	Traits = __webpack_require__(/*! ./traits/index */ 112);
	
	Sharer = __webpack_require__(/*! ./sharer/index */ 108);
	
	utils = __webpack_require__(/*! ../utils/utils */ 91);
	
	Client = (function() {
	  function Client(channel, currentUser, currentConfig) {
	    var api, auth, flag, sharer, tracker, traits;
	    this.currentConfig = currentConfig;
	    api = new Api(channel, currentUser, currentConfig);
	    auth = new Auth(api, currentUser, currentConfig);
	    tracker = new Tracker(api);
	    sharer = new Sharer(currentConfig);
	    flag = new Flag(api);
	    traits = new Traits(api);
	    if (this.currentConfig.get('debug.enabled')) {
	      EventBus.on('hull.**', function() {
	        var args;
	        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	        return logger.log.apply(logger, ["--HULL EVENT--[" + this.event + "]--"].concat(slice.call(args)));
	      });
	    }
	    this.hull = {
	      config: this.currentConfig.get,
	      utils: utils,
	      api: api.message,
	      currentUser: currentUser.get,
	      entity: Entity,
	      signup: auth.signup,
	      logout: auth.logout,
	      login: auth.login,
	      resetPassword: auth.resetPassword,
	      confirmEmail: auth.confirmEmail,
	      linkIdentity: auth.linkIdentity,
	      unlinkIdentity: auth.unlinkIdentity,
	      track: tracker.track,
	      flag: flag,
	      traits: traits,
	      trait: traits,
	      share: sharer.share,
	      findUrl: findUrl
	    };
	    this.hull;
	  }
	
	  return Client;
	
	})();
	
	module.exports = Client;


/***/ },
/* 106 */
/*!**************************************!*\
  !*** ./src/client/parse-opts.coffee ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var _, _objectDescription, _stringDescription, assign, defaultProvider, parse;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 2);
	
	
	/*
	 * Parses the parameters for an API call. At this point, they can have two forms
	 * * [String, ...] where the String is an uri. The request will be made to the default provider
	 * * [Object, ...] where the Object describes more completely the request. It must provide a "path" key, can provide a "provider" key as well as some default parameters in the "params" key
	 * In the second form, the optional params can be overridden through parameters at data.api calls
	 *
	 * The normalized form is the first one.
	 *
	 * @param {Array} the parameters for the API calls
	 * @return {Array} The normalized form of parameters
	 */
	
	defaultProvider = 'hull';
	
	_stringDescription = function(desc) {
	  return [desc, defaultProvider, {}];
	};
	
	_objectDescription = function(desc) {
	  var organization, params, path, provider;
	  path = desc.path;
	  if (desc.organization != null) {
	    organization = desc.organization;
	  }
	  provider = desc.provider || defaultProvider;
	  params = desc.params || {};
	  return [path, provider, params, organization];
	};
	
	parse = function(argsArray) {
	  var callback, description, errback, method, next, organization, params, path, provider, ref, ref1, ret, type;
	  description = argsArray.shift();
	  if (_.isString(description)) {
	    ref = _stringDescription(description), path = ref[0], provider = ref[1], params = ref[2];
	  }
	  if (_.isObject(description)) {
	    ref1 = _objectDescription(description), path = ref1[0], provider = ref1[1], params = ref1[2], organization = ref1[3];
	  }
	  if (!path) {
	    throw "Hull cannot find the Path (URI) you want to send your request to.\nCould you check your API Call parameters ? Here's what we have received :\n${JSON.stringify(path)}";
	  }
	  if (path[0] === "/") {
	    path = path.substring(1);
	  }
	  ret = [];
	  if (params != null) {
	    ret.push(params);
	  }
	  ret = ret.concat(argsArray);
	  callback = errback = null;
	  params = {};
	  while ((next = ret.shift())) {
	    type = typeof next;
	    if (type === 'string' && !method) {
	      method = next.toLowerCase();
	    } else if (type === 'function' && (!callback || !errback)) {
	      if (!callback) {
	        callback = next;
	      } else if (!errback) {
	        errback = next;
	      }
	    } else if (type === 'object') {
	      params = assign(params, next);
	    } else {
	      throw new TypeError("Invalid argument passed to Hull.api(): " + next);
	    }
	  }
	  if (method == null) {
	    method = 'get';
	  }
	  callback = callback || function() {};
	  errback = errback || function() {};
	  return {
	    opts: {
	      provider: provider,
	      path: path,
	      method: method,
	      params: params,
	      organization: organization
	    },
	    callback: callback,
	    errback: errback
	  };
	};
	
	module.exports = parse;


/***/ },
/* 107 */
/*!*********************************************!*\
  !*** ./src/client/script-tag-config.coffee ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var _, dasherize, getAttribute, getParamValue, httpsRegex, initParams, logger, origin, transform, valid;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	dasherize = function(str) {
	  return str.replace(/[A-Z]/, function(c) {
	    return "-" + c.toLowerCase();
	  });
	};
	
	origin = window.location.origin || window.location.protocol + "//" + window.location.hostname;
	
	if (window.location.port) {
	  origin += ':' + window.location.port;
	}
	
	httpsRegex = /^https:|^\/\//;
	
	valid = {
	  regex: function(reg) {
	    return function(val, key) {
	      var check;
	      check = reg.test(val);
	      if (!check) {
	        logger.error("[Hull.init] invalid format for '" + key + "'. Value '" + val + "' should match " + (reg.toString()));
	      }
	      return check;
	    };
	  },
	  https: function(val, key) {
	    var check;
	    check = httpsRegex.test(val);
	    if (check) {
	      return true;
	    }
	    logger.warn("[Hull.init] " + key + " should be loaded via https. Current value is ", val);
	    return true;
	  }
	};
	
	transform = {
	  url: function(url, key) {
	    var a;
	    if (url && url.length > 0) {
	      a = document.createElement('a');
	      a.href = url;
	      return a.href;
	    }
	  },
	  bool: function(str, key) {
	    switch (str) {
	      case 'true':
	      case true:
	        return true;
	      case 'false':
	      case false:
	        return false;
	      default:
	        return void 0;
	    }
	  }
	};
	
	initParams = {
	  appId: {
	    validation: valid.regex(/^[a-f0-9]{24}$/i),
	    required: true,
	    altKeys: ['shipId', 'platformId']
	  },
	  orgUrl: {
	    validation: valid.https,
	    required: true
	  },
	  jsUrl: {
	    transform: transform.url,
	    validation: valid.https,
	    altKeys: ['src']
	  },
	  callbackUrl: {
	    transform: transform.url,
	    validation: valid.regex(new RegExp("^" + origin + "/"))
	  },
	  debug: {
	    "default": false,
	    transform: transform.bool
	  },
	  verbose: {
	    "default": false,
	    transform: transform.bool
	  },
	  embed: {
	    "default": true,
	    transform: transform.bool
	  },
	  autoStart: {
	    "default": true,
	    transform: transform.bool
	  },
	  accessToken: {
	    "default": null
	  },
	  customerId: {
	    "default": null
	  },
	  anonymousId: {
	    "default": null
	  },
	  sessionId: {
	    "default": null
	  },
	  ravenDsn: {
	    "default": null
	  }
	};
	
	getAttribute = function(el, k) {
	  return el.getAttribute(dasherize(k)) || el.getAttribute(k);
	};
	
	getParamValue = function(el, param, key) {
	  var keys, value;
	  keys = [key].concat(param.altKeys || []);
	  transform = param.transform || function(o) {
	    return o;
	  };
	  value = _.reduce(keys, function(ret, k) {
	    if (ret === null) {
	      value = transform(getAttribute(el, k), key);
	      valid = (value != null) && (!param.validation || param.validation(value, k, el));
	      if (valid) {
	        ret = value;
	      }
	    }
	    return ret;
	  }, null);
	  if (value != null) {
	    return value;
	  } else {
	    return param["default"];
	  }
	};
	
	module.exports = function() {
	  var hull_js_sdk, out;
	  hull_js_sdk = document.getElementById('hull-js-sdk') || document.querySelector('[org-url][platform-id]');
	  if (!hull_js_sdk) {
	    return;
	  }
	  out = _.reduce(initParams, function(config, param, key) {
	    var value;
	    if (!config) {
	      return;
	    }
	    value = getParamValue(hull_js_sdk, param, key);
	    if (value != null) {
	      config[key] = value;
	    } else if (param.required) {
	      config = false;
	    }
	    return config;
	  }, {});
	  if (out) {
	    if (httpsRegex.test(out.orgUrl) && !httpsRegex.test(out.jsUrl)) {
	      logger.error("[Hull.init] jsUrl NEEDS be loaded via https if orgUrl is https ");
	    }
	  }
	  return out;
	};


/***/ },
/* 108 */
/*!****************************************!*\
  !*** ./src/client/sharer/index.coffee ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var EventBus, Promise, Sharer, _, assign, domWalker, findUrl, popup, qs,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	findUrl = __webpack_require__(/*! ../../utils/find-url */ 40);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	domWalker = __webpack_require__(/*! ../../utils/dom-walker */ 57);
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 3);
	
	qs = __webpack_require__(/*! ../../utils/query-string-encoder */ 19);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	popup = function(location, opts, params) {
	  var share;
	  if (opts == null) {
	    opts = {};
	  }
	  if (params == null) {
	    params = {};
	  }
	  if (location == null) {
	    return;
	  }
	  share = window.open(location + "?" + (qs.encode(params)), 'hull_share', "location=0,status=0,width=" + opts.width + ",height=" + opts.height);
	  return new Promise(function(resolve, reject) {
	    var interval;
	    return interval = setInterval(function() {
	      var e, error;
	      try {
	        if ((share == null) || share.closed) {
	          window.clearInterval(interval);
	          return resolve({});
	        }
	      } catch (error) {
	        e = error;
	        return reject(e);
	      }
	    }, 500);
	  });
	};
	
	Sharer = (function() {
	  function Sharer(currentConfig) {
	    this.share = bind(this.share, this);
	    this.currentConfig = currentConfig;
	  }
	
	  Sharer.prototype.share = function(opts, event) {
	    var params, popupUrl, provider, sharePromise;
	    if (event == null) {
	      event = {};
	    }
	    if (!_.isObject(opts)) {
	      throw new Error("You need to pass an options hash to the share method. You passed: " + (JSON.stringify(opts)));
	    } else if (opts.provider == null) {
	      throw new Error("You need specify the provider on which to share. You passed: " + opts.provider);
	    } else if (!_.isObject(opts.params)) {
	      opts.params = {};
	    }
	    opts.params || (opts.params = {});
	    opts.params.url = opts.params.url || opts.params.href;
	    if (!opts.params.url) {
	      opts.params.url = findUrl(event.target);
	      opts.params.title = opts.params.title || domWalker.getMetaValue('og:title') || document.title;
	    }
	    params = assign({
	      platform_id: this.currentConfig.get('appId')
	    }, opts.params);
	    provider = opts.provider;
	    popupUrl = this.currentConfig.get('orgUrl') + "/api/v1/intent/share/" + opts.provider;
	    sharePromise = popup(popupUrl, {
	      width: 550,
	      height: 420
	    }, params);
	    return sharePromise.then((function(_this) {
	      return function(response) {
	        var data;
	        data = assign({
	          url: opts.params.url
	        }, params, {
	          provider: provider
	        });
	        EventBus.emit("hull." + opts.provider + ".share", data);
	        return assign({}, data, {
	          response: response
	        });
	      };
	    })(this), function(err) {
	      throw err;
	    });
	  };
	
	  return Sharer;
	
	})();
	
	module.exports = Sharer;


/***/ },
/* 109 */
/*!******************************************!*\
  !*** ./src/client/style/observer.coffee ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var StyleObserver, _, getLinks, getStyles, hasLinkSheet, hasStyleMutations, hasStyleTag, isLinkSheet, isOrHasLinkSheet, isOrHasStyleTag, isStyleTag, observerOptions, processDocumentMutations, processNodeMutations, styleScoper;
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	styleScoper = __webpack_require__(/*! ./style-scoper */ 110);
	
	observerOptions = {
	  subtree: true,
	  childList: true,
	  characterData: false,
	  attributes: false,
	  attributeOldValue: false
	};
	
	isStyleTag = function(node) {
	  return node.nodeType === 1 && node.nodeName === 'STYLE';
	};
	
	isLinkSheet = function(node) {
	  return node.nodeType === 1 && node.nodeName === 'LINK' && node.getAttribute('rel') === 'stylesheet';
	};
	
	hasLinkSheet = function(node) {
	  return node.nodeType === 1 && !!node.getElementsByTagName('link[rel=stylesheet]').length;
	};
	
	hasStyleTag = function(node) {
	  return node.nodeType === 1 && !!node.getElementsByTagName('style').length;
	};
	
	isOrHasStyleTag = function(node) {
	  return isStyleTag(node) || hasStyleTag(node);
	};
	
	isOrHasLinkSheet = function(node) {
	  return isLinkSheet(node) || hasLinkSheet(node);
	};
	
	getStyles = function(node) {
	  if (node == null) {
	    return;
	  }
	  if (node.nodeType !== 1) {
	    return [];
	  }
	  if (isStyleTag(node)) {
	    return [node];
	  }
	  return node.querySelectorAll('style');
	};
	
	getLinks = function(node) {
	  if (node == null) {
	    return;
	  }
	  if (node.nodeType !== 1) {
	    return [];
	  }
	  if (isLinkSheet(node)) {
	    return [node];
	  }
	  return node.querySelectorAll('link[rel=stylesheet]');
	};
	
	hasStyleMutations = function(mutations) {
	  return _.some(mutations, function(m) {
	    if (isStyleTag(m.target) || isLinkSheet(m.target)) {
	      return true;
	    }
	    return _.some(m.addedNodes, isOrHasStyleTag);
	    return _.some(m.removedNodes, isOrHasStyleTag);
	    return _.some(m.addedNodes, isOrHasLinkSheet);
	    return _.some(m.removedNodes, isOrHasLinkSheet);
	    return false;
	  });
	};
	
	processDocumentMutations = function(prefix, doc, mutations) {
	  if (hasStyleMutations(mutations)) {
	    return styleScoper.addDocument(prefix, doc);
	  }
	};
	
	processNodeMutations = function(prefix, mutations) {
	  return _.map(mutations, function(mutation) {
	    return _.map(mutation.addedNodes, function(node) {
	      var i, len, ref, results, style;
	      ref = getStyles(node);
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        style = ref[i];
	        results.push(styleScoper.addStyle(prefix, style));
	      }
	      return results;
	    });
	  });
	};
	
	StyleObserver = (function() {
	  function StyleObserver(prefix) {
	    this._observers = [];
	    this.prefix = prefix;
	  }
	
	  StyleObserver.prototype.observe = function(target) {
	    if (target.nodeType === 9) {
	      this.observeDocument(target);
	    }
	    if (target.nodeType === 1) {
	      return this.observeNode(target);
	    }
	  };
	
	  StyleObserver.prototype.process = function(target) {
	    if (target.nodeType === 9) {
	      this.processDocument(target);
	    }
	    if (target.nodeType === 1) {
	      return this.processNode(target);
	    }
	  };
	
	  StyleObserver.prototype.destroy = function() {
	    var i, len, ref, results, root;
	    ref = this._observers;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      root = ref[i];
	      results.push(this.unobserve(root));
	    }
	    return results;
	  };
	
	  StyleObserver.prototype.processNode = function(node) {
	    return _.map(node.querySelectorAll('style'), styleScoper.addStyle.bind(this, this.prefix));
	  };
	
	  StyleObserver.prototype.observeNode = function(node) {
	    var observer;
	    if (!node) {
	      return;
	    }
	    this.processNode(node);
	    observer = new MutationObserver(processNodeMutations.bind(this, this.prefix));
	    observer.observe(node, observerOptions);
	    this._observers.push({
	      root: node,
	      observer: observer
	    });
	    return observer;
	  };
	
	  StyleObserver.prototype.processDocument = function(doc) {
	    return styleScoper.addDocument(this.prefix, doc);
	  };
	
	  StyleObserver.prototype.observeDocument = function(doc) {
	    var observer;
	    if (!doc) {
	      return;
	    }
	    this.processDocument(doc);
	    observer = new MutationObserver(processDocumentMutations.bind(this, this.prefix, doc));
	    observer.observe(doc.head, observerOptions);
	    observer.observe(doc.body, observerOptions);
	    this._observers.push({
	      root: doc,
	      observer: observer
	    });
	    return observer;
	  };
	
	  StyleObserver.prototype.unobserve = function(root) {
	    var observer;
	    observer = _.find(this._observers, function(obs) {
	      return obs.root === root;
	    });
	    return observer.observer.disconnect();
	  };
	
	  StyleObserver.prototype.destroy = function() {
	    var i, len, observer, ref;
	    ref = this._observers;
	    for (i = 0, len = ref.length; i < len; i++) {
	      observer = ref[i];
	      observer.observer.disconnect();
	    }
	    return this._observers = [];
	  };
	
	  return StyleObserver;
	
	})();
	
	module.exports = StyleObserver;


/***/ },
/* 110 */
/*!**********************************************!*\
  !*** ./src/client/style/style-scoper.coffee ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var CSS_IMPORT_REGEXP, CSS_URL_REGEXP, MergedStyles, Promise, Styles, _, addDocument, addLink, addSheet, addStyle, appendStyle, appendText, createStyleSheet, fetch, finalize, finalizeNow, findNode, getRules, getTextContent, getUriFromHref, logger, polyfill, prefixRule, prefixRules, promise, removeDocument, removeLink, removeStyleSheet, replaceUrls, resolveUrls, resolveUrlsInCssText, resolveUrlsInStyle, setTextContent, superagent, textToRules, throwErr;
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	polyfill = __webpack_require__(/*! ../../utils/load-polyfills */ 29);
	
	throwErr = __webpack_require__(/*! ../../utils/throw */ 12);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 5);
	
	superagent = __webpack_require__(/*! superagent */ 22);
	
	Styles = [];
	
	CSS_URL_REGEXP = /(url\()([^)]*)(\))/g;
	
	CSS_IMPORT_REGEXP = /(@import[\s]+(?!url\())([^;]*)(;)/g;
	
	resolveUrlsInStyle = function(style, linkUrl) {
	  var doc, resolver, tc;
	  doc = style.ownerDocument;
	  resolver = doc.createElement("a");
	  tc = getTextContent(style);
	  setTextContent(style, resolveUrlsInCssText(tc, linkUrl, resolver));
	  return style;
	};
	
	resolveUrlsInCssText = function(cssText, linkUrl, urlObj) {
	  var r;
	  r = replaceUrls(cssText, urlObj, linkUrl, CSS_URL_REGEXP);
	  r = replaceUrls(r, urlObj, linkUrl, CSS_IMPORT_REGEXP);
	  return r;
	};
	
	replaceUrls = function(text, urlObj, linkUrl, regexp) {
	  if (!text) {
	    return "";
	  }
	  return text.replace(regexp, function(m, pre, url, post) {
	    var urlPath;
	    urlPath = url.replace(/["']/g, "");
	    if (linkUrl) {
	      urlPath = new URL(urlPath, linkUrl).href;
	    }
	    urlObj.href = urlPath;
	    urlPath = urlObj.href;
	    return pre + "'" + urlPath + "'" + post;
	  });
	};
	
	resolveUrls = function(text, href, doc) {
	  var resolver;
	  resolver = doc.createElement("a");
	  return resolveUrlsInCssText(text, href, resolver);
	};
	
	getTextContent = function(node) {
	  if (node.textContent != null) {
	    return node.textContent;
	  }
	  return node.innerText;
	};
	
	setTextContent = function(tag, content) {
	  var textnode;
	  if (content == null) {
	    content = "";
	  }
	  if (tag.styleSheet) {
	    return tag.styleSheet.cssText = content;
	  } else {
	    textnode = document.createTextNode(content);
	    while (tag.firstChild) {
	      tag.removeChild(tag.firstChild);
	    }
	    return tag.appendChild(textnode);
	  }
	};
	
	createStyleSheet = function(content, disabled) {
	  var style;
	  if (disabled == null) {
	    disabled = false;
	  }
	  style = document.createElement('style');
	  if (disabled) {
	    style.disabled = true;
	  }
	  style.setAttribute("type", "text/css");
	  style.setAttribute('id', 'hull-style');
	  document.getElementsByTagName('head')[0].appendChild(style);
	  setTextContent(style, content);
	  return style;
	};
	
	removeStyleSheet = function(style) {
	  var ref;
	  return (ref = style.parentNode) != null ? ref.removeChild(style) : void 0;
	};
	
	if (!MergedStyles) {
	  MergedStyles = createStyleSheet("");
	}
	
	promise = new Promise(function(resolve, reject) {
	  return resolve();
	});
	
	getRules = function(sheet) {
	  if (sheet == null) {
	    return;
	  }
	  return sheet.cssRules || sheet.rules;
	};
	
	fetch = function(href) {
	  return new Promise(function(resolve, reject) {
	    if (!href) {
	      return reject();
	    }
	    return superagent.get("http://" + polyfill.domain + "/cors/" + (encodeURIComponent(href))).end(function(err, res) {
	      if (err != null) {
	        return reject(err);
	      } else {
	        return resolve(res != null ? res.text : void 0);
	      }
	    });
	  });
	};
	
	prefixRule = function(prefix, rule) {
	  var content, j, query, ref, selectorText, subRule, subSheet;
	  if (!rule) {
	    return;
	  }
	  if (rule.selectorText) {
	    selectorText = (ref = rule.selectorText) != null ? ref.split(',').map(function(r) {
	      r = r.replace(':host', prefix);
	      if (r.indexOf(prefix) > -1) {
	        return r;
	      } else {
	        return prefix + " " + r;
	      }
	    }).join(', ') : void 0;
	    return selectorText + " {" + rule.style.cssText + "} ";
	  } else {
	    subSheet = rule.cssRules || rule.rules;
	    if (!subSheet) {
	      return rule.cssText;
	    }
	    content = (function() {
	      var i, len, results;
	      results = [];
	      for (j = i = 0, len = subSheet.length; i < len; j = ++i) {
	        subRule = subSheet[j];
	        results.push(prefixRule(prefix, subRule));
	      }
	      return results;
	    })();
	    query = rule.cssText.split('{');
	    return query[0] + " {" + (content.join(' ')) + "} ";
	  }
	};
	
	getUriFromHref = function(href) {
	  var uri;
	  uri = href.split('/');
	  uri.pop();
	  return uri.join('/') + '/';
	};
	
	textToRules = function(text) {
	  var rules, style;
	  style = createStyleSheet(text, true);
	  rules = getRules(style.sheet);
	  removeStyleSheet(style);
	  return rules;
	};
	
	prefixRules = function(prefix, rules) {
	  var r;
	  r = _.map(rules, function(rule) {
	    return prefixRule(prefix, rule);
	  });
	  return r.join(' ');
	};
	
	appendText = function(entry, text) {
	  var rules;
	  rules = textToRules(resolveUrls(text, entry.node.href, entry.doc));
	  if (rules) {
	    entry.style = prefixRules(entry.prefix, rules);
	  }
	  return true;
	};
	
	appendStyle = function(entry) {
	  var rules;
	  if (!!entry.node.href) {
	    if (entry.node.__resource) {
	      return appendText(entry, entry.node.__resource);
	    } else {
	      removeStyleSheet(entry.node);
	      return fetch(entry.node.href).then(appendText.bind(this, entry), function(err) {
	        return logger.log("Could not fetch style (probably because of CORS), so we ignored it. " + err);
	      });
	    }
	  } else {
	    resolveUrlsInStyle(entry.node);
	    entry.node.disabled = true;
	    rules = getRules(entry.node.sheet);
	    if (rules) {
	      return entry.style = prefixRules(entry.prefix, rules);
	    }
	  }
	};
	
	addSheet = function(prefix, node, doc) {
	  var entry;
	  entry = findNode(prefix, node);
	  if (!entry) {
	    entry = {
	      prefix: prefix,
	      node: node,
	      doc: doc,
	      style: ""
	    };
	    Styles.push(entry);
	  }
	  if (!node.disabled) {
	    node.disabled = true;
	    return promise = promise.then(function() {
	      return appendStyle(entry);
	    }, throwErr);
	  }
	};
	
	findNode = function(prefix, node) {
	  return _.find(Styles, function(d) {
	    return d.node === node && d.prefix === prefix;
	  });
	};
	
	finalizeNow = function() {
	  return promise.then(function() {
	    return setTextContent(MergedStyles, _.pluck(Styles, 'style').join(' '));
	  }, throwErr);
	};
	
	finalize = _.throttle(finalizeNow, 20);
	
	
	/**
	 * Adds a whole document's styles to the Styles tag
	 *
	 * Under Firefox, you can't change css Rules or the containing
	 * style tag or those will be reset when touching anything else.
	 * Resort to building an entirely new stylesheet without copying cssRules
	 * @param {[type]} prefix [description]
	 * @param {[type]} doc    [description]
	 */
	
	addDocument = function(prefix, doc) {
	  var index, node, styles;
	  styles = _.toArray(doc.querySelectorAll('style,link'));
	  for (index in styles) {
	    node = styles[index];
	    addSheet(prefix, node, doc);
	  }
	  return finalize();
	};
	
	removeDocument = function(prefix, doc) {
	  Styles = _.omit(Styles, function(style) {
	    return style.doc === doc;
	  });
	  return finalize();
	};
	
	addStyle = function(prefix, node) {
	  addSheet(prefix, node, node.ownerDocument);
	  node.setAttribute('data-scoped', true);
	  return finalize();
	};
	
	addLink = function(prefix, node) {
	  addSheet(prefix, node, node.ownerDocument);
	  return finalize();
	};
	
	removeLink = function(node) {
	  Styles = _.omit(Styles, function(style) {
	    return style.node === node;
	  });
	  return finalize();
	};
	
	module.exports = {
	  addDocument: addDocument,
	  removeDocument: removeDocument,
	  addStyle: addStyle,
	  addLink: addLink
	};


/***/ },
/* 111 */
/*!***************************************!*\
  !*** ./src/client/track/index.coffee ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var EventBus, Tracker, _, assign,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	Tracker = (function() {
	  function Tracker(api, currentUser) {
	    this.track = bind(this.track, this);
	    this.api = api;
	    this.currentUser = currentUser;
	    this.setupTracking();
	  }
	
	  Tracker.prototype.getCurrentUserId = function() {
	    return this.currentUser.get('id');
	  };
	
	  Tracker.prototype.setupTracking = function() {
	    var self;
	    if (this.setup) {
	      return;
	    }
	    this.setup = true;
	    self = this;
	    EventBus.on('hull.*.share', function(res) {
	      return self.track(this.event, res);
	    });
	    EventBus.on('hull.user.create', function(me) {
	      var providers;
	      providers = _.pluck(me.identities, 'provider');
	      return self.track('hull.user.create', {
	        providers: providers,
	        main_identity: me.main_identity
	      });
	    });
	    EventBus.on('hull.user.update', function(me) {
	      return self.track('hull.user.update', {});
	    });
	    EventBus.on('hull.user.login', function(me, provider) {
	      var providers;
	      providers = _.pluck(me.identities, 'provider');
	      provider = provider || me.main_identity;
	      return self.track('hull.user.login', {
	        provider: provider,
	        providers: providers,
	        main_identity: me.main_identity
	      });
	    });
	    return EventBus.on('hull.user.logout', function() {
	      return self.track('hull.user.logout');
	    });
	  };
	
	  Tracker.prototype.track = function(event, payload, success, failure) {
	    return this.api.message({
	      provider: 'track',
	      path: event
	    }, 'post', {
	      payload: payload,
	      url: document.location.href,
	      referer: document.referrer
	    });
	  };
	
	  return Tracker;
	
	})();
	
	module.exports = Tracker;


/***/ },
/* 112 */
/*!****************************************!*\
  !*** ./src/client/traits/index.coffee ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Trait, _, assign;
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	Trait = (function() {
	  function Trait(api, name, value) {
	    this._api = api;
	    this.name = name;
	    if (value != null) {
	      if (_.isObject(value)) {
	        this.raw(assign({}, value, {
	          name: this.name
	        }));
	      } else {
	        this.set(value);
	      }
	    }
	  }
	
	  Trait.prototype.inc = function(step) {
	    if (step == null) {
	      step = 1;
	    }
	    return this.raw({
	      name: this.name,
	      operation: 'inc',
	      value: step
	    });
	  };
	
	  Trait.prototype.dec = function(step) {
	    if (step == null) {
	      step = 1;
	    }
	    return this.raw({
	      name: this.name,
	      operation: 'dec',
	      value: step
	    });
	  };
	
	  Trait.prototype.set = function(value) {
	    return this.raw({
	      name: this.name,
	      operation: 'set',
	      value: value
	    });
	  };
	
	  Trait.prototype.raw = function(payload) {
	    return this._api.message('me/traits', 'put', payload);
	  };
	
	  return Trait;
	
	})();
	
	module.exports = function(api) {
	  return function(name, value) {
	    var traits;
	    if (_.isObject(name)) {
	      _.map(name, function(value, key) {
	        return new Trait(api, key, value);
	      });
	      return Hull.emit('hull.traits', name);
	    } else {
	      traits = {};
	      traits[name] = value;
	      Hull.emit('hull.traits', traits);
	      return new Trait(api, name, value);
	    }
	  };
	};


/***/ },
/* 113 */
/*!********************************!*\
  !*** ./src/hull-remote.coffee ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	var Channel, ClientConfigStore, ConfigNormalizer, EventBus, Gateway, Hull, Raven, RemoteActions, RemoteConfigStore, RemoteConstants, RemoteHeaderStore, RemoteUserStore, Services, captureException, hull, locationOrigin, logger, polyfill, qs;
	
	Raven = __webpack_require__(/*! ./utils/raven */ 30);
	
	polyfill = __webpack_require__(/*! ./utils/load-polyfills */ 29);
	
	EventBus = __webpack_require__(/*! ./utils/eventbus */ 6);
	
	logger = __webpack_require__(/*! ./utils/logger */ 5);
	
	ConfigNormalizer = __webpack_require__(/*! ./utils/config-normalizer */ 130);
	
	locationOrigin = __webpack_require__(/*! ./utils/location-origin */ 134);
	
	qs = __webpack_require__(/*! ./utils/query-string-encoder */ 19);
	
	Services = __webpack_require__(/*! ./remote/services */ 116);
	
	Gateway = __webpack_require__(/*! ./remote/gateway */ 115);
	
	Channel = __webpack_require__(/*! ./remote/channel */ 114);
	
	ClientConfigStore = __webpack_require__(/*! ./flux/stores/ClientConfigStore */ 85);
	
	RemoteHeaderStore = __webpack_require__(/*! ./flux/stores/RemoteHeaderStore */ 37);
	
	RemoteUserStore = __webpack_require__(/*! ./flux/stores/RemoteUserStore */ 24);
	
	RemoteConfigStore = __webpack_require__(/*! ./flux/stores/RemoteConfigStore */ 27);
	
	RemoteActions = __webpack_require__(/*! ./flux/actions/RemoteActions */ 50);
	
	RemoteConstants = __webpack_require__(/*! ./flux/constants/RemoteConstants */ 17);
	
	captureException = function(err, ctx) {
	  return Raven.captureException(err, ctx);
	};
	
	hull = void 0;
	
	Hull = function(remoteConfig) {
	  var config, polyfilled;
	  if (hull) {
	    return hull;
	  }
	  config = ConfigNormalizer(remoteConfig);
	  Raven.init(config.queryParams.ravenDsn, {
	    runtime: 'hull-remote',
	    orgUrl: locationOrigin(),
	    appId: config.appId
	  });
	  polyfilled = polyfill.fill(config);
	  return polyfilled.then(function() {
	    var channel, gateway, hideOnClick, request, services, subscribeToEvents;
	    RemoteActions.updateRemoteConfig(config);
	    hull = {
	      config: config
	    };
	    gateway = new Gateway(config);
	    services = new Services(config, gateway);
	    channel = new Channel(config, services);
	    ClientConfigStore.addChangeListener((function(_this) {
	      return function(change) {
	        return logger.init((ClientConfigStore.getState() || {}).debug);
	      };
	    })(this));
	    RemoteConfigStore.addChangeListener((function(_this) {
	      return function(change) {
	        switch (change) {
	          case RemoteConstants.UPDATE_REMOTE_CONFIG:
	          case RemoteConstants.UPDATE_SETTINGS:
	            channel.rpc.configUpdate(RemoteConfigStore.getState());
	            break;
	        }
	      };
	    })(this));
	    RemoteUserStore.addChangeListener((function(_this) {
	      return function(change) {
	        switch (change) {
	          case RemoteConstants.UPDATE_USER:
	          case RemoteConstants.CLEAR_USER:
	            channel.rpc.userUpdate(RemoteUserStore.getState().user);
	            break;
	        }
	      };
	    })(this));
	    request = services.services.hull.request;
	    hideOnClick = function(e) {
	      return channel.rpc.hide();
	    };
	    subscribeToEvents = function(clientConfig) {
	      if (document.addEventListener) {
	        document.addEventListener('click', hideOnClick);
	      } else if (document.attachEvent) {
	        document.attachEvent('onclick', hideOnClick);
	      }
	      EventBus.on('remote.iframe.show', function() {
	        return channel.rpc.show();
	      });
	      EventBus.on('remote.iframe.hide', function() {
	        return channel.rpc.hide();
	      });
	      EventBus.on('remote.track', function(payload) {
	        return services.services.track.request({
	          params: payload.params,
	          path: payload.event
	        });
	      });
	      EventBus.on('remote.tracked', function(payload) {
	        return channel.rpc.track(payload);
	      });
	      return clientConfig;
	    };
	    return channel.promise.then(subscribeToEvents).then(function(clientConfig) {
	      return RemoteActions.updateClientConfig(clientConfig);
	    })["catch"](function(err) {
	      captureException(err);
	      return console.error("Could not initialize Hull: " + err.message);
	    });
	  })["catch"](function(err) {
	    captureException(err);
	    return console.error("Could not initialize Hull: " + err.message);
	  });
	};
	
	Hull.version = ("0.9.0");
	
	module.exports = Hull;


/***/ },
/* 114 */
/*!***********************************!*\
  !*** ./src/remote/channel.coffee ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var Channel, Promise, catchAll, xdm;
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	xdm = __webpack_require__(/*! ../utils/xdm */ 53);
	
	catchAll = function(res) {
	  return res;
	};
	
	Channel = (function() {
	  function Channel(config, services) {
	    var domains, e, error, error1, local, whitelisted;
	    this._ready = {};
	    this.promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _this._ready.resolve = resolve;
	        return _this._ready.reject = reject;
	      };
	    })(this));
	    this.rpc = null;
	    try {
	      local = services.getMethods();
	      this.rpc = new xdm.Rpc({
	        acl: config.appDomains
	      }, {
	        remote: {
	          ready: {},
	          message: {},
	          userUpdate: {},
	          configUpdate: {},
	          getClientConfig: {},
	          track: {},
	          show: {},
	          hide: {}
	        },
	        local: local
	      });
	      this.rpc.ready(config);
	      this.rpc.getClientConfig(this._ready.resolve);
	    } catch (error) {
	      e = error;
	      try {
	        domains = (config.appDomains || []).toString();
	        whitelisted = domains.replace(/\(\:\[0-9\]\+\)\?\$/g, '').replace(/\^\(https\?\:\/\/\)\?/g, '').replace(/\\/g, '');
	        e = new Error(e.message + ", You should whitelist this domain. The following domains are authorized : \n" + whitelisted);
	        this._ready.reject(e);
	        this.rpc = new xdm.Rpc({}, {
	          local: {},
	          remote: {
	            loadError: {}
	          }
	        });
	        this.rpc.loadError(e.message);
	      } catch (error1) {
	        e = error1;
	        throw new Error("Unable to establish communication between Hull Remote and your page. " + e.message);
	      }
	    }
	  }
	
	  return Channel;
	
	})();
	
	module.exports = Channel;


/***/ },
/* 115 */
/*!***********************************!*\
  !*** ./src/remote/gateway.coffee ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var API_PATH, API_PATH_REGEXP, Base64, EventBus, Gateway, Promise, QSEncoder, RESPONSE_HEADERS, RemoteHeaderStore, _, assign, batchable, clone, cookies, formatBatchParams, logger, normalizePath, reduceHeaders, resolveResponse, superagent,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 2);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 28);
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 18);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	EventBus = __webpack_require__(/*! ../utils/eventbus */ 6);
	
	clone = __webpack_require__(/*! ../utils/clone */ 9);
	
	RemoteHeaderStore = __webpack_require__(/*! ../flux/stores/RemoteHeaderStore */ 37);
	
	QSEncoder = __webpack_require__(/*! ../utils/query-string-encoder */ 19);
	
	superagent = __webpack_require__(/*! superagent */ 22);
	
	API_PATH = '/api/v1/';
	
	API_PATH_REGEXP = /^\/?api\/v1\//;
	
	RESPONSE_HEADERS = ['Hull-Auth-Scope', 'Hull-Track', 'Hull-User-Id', 'Hull-User-Sig', 'X-Hits-Count', 'Link'];
	
	normalizePath = function(path) {
	  if (API_PATH_REGEXP.test(path)) {
	    return path.replace(API_PATH_REGEXP, API_PATH);
	  }
	  if (path[0] === '/') {
	    path = path.substring(1);
	  }
	  return API_PATH + path;
	};
	
	batchable = function(threshold, callback) {
	  var args, timeout;
	  timeout = null;
	  args = [];
	  return function() {
	    var delayed;
	    args.push(Array.prototype.slice.call(arguments));
	    clearTimeout(timeout);
	    delayed = (function(_this) {
	      return function() {
	        callback.call(_this, args);
	        timeout = null;
	        return args = [];
	      };
	    })(this);
	    return timeout = setTimeout(delayed, threshold);
	  };
	};
	
	reduceHeaders = function(headers) {
	  var _headers;
	  _headers = _.reduce(headers, function(memo, value, key) {
	    memo[key.toLowerCase()] = value;
	    return memo;
	  }, {});
	  return _.reduce(RESPONSE_HEADERS, function(memo, name) {
	    var value;
	    value = _headers[name.toLowerCase()];
	    if (value != null) {
	      memo[name] = value;
	    }
	    return memo;
	  }, {});
	};
	
	formatBatchParams = function(requests) {
	  var c, params, r, request;
	  params = {
	    sequential: true
	  };
	  params.ops = (function() {
	    var j, len, results;
	    results = [];
	    for (j = 0, len = requests.length; j < len; j++) {
	      request = requests[j];
	      r = request[0];
	      c = {
	        method: r.method,
	        url: r.path
	      };
	      if (r.params != null) {
	        c.params = r.params;
	      }
	      if (r.headers != null) {
	        c.headers = r.headers;
	      }
	      results.push(c);
	    }
	    return results;
	  })();
	  return params;
	};
	
	resolveResponse = function(request, response, resolve, reject) {
	  var h, headers;
	  headers = reduceHeaders(response.headers);
	  h = {
	    body: response.body,
	    status: response.status,
	    headers: headers,
	    request: request
	  };
	  return resolve(h);
	};
	
	Gateway = (function() {
	  function Gateway(config) {
	    var appId, batching, identify;
	    if (config == null) {
	      config = {};
	    }
	    this.before = bind(this.before, this);
	    this.after = bind(this.after, this);
	    this.fetch = bind(this.fetch, this);
	    batching = config.batching, appId = config.appId, identify = config.identify;
	    this.identify = identify;
	    this.options = _.defaults({}, batching, {
	      min: 1,
	      max: 1,
	      delay: 2
	    });
	    this.queue = batchable(this.options.delay, function(requests) {
	      return this.flush(requests);
	    });
	  }
	
	  Gateway.prototype.identifyBrowserAndSession = function() {
	    var ident;
	    ident = {};
	    if (!cookies.get('_bid')) {
	      ident['Hull-Bid'] = this.identify.browser;
	    }
	    if (!cookies.get('_sid')) {
	      ident['Hull-Sid'] = this.identify.session;
	    }
	    return ident;
	  };
	
	  Gateway.prototype.resetIdentify = function() {
	    return this.identify = {};
	  };
	
	  Gateway.prototype.fetch = function(options) {
	    var headers, method, params, path, s;
	    if (options == null) {
	      options = {};
	    }
	    method = options.method, headers = options.headers, path = options.path, params = options.params;
	    method = (method || 'get').toUpperCase();
	    headers = assign(this.identifyBrowserAndSession(), RemoteHeaderStore.getState(), headers);
	    s = superagent(method, path).set(headers);
	    if ((params != null) && method === 'GET') {
	      s.query(QSEncoder.encode(params));
	    } else {
	      s.send(params);
	    }
	    return new Promise(function(resolve, reject) {
	      logger.verbose(">", method, path, params, headers);
	      return s.end((function(_this) {
	        return function(response) {
	          var h;
	          logger.verbose("<", method, path, response);
	          h = {
	            body: response.body,
	            headers: response.headers,
	            status: response.status
	          };
	          return resolve(h);
	        };
	      })(this));
	    });
	  };
	
	  Gateway.prototype.flush = function(requests) {
	    var ref, reject, request, resolve, results;
	    if (requests.length <= this.options.min) {
	      results = [];
	      while (requests.length) {
	        ref = requests.pop(), request = ref[0], resolve = ref[1], reject = ref[2];
	        results.push(this.handleOne(request, resolve, reject));
	      }
	      return results;
	    } else {
	      this.handleMany(requests.splice(0, this.options.max));
	      if (requests.length) {
	        return this.flush(requests);
	      }
	    }
	  };
	
	  Gateway.prototype.after_middlewares = [];
	
	  Gateway.prototype.before_middlewares = [];
	
	  Gateway.prototype.after = function(cb) {
	    if (!((cb != null) && _.isFunction(cb))) {
	      return;
	    }
	    this.after_middlewares.push(cb);
	    return cb;
	  };
	
	  Gateway.prototype.before = function(cb) {
	    if (!((cb != null) && _.isFunction(cb))) {
	      return;
	    }
	    this.before_middlewares.push(cb);
	    return cb;
	  };
	
	  Gateway.prototype.handle = function(request) {
	    var promise;
	    request.path = normalizePath(request.path);
	    promise = new Promise((function(_this) {
	      return function(resolve, reject) {
	        _.each(_this.before_middlewares, function(middleware) {
	          return middleware(request);
	        });
	        return _this.queue(request, resolve, reject);
	      };
	    })(this));
	    if (!request.nocallback) {
	      _.each(this.after_middlewares, function(middleware) {
	        return promise = promise.then(middleware);
	      });
	    }
	    return promise["catch"](function(err) {
	      throw err;
	    });
	  };
	
	  Gateway.prototype.handleOne = function(request, resolve, reject) {
	    var error, success;
	    success = function(response) {
	      return resolveResponse(request, response, resolve, reject);
	    };
	    error = function(error) {
	      var response;
	      response = error.body;
	      return reject({
	        response: response,
	        request: request,
	        headers: {}
	      });
	    };
	    return this.fetch(request).then(success, error);
	  };
	
	  Gateway.prototype.handleMany = function(requests) {
	    var error, params, success;
	    params = formatBatchParams(requests);
	    success = function(responses) {
	      var i, j, len, ref, response;
	      ref = responses.body.results;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        response = ref[i];
	        resolveResponse(requests[i], response, requests[i][1], requests[i][2]);
	      }
	      return void 0;
	    };
	    error = function(response) {
	      var j, len, request, results;
	      results = [];
	      for (j = 0, len = requests.length; j < len; j++) {
	        request = requests[j];
	        results.push(request[1].reject({
	          response: response,
	          headers: {},
	          request: request
	        }));
	      }
	      return results;
	    };
	    return this.fetch({
	      method: 'post',
	      path: '/api/v1/batch',
	      params: params
	    }).then(success, error);
	  };
	
	  return Gateway;
	
	})();
	
	module.exports = Gateway;


/***/ },
/* 116 */
/*!************************************!*\
  !*** ./src/remote/services.coffee ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var Promise, RemoteActions, RemoteConfigStore, RemoteConstants, RemoteHeaderStore, RemoteUserStore, ServiceList, Services, _, assign, cookies, handleSpecialRoutes, logger, maybeUpdateUser,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	logger = __webpack_require__(/*! ../utils/logger */ 5);
	
	Promise = __webpack_require__(/*! ../utils/promises */ 3);
	
	assign = __webpack_require__(/*! ../polyfills/assign */ 2);
	
	ServiceList = __webpack_require__(/*! ./services/list */ 125);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 28);
	
	RemoteHeaderStore = __webpack_require__(/*! ../flux/stores/RemoteHeaderStore */ 37);
	
	RemoteUserStore = __webpack_require__(/*! ../flux/stores/RemoteUserStore */ 24);
	
	RemoteConfigStore = __webpack_require__(/*! ../flux/stores/RemoteConfigStore */ 27);
	
	RemoteActions = __webpack_require__(/*! ../flux/actions/RemoteActions */ 50);
	
	RemoteConstants = __webpack_require__(/*! ../flux/constants/RemoteConstants */ 17);
	
	handleSpecialRoutes = function(request) {
	  switch (request.path) {
	    case '/api/v1/logout':
	      request.nocallback = true;
	      RemoteActions.logoutUser();
	      break;
	  }
	  return request;
	};
	
	maybeUpdateUser = function(response) {
	  RemoteActions.updateUserIfMe(response);
	  return response;
	};
	
	Services = (function() {
	  function Services(remoteConfig, gateway) {
	    this.onMessage = bind(this.onMessage, this);
	    this.handleAdminCall = bind(this.handleAdminCall, this);
	    this.onRefreshUser = bind(this.onRefreshUser, this);
	    this.onResetIdentify = bind(this.onResetIdentify, this);
	    if (remoteConfig.data.me) {
	      RemoteActions.updateUser(remoteConfig.data.me);
	    }
	    this.gateway = gateway;
	    gateway.before(handleSpecialRoutes);
	    gateway.after(maybeUpdateUser);
	    this.services = _.reduce(ServiceList, function(memo, Service, key) {
	      memo[key] = new Service(remoteConfig, gateway);
	      return memo;
	    }, {});
	    RemoteHeaderStore.addChangeListener((function(_this) {
	      return function(change) {
	        var user, userHeaderId;
	        switch (change) {
	          case RemoteConstants.UPDATE_USER:
	            userHeaderId = RemoteHeaderStore.getHeader('Hull-User-Id');
	            user = RemoteUserStore.getState().user;
	            if (userHeaderId !== (user != null ? user.id : void 0)) {
	              _this.onRefreshUser();
	            }
	            break;
	        }
	      };
	    })(this));
	  }
	
	  Services.prototype.getMethods = function() {
	    return {
	      ready: this.onReady,
	      message: this.onMessage,
	      refreshUser: this.onRefreshUser,
	      resetIdentify: this.onResetIdentify
	    };
	  };
	
	  Services.prototype.onResetIdentify = function(xdmCallback, xdmErrback) {
	    cookies.remove('_bid', {
	      path: '/',
	      domain: document.location.host
	    });
	    cookies.remove('_sid', {
	      path: '/',
	      domain: document.location.host
	    });
	    return this.gateway.resetIdentify();
	  };
	
	  Services.prototype.onReady = function(req, xdmCallback, xdmErrback) {};
	
	  Services.prototype.onRefreshUser = function(xdmCallback, xdmErrback) {
	    var me, onError, onSuccess, settings;
	    if (xdmCallback == null) {
	      xdmCallback = function() {};
	    }
	    if (xdmErrback == null) {
	      xdmErrback = function() {};
	    }
	    me = this.services.hull.request({
	      path: 'me',
	      nocallback: true
	    });
	    settings = this.services.hull.request({
	      path: 'app/settings',
	      nocallback: true
	    });
	    onSuccess = (function(_this) {
	      return function(res) {
	        var services;
	        me = res[0].body;
	        services = res[1].body;
	        RemoteActions.updateUser(me, {
	          silent: true
	        });
	        RemoteActions.updateServices(services, {
	          silent: true
	        });
	        xdmCallback({
	          me: me,
	          services: services,
	          headers: res[0].headers
	        });
	        return void 0;
	      };
	    })(this);
	    onError = function(res) {
	      var error, ref;
	      if (res == null) {
	        res = {};
	      }
	      xdmErrback(res.response || res);
	      error = new Error((res != null ? (ref = res.response) != null ? ref.message : void 0 : void 0) || (res != null ? res.response : void 0) || res);
	      logger.error('Failed refreshing User', error.message, error.stack);
	      throw error;
	    };
	    Promise.all([me, settings]).then(onSuccess, onError);
	    return void 0;
	  };
	
	  Services.prototype.handleAdminCall = function(request, callback, errback) {};
	
	  Services.prototype.onMessage = function(request, xdmCallback, xdmErrback) {
	    var service;
	    if (xdmCallback == null) {
	      xdmCallback = function() {};
	    }
	    if (xdmErrback == null) {
	      xdmErrback = function() {};
	    }
	    if (!request.path) {
	      throw new Error("Path not recognized " + (JSON.stringify(request, null, 2)));
	    }
	    service = this.services[request.provider];
	    if (_.isFunction(service.request)) {
	      service.request(request, xdmCallback, xdmErrback);
	      return void 0;
	    } else {
	      xdmErrback(request);
	    }
	    return void 0;
	  };
	
	  return Services;
	
	})();
	
	module.exports = Services;


/***/ },
/* 117 */
/*!******************************************!*\
  !*** ./src/remote/services/admin.coffee ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, HullAdminService, QSEncoder, RemoteConfigStore, logger, superagent,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	superagent = __webpack_require__(/*! superagent */ 22);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	QSEncoder = __webpack_require__(/*! ../../utils/query-string-encoder */ 19);
	
	logger = __webpack_require__(/*! ../../utils/logger */ 5);
	
	RemoteConfigStore = __webpack_require__(/*! ../../flux/stores/RemoteConfigStore */ 27);
	
	HullAdminService = (function(superClass) {
	  extend(HullAdminService, superClass);
	
	  HullAdminService.prototype.name = 'hull';
	
	  function HullAdminService(config, gateway) {}
	
	  HullAdminService.prototype.request = function(request, callback, errback) {
	    var headers, method, organization, params, path, protocol, s, token, top_domain, url;
	    method = request.method, path = request.path, params = request.params, organization = request.organization;
	    if (organization == null) {
	      throw new Error('No organization defined');
	    }
	    method = method.toUpperCase();
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    top_domain = document.location.host.split('.');
	    top_domain.shift();
	    top_domain = top_domain.join('.');
	    protocol = document.location.protocol;
	    url = protocol + "//" + organization + "." + top_domain + "/api/v1/" + path;
	    headers = {};
	    token = RemoteConfigStore.getHullToken();
	    if (token) {
	      headers['AccessToken'] = token;
	    }
	    s = superagent(method, url).set(headers);
	    if (method === 'GET' && (params != null)) {
	      s.query(QSEncoder.encode(params));
	    } else {
	      s.send(params);
	    }
	    return s.end(function(response) {
	      if (response.error) {
	        return errback(response.body, response.error);
	      }
	      return callback({
	        provider: 'admin',
	        body: response.body
	      });
	    });
	  };
	
	  return HullAdminService;
	
	})(GenericService);
	
	module.exports = HullAdminService;


/***/ },
/* 118 */
/*!**********************************************!*\
  !*** ./src/remote/services/angellist.coffee ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var AngelListService, GenericService, assign,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	AngelListService = (function(superClass) {
	  extend(AngelListService, superClass);
	
	  AngelListService.prototype.name = 'angellist';
	
	  AngelListService.prototype.path = 'angellist';
	
	  function AngelListService(config, gateway) {}
	
	  AngelListService.prototype.request = function(request, callback, errback) {
	    var method, params, path, token;
	    method = request.method, path = request.path, params = request.params;
	    method = method.toLowerCase();
	    if (method !== 'get') {
	      return errback('Unable to perform non-GET requests on AngelList');
	    }
	    token = this.getSettings();
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    params = {
	      url: "https://api.linkedin.com/v1/" + path,
	      data: assign({}, params, {
	        access_token: this.token.access_token
	      }),
	      error: function(err) {
	        return errback(err.url);
	      },
	      success: function(response) {
	        return callback({
	          body: response.data,
	          provider: this.name
	        });
	      }
	    };
	    return this.request_jsonp(params);
	  };
	
	  return AngelListService;
	
	})(GenericService);
	
	module.exports = AngelListService;


/***/ },
/* 119 */
/*!*********************************************!*\
  !*** ./src/remote/services/facebook.coffee ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var EventBus, FB_EVENTS, FacebookService, GenericService, Promise, _, assign, clone,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	clone = __webpack_require__(/*! ../../utils/clone */ 9);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	FB_EVENTS = ["auth.authResponseChanged", "auth.statusChange", "auth.login", "auth.logout", "comment.create", "comment.remove", "edge.create", "edge.remove", "message.send", "xfbml.render"];
	
	FacebookService = (function(superClass) {
	  extend(FacebookService, superClass);
	
	  FacebookService.prototype.name = 'facebook';
	
	  FacebookService.prototype.path = 'facebook';
	
	  function FacebookService(config, gateway) {
	    this.subscribeToFBEvents = bind(this.subscribeToFBEvents, this);
	    this.updateFBUserStatus = bind(this.updateFBUserStatus, this);
	    this.fbUiCallback = bind(this.fbUiCallback, this);
	    this.fbRequestCallback = bind(this.fbRequestCallback, this);
	    this.performRequest = bind(this.performRequest, this);
	    this.ensureLoggedIn = bind(this.ensureLoggedIn, this);
	    this.request = bind(this.request, this);
	    var settings;
	    FacebookService.__super__.constructor.call(this, config, gateway);
	    settings = this.getSettings();
	    if (settings != null ? settings.appId : void 0) {
	      this.loadFbSdk(settings);
	    }
	  }
	
	  FacebookService.prototype.request = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return this.ensureLoggedIn().then((function(_this) {
	      return function() {
	        return _this.performRequest.apply(_this, args);
	      };
	    })(this));
	  };
	
	  FacebookService.prototype.ensureLoggedIn = function() {
	    var self;
	    self = this;
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var args, ref;
	        args = Array.prototype.slice.call(arguments);
	        if (((ref = _this.fbUser) != null ? ref.status : void 0) === 'connected') {
	          return resolve();
	        } else {
	          return FB.getLoginStatus(function(res) {
	            self.updateFBUserStatus(res);
	            if (res.status === 'connected') {
	              return resolve();
	            } else {
	              return reject();
	            }
	          }, true);
	        }
	      };
	    })(this));
	  };
	
	  FacebookService.prototype.performRequest = function(request, callback, errback) {
	    var fbCallback, fbErrback, isUICall, params, path, ref, trackParams;
	    path = request.path;
	    isUICall = path === 'ui' && (((ref = request.params) != null ? ref.method : void 0) != null);
	    fbErrback = function(msg, res) {
	      res.time = new Date();
	      return errback(res);
	    };
	    fbCallback = this.fbRequestCallback(request, {
	      isUICall: isUICall,
	      path: path
	    }, callback, errback);
	    if (path === 'fql.query') {
	      return FB.api({
	        method: 'fql.query',
	        query: request.params.query
	      }, fbCallback);
	    } else if (isUICall) {
	      params = clone(request.params);
	      this.showIframe();
	      trackParams = {
	        ui_request_id: (typeof utils !== "undefined" && utils !== null ? typeof utils.uuid === "function" ? utils.uuid() : void 0 : void 0) || (new Date()).getTime()
	      };
	      this.track({
	        event: "facebook." + path + ".open",
	        params: assign({}, request.params, trackParams)
	      });
	      return setTimeout((function(_this) {
	        return function() {
	          return FB.ui(params, function(response) {
	            var event;
	            event = "facebook." + path + ".";
	            event += !response || response.error_code ? "error" : "success";
	            _this.track({
	              event: event,
	              params: assign({}, response, trackParams)
	            });
	            return fbCallback(response);
	          });
	        };
	      })(this), 100);
	    } else {
	      return FB.api(path, request.method, request.params, this.fbRequestCallback(request, {
	        isUICall: false,
	        path: path
	      }, callback, fbErrback));
	    }
	  };
	
	  FacebookService.prototype.showIframe = function() {
	    if (this.fb) {
	      return EventBus.emit('remote.iframe.show');
	    }
	  };
	
	  FacebookService.prototype.hideIframe = function() {
	    if (this.fb) {
	      return EventBus.emit('remote.iframe.hide');
	    }
	  };
	
	  FacebookService.prototype.track = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return EventBus.emit.apply(EventBus, ['remote.track'].concat(slice.call(args)));
	  };
	
	  FacebookService.prototype.fbRequestCallback = function(request, opts, callback, errback) {
	    if (opts == null) {
	      opts = {};
	    }
	    return (function(_this) {
	      return function(response) {
	        var errorMsg;
	        if (opts.isUICall) {
	          _this.fbUiCallback(request, response, opts.path);
	        }
	        if (!response || (response != null ? response.error : void 0)) {
	          errorMsg = response ? "[Facebook Error] " + response.error.type + "  : " + response.error.message : "[Facebook Error] Unknown error";
	          return errback(errorMsg, {
	            response: response,
	            request: request
	          });
	        }
	        return callback({
	          body: response,
	          provider: 'facebook'
	        });
	      };
	    })(this);
	  };
	
	  FacebookService.prototype.fbUiCallback = function(req, res, path) {
	    var opts;
	    this.hideIframe();
	    opts = {
	      path: path,
	      method: 'post',
	      params: res
	    };
	    return this.wrappedRequest(opts);
	  };
	
	  FacebookService.prototype.updateFBUserStatus = function(res) {
	    return this.fbUser = res;
	  };
	
	  FacebookService.prototype.subscribeToFBEvents = function() {
	    var self;
	    if ((typeof FB !== "undefined" && FB !== null ? FB.Event : void 0) == null) {
	      return;
	    }
	    self = this;
	    return _.map(FB_EVENTS, (function(_this) {
	      return function(event) {
	        return FB.Event.subscribe(event, function() {
	          var args;
	          args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	          if (event.indexOf('auth.') > -1) {
	            self.updateFBUserStatus.apply(self, args);
	          }
	          return EventBus.emit.apply(EventBus, ["fb." + event].concat(slice.call(args)));
	        });
	      };
	    })(this));
	  };
	
	  FacebookService.prototype.loadFbSdk = function(config) {
	    return new Promise((function(_this) {
	      return function(resolve, reject) {
	        var fb;
	        config = _.omit(assign({}, config, {
	          status: true
	        }), 'credentials');
	        fb = document.createElement('script');
	        fb.type = 'text/javascript';
	        fb.async = true;
	        fb.src = "https://connect.facebook.net/en_US/all.js";
	        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(fb);
	        return window.fbAsyncInit = function() {
	          _this.fb = true;
	          FB.init(config);
	          FB.getLoginStatus(_this.updateFBUserStatus);
	          _this.subscribeToFBEvents();
	          return resolve({});
	        };
	      };
	    })(this));
	  };
	
	  return FacebookService;
	
	})(GenericService);
	
	module.exports = FacebookService;


/***/ },
/* 120 */
/*!*******************************************!*\
  !*** ./src/remote/services/github.coffee ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, GithubService, QSEncoder, superagent,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	superagent = __webpack_require__(/*! superagent */ 22);
	
	QSEncoder = __webpack_require__(/*! ../../utils/query-string-encoder */ 19);
	
	GithubService = (function(superClass) {
	  extend(GithubService, superClass);
	
	  GithubService.prototype.name = 'github';
	
	  GithubService.prototype.path = 'github';
	
	  function GithubService(config, gateway) {
	    this.request = bind(this.request, this);
	    GithubService.__super__.constructor.call(this, config, gateway);
	  }
	
	  GithubService.prototype.request = function(request, callback, errback) {
	    var method, params, path, ref, s, token, url;
	    token = (ref = this.getSettings().credentials) != null ? ref.token : void 0;
	    method = request.method, path = request.path, params = request.params;
	    method = method.toUpperCase();
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    url = "https://api.github.com/" + path;
	    s = superagent(method, url);
	    if (method === 'GET' && (params != null)) {
	      s.query(QSEncoder.encode(params));
	    } else {
	      s.send(params);
	    }
	    if (token) {
	      s.set('Authorization', "token " + token);
	    }
	    return s.end(function(response) {
	      if (response.error) {
	        return errback(response.error.message);
	      }
	      return callback({
	        provider: this.name,
	        headers: response.headers,
	        body: response.body
	      });
	    });
	  };
	
	  return GithubService;
	
	})(GenericService);
	
	module.exports = GithubService;


/***/ },
/* 121 */
/*!*******************************************!*\
  !*** ./src/remote/services/google.coffee ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, GoogleService, assign,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	GoogleService = (function(superClass) {
	  extend(GoogleService, superClass);
	
	  GoogleService.prototype.name = 'google';
	
	  GoogleService.prototype.path = 'google';
	
	  function GoogleService(config, gateway) {
	    this.request = bind(this.request, this);
	    GoogleService.__super__.constructor.call(this, config, gateway);
	  }
	
	  GoogleService.prototype.request = function(request, callback, errback) {
	    var method, params, path, ref, token;
	    token = (ref = this.getSettings().credentials) != null ? ref.token : void 0;
	    if (token == null) {
	      return errback('No Google+ User');
	    }
	    method = request.method, path = request.path, params = request.params;
	    method = method.toLowerCase();
	    if (method !== 'get') {
	      return errback('Unable to perform non-GET requests on Google+');
	    }
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    params = {
	      url: "https://www.googleapis.com/plus/v1/" + path,
	      data: assign({}, params, {
	        access_token: token
	      }),
	      error: function(err) {
	        return errback(err.url);
	      },
	      success: (function(_this) {
	        return function(response) {
	          return callback({
	            provider: _this.name,
	            body: response
	          });
	        };
	      })(this)
	    };
	    return this.request_jsonp(params);
	  };
	
	  return GoogleService;
	
	})(GenericService);
	
	module.exports = GoogleService;


/***/ },
/* 122 */
/*!*****************************************!*\
  !*** ./src/remote/services/hull.coffee ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var Base64, EventBus, HullService, Promise, RECAPTCHA_ONLOAD, RECAPTCHA_SRC, TrackEventMatcher, _, _loadRecaptchaScriptPromise, addEvent, assign, displayBanner, getWrappedRequest, loadRecaptchaScript, ref, removeBanner, removeEvent, scriptLoader, stopEventPropagation, trackResponse,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	Promise = __webpack_require__(/*! ../../utils/promises */ 3);
	
	_ = __webpack_require__(/*! ../../utils/lodash */ 1);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	Base64 = __webpack_require__(/*! ../../utils/base64 */ 18);
	
	getWrappedRequest = __webpack_require__(/*! ../wrapped-request */ 51);
	
	scriptLoader = __webpack_require__(/*! ../../utils/script-loader */ 31);
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	displayBanner = __webpack_require__(/*! ../../utils/ui/display-banner */ 61);
	
	ref = __webpack_require__(/*! ../../utils/dom-events */ 88), addEvent = ref.addEvent, removeEvent = ref.removeEvent;
	
	RECAPTCHA_ONLOAD = '___recaptcha___';
	
	RECAPTCHA_SRC = "https://www.google.com/recaptcha/api.js?onload=" + RECAPTCHA_ONLOAD + "&render=explicit";
	
	_loadRecaptchaScriptPromise = null;
	
	loadRecaptchaScript = function() {
	  if ((_loadRecaptchaScriptPromise != null)) {
	    return _loadRecaptchaScriptPromise;
	  }
	  _loadRecaptchaScriptPromise = new Promise(function(resolve) {
	    window[RECAPTCHA_ONLOAD] = resolve;
	    scriptLoader({
	      src: RECAPTCHA_SRC
	    });
	    return null;
	  });
	  return _loadRecaptchaScriptPromise;
	};
	
	TrackEventMatcher = (function() {
	  function TrackEventMatcher(config) {
	    if (config === false || ((config != null ? config.ignore : void 0) != null)) {
	      this.mode = 'ignore';
	      this._initMatchers(config.ignore);
	    } else if (config == null) {
	      this.mode = 'match_all';
	    } else {
	      this.mode = 'match';
	      this._initMatchers((config != null ? config.only : void 0) || config);
	    }
	  }
	
	  TrackEventMatcher.prototype._initMatchers = function(m) {
	    if (_.isString(m)) {
	      m = [m];
	    }
	    return this.matchers = _.map(_.compact(m), function(c) {
	      var _c;
	      _c = c.toString();
	      if (/^\/.*\/$/.test(_c)) {
	        return new RegExp(_c.slice(1, -1));
	      } else {
	        return _c;
	      }
	    });
	  };
	
	  TrackEventMatcher.prototype.isTracked = function(event) {
	    var ret;
	    if (event == null) {
	      return false;
	    }
	    if (this.mode === 'match_all') {
	      return true;
	    }
	    ret = _.some(_.map(this.matchers, function(m) {
	      if (_.isFunction(m.test)) {
	        return m.test(event);
	      } else {
	        return m === event;
	      }
	    }));
	    if (this.mode === 'ignore') {
	      return !ret;
	    } else {
	      return ret;
	    }
	  };
	
	  return TrackEventMatcher;
	
	})();
	
	trackResponse = (function(_this) {
	  return function(response) {
	    var error, error1, eventName, payload, ref1, ref2, track;
	    if (response == null) {
	      response = {};
	    }
	    if (track = (ref1 = response.headers) != null ? ref1['Hull-Track'] : void 0) {
	      try {
	        ref2 = JSON.parse(Base64.decode(track)), eventName = ref2[0], payload = ref2[1];
	        EventBus.emit('remote.track', {
	          event: eventName,
	          params: {
	            payload: payload,
	            url: document.referrer
	          }
	        });
	      } catch (error1) {
	        error = error1;
	        "Invalid Tracking header : ${JSON.stringify(errror,null,2)}";
	      }
	    }
	    return response;
	  };
	})(this);
	
	stopEventPropagation = function(e) {
	  return e.stopPropagation();
	};
	
	removeBanner = function(banner) {
	  removeEvent(banner, 'click', stopEventPropagation);
	  return banner.remove();
	};
	
	HullService = (function() {
	  function HullService(config, gateway) {
	    this.ensureIsHuman = bind(this.ensureIsHuman, this);
	    var middlewares;
	    this.config = config;
	    middlewares = [this.ensureIsHuman, trackResponse];
	    this.request = getWrappedRequest({
	      name: 'hull',
	      path: null
	    }, gateway, middlewares);
	    this.trackMatcher = new TrackEventMatcher(config.track);
	  }
	
	  HullService.prototype.ensureIsHuman = function(response) {
	    var banner, performRequest, ref1, sitekey, stoken;
	    if (response.body == null) {
	      return response;
	    }
	    ref1 = response.body, sitekey = ref1.sitekey, stoken = ref1.stoken;
	    if (response.status !== 429 || (sitekey == null) || (stoken == null)) {
	      return response;
	    }
	    banner = this._getCaptchaBanner();
	    performRequest = this.request;
	    return new Promise(function(resolve, reject) {
	      return loadRecaptchaScript().then(function() {
	        grecaptcha.render(banner.querySelector('.hull-captcha-container'), {
	          sitekey: sitekey,
	          stoken: stoken,
	          callback: function(captchaResponse) {
	            var requestWithCaptcha;
	            EventBus.emit('remote.iframe.hide');
	            removeBanner(banner);
	            requestWithCaptcha = assign({}, response.request, {
	              headers: assign({}, response.request.headers, {
	                'X-Captcha-Response': captchaResponse
	              })
	            });
	            return performRequest(requestWithCaptcha).then(resolve, reject);
	          }
	        });
	        document.body.appendChild(banner);
	        return EventBus.emit('remote.iframe.show');
	      });
	    });
	  };
	
	  HullService.prototype._getCaptchaBanner = function() {
	    if (this._banner) {
	      removeBanner(this._banner);
	    }
	    this._banner = displayBanner('captcha', false);
	    addEvent(this._banner, 'click', stopEventPropagation);
	    return this._banner;
	  };
	
	  return HullService;
	
	})();
	
	module.exports = HullService;


/***/ },
/* 123 */
/*!**********************************************!*\
  !*** ./src/remote/services/instagram.coffee ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, InstagramService, assign,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	InstagramService = (function(superClass) {
	  extend(InstagramService, superClass);
	
	  InstagramService.prototype.name = 'instagram';
	
	  InstagramService.prototype.path = 'instagram';
	
	  function InstagramService(config, gateway) {
	    this.request = bind(this.request, this);
	    InstagramService.__super__.constructor.call(this, config, gateway);
	  }
	
	  InstagramService.prototype.request = function(request, callback, errback) {
	    var config, method, params, path;
	    config = this.getSettings();
	    if (typeof token === "undefined" || token === null) {
	      return errback('No Likedin User');
	    }
	    method = request.method, path = request.path, params = request.params;
	    method = method.toLowerCase();
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    if (method !== 'get') {
	      return this.wrappedRequest(request, callback, errback);
	    } else {
	      params = {
	        url: "https://api.instagram.com/v1/" + path,
	        data: assign({}, params, config),
	        error: function(err) {
	          return errback(err.url);
	        },
	        success: function(response) {
	          return callback({
	            provider: this.name,
	            body: response.data,
	            headers: {
	              pagination: response.pagination,
	              meta: response.meta
	            }
	          });
	        }
	      };
	      return this.request_jsonp(params);
	    }
	  };
	
	  return InstagramService;
	
	})(GenericService);
	
	module.exports = InstagramService;


/***/ },
/* 124 */
/*!*********************************************!*\
  !*** ./src/remote/services/linkedin.coffee ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, LinkedInService, assign,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	LinkedInService = (function(superClass) {
	  extend(LinkedInService, superClass);
	
	  LinkedInService.prototype.name = 'linkedin';
	
	  LinkedInService.prototype.path = 'linkedin';
	
	  function LinkedInService(config, gateway) {
	    this.request = bind(this.request, this);
	    LinkedInService.__super__.constructor.call(this, config, gateway);
	  }
	
	  LinkedInService.prototype.request = function(request, callback, errback) {
	    var method, params, path, ref, token;
	    token = (ref = this.getSettings().credentials) != null ? ref.token : void 0;
	    if (token == null) {
	      return errback('No Likedin User');
	    }
	    method = request.method, path = request.path, params = request.params;
	    method = method.toLowerCase();
	    if (method !== 'get') {
	      return errback('Unable to perform non-GET requests on Likedin');
	    }
	    if (path[0] === "/") {
	      path = path.substring(1);
	    }
	    params = {
	      url: "https://api.linkedin.com/v1/" + path,
	      data: assign({}, params, {
	        oauth2_access_token: token
	      }),
	      error: function(err) {
	        return errback(err.url);
	      },
	      success: (function(_this) {
	        return function(response) {
	          return callback({
	            provider: _this.name,
	            body: response
	          });
	        };
	      })(this)
	    };
	    return this.request_jsonp(params);
	  };
	
	  return LinkedInService;
	
	})(GenericService);
	
	module.exports = LinkedInService;


/***/ },
/* 125 */
/*!*****************************************!*\
  !*** ./src/remote/services/list.coffee ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  admin: __webpack_require__(/*! ./admin */ 117),
	  track: __webpack_require__(/*! ./track */ 127),
	  hull: __webpack_require__(/*! ./hull */ 122),
	  angellist: __webpack_require__(/*! ./angellist */ 118),
	  facebook: __webpack_require__(/*! ./facebook */ 119),
	  github: __webpack_require__(/*! ./github */ 120),
	  google: __webpack_require__(/*! ./google */ 121),
	  instagram: __webpack_require__(/*! ./instagram */ 123),
	  linkedin: __webpack_require__(/*! ./linkedin */ 124),
	  soundcloud: __webpack_require__(/*! ./soundcloud */ 126),
	  tumblr: __webpack_require__(/*! ./tumblr */ 128),
	  twitter: __webpack_require__(/*! ./twitter */ 129)
	};


/***/ },
/* 126 */
/*!***********************************************!*\
  !*** ./src/remote/services/soundcloud.coffee ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, SoundCloudService,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	SoundCloudService = (function(superClass) {
	  extend(SoundCloudService, superClass);
	
	  SoundCloudService.prototype.name = 'soundcloud';
	
	  SoundCloudService.prototype.path = 'soundcloud';
	
	  function SoundCloudService(config, gateway) {
	    SoundCloudService.__super__.constructor.call(this, config, gateway);
	    this.request = this.wrappedRequest;
	  }
	
	  return SoundCloudService;
	
	})(GenericService);
	
	module.exports = SoundCloudService;


/***/ },
/* 127 */
/*!******************************************!*\
  !*** ./src/remote/services/track.coffee ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var Base64, EventBus, GenericService, HullTrackService, Identity, MarketingProps, RemoteUserStore, StructuredEventProps, TopLevelProps, assign,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	assign = __webpack_require__(/*! ../../polyfills/assign */ 2);
	
	EventBus = __webpack_require__(/*! ../../utils/eventbus */ 6);
	
	RemoteUserStore = __webpack_require__(/*! ../../flux/stores/RemoteUserStore */ 24);
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	Base64 = __webpack_require__(/*! ../../utils/base64 */ 18);
	
	StructuredEventProps = ['category', 'action', 'label', 'property', 'value'];
	
	MarketingProps = ['campaign', 'source', 'medium', 'term', 'content'];
	
	TopLevelProps = ['hull_ship_id'].concat(StructuredEventProps);
	
	Identity = function(o) {
	  return o;
	};
	
	HullTrackService = (function(superClass) {
	  extend(HullTrackService, superClass);
	
	  HullTrackService.prototype.name = 'hull';
	
	  function HullTrackService(config, gateway) {
	    this.request = bind(this.request, this);
	    HullTrackService.__super__.constructor.call(this, config, gateway);
	    this._request = this.wrappedRequest;
	    RemoteUserStore.addChangeListener((function(_this) {
	      return function(change) {
	        var currentUser, currentUserId;
	        currentUser = RemoteUserStore.getState().user;
	        return currentUserId = currentUser != null ? currentUser.id : void 0;
	      };
	    })(this));
	  }
	
	  HullTrackService.prototype.request = function(opts, callback, errback) {
	    var event, params, path;
	    params = opts.params, path = opts.path;
	    event = path;
	    EventBus.emit('remote.tracked', {
	      event: event,
	      params: params.payload
	    });
	    return this._request({
	      path: 't',
	      method: 'post',
	      params: {
	        t: Base64.encode(JSON.stringify(assign({
	          event: event
	        }, params.payload))),
	        url: params.url,
	        referer: params.referer || ""
	      },
	      nocallback: true
	    }).then((function(_this) {
	      return function(response) {
	        response.provider = 'track';
	        return response;
	      };
	    })(this)).then(callback || Identity, errback || Identity);
	  };
	
	  return HullTrackService;
	
	})(GenericService);
	
	module.exports = HullTrackService;


/***/ },
/* 128 */
/*!*******************************************!*\
  !*** ./src/remote/services/tumblr.coffee ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, TumblrService,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	TumblrService = (function(superClass) {
	  extend(TumblrService, superClass);
	
	  TumblrService.prototype.name = 'twitter';
	
	  TumblrService.prototype.path = 'tumblr/v2';
	
	  function TumblrService(config, gateway) {
	    TumblrService.__super__.constructor.call(this, config, gateway);
	    this.request = this.wrappedRequest;
	  }
	
	  return TumblrService;
	
	})(GenericService);
	
	module.exports = TumblrService;


/***/ },
/* 129 */
/*!********************************************!*\
  !*** ./src/remote/services/twitter.coffee ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var GenericService, TwitterService,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	GenericService = __webpack_require__(/*! ./generic-service */ 8);
	
	TwitterService = (function(superClass) {
	  extend(TwitterService, superClass);
	
	  TwitterService.prototype.name = 'twitter';
	
	  TwitterService.prototype.path = 'twitter/1.1';
	
	  function TwitterService(config, gateway) {
	    TwitterService.__super__.constructor.call(this, config, gateway);
	    this.request = this.wrappedRequest;
	  }
	
	  return TwitterService;
	
	})(GenericService);
	
	module.exports = TwitterService;


/***/ },
/* 130 */
/*!********************************************!*\
  !*** ./src/utils/config-normalizer.coffee ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var _, applyUserCredentials, clone, cookies, flattenSettings, qs, sortServicesByType;
	
	_ = __webpack_require__(/*! ../utils/lodash */ 1);
	
	clone = __webpack_require__(/*! ../utils/clone */ 9);
	
	cookies = __webpack_require__(/*! ../utils/cookies */ 28);
	
	qs = __webpack_require__(/*! ../utils/query-string-encoder */ 19);
	
	flattenSettings = function(settings, name) {
	  var nameArray;
	  nameArray = name.split('_');
	  if (nameArray.length > 1) {
	    nameArray.pop();
	  }
	  return [nameArray.join('_'), settings[name] || {}];
	};
	
	applyUserCredentials = function(config, creds) {
	  if (creds == null) {
	    creds = {};
	  }
	  _.each(creds, function(c, k) {
	    if (!_.keys(c).length) {
	      return;
	    }
	    if (config != null) {
	      if (config[k] == null) {
	        config[k] = {};
	      }
	    }
	    return config != null ? config[k].credentials = c : void 0;
	  });
	  return config;
	};
	
	sortServicesByType = function(settings, types) {
	  var ret;
	  ret = _.map(types, function(names, type) {
	    var typeSettings;
	    typeSettings = _.zipObject(_.map(names, flattenSettings.bind(void 0, settings)));
	    return [type, typeSettings];
	  });
	  return _.zipObject(ret);
	};
	
	module.exports = function(_config) {
	  var config, services;
	  if (_config == null) {
	    _config = {};
	  }
	  config = clone(_config);
	  if (config.debug == null) {
	    config.debug = false;
	  }
	  services = sortServicesByType(config.services.settings, config.services.types);
	  if (services.auth == null) {
	    services.auth = {};
	  }
	  services.auth = applyUserCredentials(services.auth, config.data.credentials);
	  config.services = services;
	  config.cookiesEnabled = cookies.enabled();
	  config.queryParams = qs.decode() || {};
	  return config;
	};


/***/ },
/* 131 */
/*!***************************************!*\
  !*** ./src/utils/console-shim.coffee ***!
  \***************************************/
/***/ function(module, exports) {

	var log, methods,
	  slice = [].slice;
	
	methods = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "markTimeline", "table", "time", "timeEnd", "timeStamp", "trace", "warn"];
	
	if (!(window.console && console.log)) {
	  (function() {
	    var console, i, len, method, noop, results;
	    noop = function() {};
	    console = window.console = {};
	    results = [];
	    for (i = 0, len = methods.length; i < len; i++) {
	      method = methods[i];
	      results.push(console[method] = noop);
	    }
	    return results;
	  })();
	} else if (typeof console.log === 'object') {
	  log = console.log;
	  console.log = function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return log(args);
	  };
	}


/***/ },
/* 132 */
/*!**************************************!*\
  !*** ./src/utils/decode-hash.coffee ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var Base64;
	
	Base64 = __webpack_require__(/*! ../utils/base64 */ 18);
	
	module.exports = function() {
	  var e, error, h, hash;
	  try {
	    h = document.location.hash.replace('#', '');
	    if (!!h) {
	      hash = JSON.parse(Base64.decode(h));
	    }
	  } catch (error) {
	    e = error;
	    hash = null;
	  }
	  return hash;
	};


/***/ },
/* 133 */
/*!*********************************!*\
  !*** ./src/utils/entity.coffee ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	var Base64;
	
	Base64 = __webpack_require__(/*! ./base64.js */ 18);
	
	module.exports = {
	  decode: function(input) {
	    if (!/^~[a-z0-9_\-\+\/\=]+$/i.test(input)) {
	      throw "'" + input + "' cannot be decoded because it has not been correctly encoded";
	    }
	    return Base64.decodeURL(input.substr(1));
	  },
	  encode: function(input) {
	    return "~" + (Base64.encodeURL(input));
	  }
	};


/***/ },
/* 134 */
/*!******************************************!*\
  !*** ./src/utils/location-origin.coffee ***!
  \******************************************/
/***/ function(module, exports) {

	module.exports = function() {
	  var origin, port;
	  if (window.location.origin) {
	    return window.location.origin;
	  }
	  port = '';
	  if (window.location.port) {
	    port = ':' + window.location.port;
	  }
	  origin = window.location.protocol + "//" + window.location.hostname + port;
	  return origin;
	};


/***/ },
/* 135 */
/*!*******************************!*\
  !*** ./src/utils/pool.coffee ***!
  \*******************************/
/***/ function(module, exports) {

	var _pool, createPool, deletePool, run,
	  slice = [].slice;
	
	_pool = _pool || {};
	
	createPool = function(name) {
	  if (_pool[name] == null) {
	    _pool[name] = [];
	  }
	  return function() {
	    var args;
	    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	    return _pool[name].push(args);
	  };
	};
	
	deletePool = function(name) {
	  return delete _pool[name];
	};
	
	run = function(name, obj) {
	  var data, i, len, ref;
	  ref = _pool[name];
	  for (i = 0, len = ref.length; i < len; i++) {
	    data = ref[i];
	    obj[name].apply(obj, data);
	  }
	  return deletePool(name);
	};
	
	module.exports = {
	  create: createPool,
	  "delete": deletePool,
	  run: run
	};


/***/ },
/* 136 */
/*!*************************!*\
  !*** ./~/flux/index.js ***!
  \*************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(/*! ./lib/Dispatcher */ 137);


/***/ },
/* 137 */
/*!**********************************!*\
  !*** ./~/flux/lib/Dispatcher.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(/*! fbjs/lib/invariant */ 138);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ },
/* 138 */
/*!****************************************!*\
  !*** ./~/flux/~/fbjs/lib/invariant.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 139 */
/*!***************************************************!*\
  !*** ./~/html-loader!./src/utils/ui/captcha.html ***!
  \***************************************************/
/***/ function(module, exports) {

	module.exports = "<div class=hull-captcha-banner-container><h3 class=hull-banner-title>A lot of users have been created with your IP!</h3><p class=hull-banner-text>Please prove us that you are a Human.</p><div class=hull-captcha-container></div></div>";

/***/ },
/* 140 */
/*!****************************************************!*\
  !*** ./~/html-loader!./src/utils/ui/platform.html ***!
  \****************************************************/
/***/ function(module, exports) {

	module.exports = "<div class=hull-banner-container><h3 class=hull-banner-title>Congratulations! Hull is ready.</h3><p class=hull-banner-text>Your snippet is correctly installed and configured<br><i>This banner is only visible to you.</i></p><a class=hull-banner-button data-hull-intent=hull.snippet.success href=#>Close Window</a></div>";

/***/ },
/* 141 */
/*!***********************************!*\
  !*** ./~/lodash/array/compact.js ***!
  \***********************************/
/***/ function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ },
/* 142 */
/*!***********************************!*\
  !*** ./~/lodash/array/indexOf.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ../internal/baseIndexOf */ 33),
	    binaryIndex = __webpack_require__(/*! ../internal/binaryIndex */ 189);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	 * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	 * performs a faster binary search.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	 *  to perform a binary search on a sorted array.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // using `fromIndex`
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 *
	 * // performing a binary search
	 * _.indexOf([1, 1, 2, 2], 2, true);
	 * // => 2
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  if (typeof fromIndex == 'number') {
	    fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	  } else if (fromIndex) {
	    var index = binaryIndex(array, value);
	    if (index < length &&
	        (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	      return index;
	    }
	    return -1;
	  }
	  return baseIndexOf(array, value, fromIndex || 0);
	}
	
	module.exports = indexOf;


/***/ },
/* 143 */
/*!********************************!*\
  !*** ./~/lodash/array/last.js ***!
  \********************************/
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 144 */
/*!********************************!*\
  !*** ./~/lodash/array/uniq.js ***!
  \********************************/
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(/*! ../internal/baseCallback */ 10),
	    baseUniq = __webpack_require__(/*! ../internal/baseUniq */ 187),
	    isIterateeCall = __webpack_require__(/*! ../internal/isIterateeCall */ 26),
	    sortedUniq = __webpack_require__(/*! ../internal/sortedUniq */ 206);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurence of each element
	 * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	 * for sorted arrays. If an iteratee function is provided it's invoked for
	 * each element in the array to generate the criterion by which uniqueness
	 * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index, array).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}
	
	module.exports = uniq;


/***/ },
/* 145 */
/*!*************************************!*\
  !*** ./~/lodash/array/zipObject.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * The inverse of `_.pairs`; this method returns an object composed from arrays
	 * of property names and values. Provide either a single two dimensional array,
	 * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	 * and one of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @alias object
	 * @category Array
	 * @param {Array} props The property names.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObject([['fred', 30], ['barney', 40]]);
	 * // => { 'fred': 30, 'barney': 40 }
	 *
	 * _.zipObject(['fred', 'barney'], [30, 40]);
	 * // => { 'fred': 30, 'barney': 40 }
	 */
	function zipObject(props, values) {
	  var index = -1,
	      length = props ? props.length : 0,
	      result = {};
	
	  if (length && !values && !isArray(props[0])) {
	    values = [];
	  }
	  while (++index < length) {
	    var key = props[index];
	    if (values) {
	      result[key] = values[index];
	    } else if (key) {
	      result[key[0]] = key[1];
	    }
	  }
	  return result;
	}
	
	module.exports = zipObject;


/***/ },
/* 146 */
/*!*****************************************!*\
  !*** ./~/lodash/collection/contains.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./includes */ 152);


/***/ },
/* 147 */
/*!*************************************!*\
  !*** ./~/lodash/collection/each.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./forEach */ 151);


/***/ },
/* 148 */
/*!**************************************!*\
  !*** ./~/lodash/collection/every.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(/*! ../internal/arrayEvery */ 164),
	    baseCallback = __webpack_require__(/*! ../internal/baseCallback */ 10),
	    baseEvery = __webpack_require__(/*! ../internal/baseEvery */ 172),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isIterateeCall = __webpack_require__(/*! ../internal/isIterateeCall */ 26);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * The predicate is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias all
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': false },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.every(users, 'active', false);
	 * // => true
	 *
	 * // using the `_.property` callback shorthand
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	    predicate = undefined;
	  }
	  if (typeof predicate != 'function' || thisArg !== undefined) {
	    predicate = baseCallback(predicate, thisArg, 3);
	  }
	  return func(collection, predicate);
	}
	
	module.exports = every;


/***/ },
/* 149 */
/*!***************************************!*\
  !*** ./~/lodash/collection/filter.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(/*! ../internal/arrayFilter */ 65),
	    baseCallback = __webpack_require__(/*! ../internal/baseCallback */ 10),
	    baseFilter = __webpack_require__(/*! ../internal/baseFilter */ 68),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias select
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * _.filter([4, 5, 6], function(n) {
	 *   return n % 2 == 0;
	 * });
	 * // => [4, 6]
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	 * // => ['barney']
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.pluck(_.filter(users, 'active', false), 'user');
	 * // => ['fred']
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.filter(users, 'active'), 'user');
	 * // => ['barney']
	 */
	function filter(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseCallback(predicate, thisArg, 3);
	  return func(collection, predicate);
	}
	
	module.exports = filter;


/***/ },
/* 150 */
/*!*************************************!*\
  !*** ./~/lodash/collection/find.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ../internal/baseEach */ 13),
	    createFind = __webpack_require__(/*! ../internal/createFind */ 197);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ },
/* 151 */
/*!****************************************!*\
  !*** ./~/lodash/collection/forEach.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(/*! ../internal/arrayEach */ 163),
	    baseEach = __webpack_require__(/*! ../internal/baseEach */ 13),
	    createForEach = __webpack_require__(/*! ../internal/createForEach */ 198);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection). Iteratee functions may exit iteration early
	 * by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	 * may be used for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array|Object|string} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(n) {
	 *   console.log(n);
	 * }).value();
	 * // => logs each value from left to right and returns the array
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	 *   console.log(n, key);
	 * });
	 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	 */
	var forEach = createForEach(arrayEach, baseEach);
	
	module.exports = forEach;


/***/ },
/* 152 */
/*!*****************************************!*\
  !*** ./~/lodash/collection/includes.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ../internal/baseIndexOf */ 33),
	    getLength = __webpack_require__(/*! ../internal/getLength */ 34),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isIterateeCall = __webpack_require__(/*! ../internal/isIterateeCall */ 26),
	    isLength = __webpack_require__(/*! ../internal/isLength */ 14),
	    isString = __webpack_require__(/*! ../lang/isString */ 45),
	    values = __webpack_require__(/*! ../object/values */ 47);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `target` is in `collection` using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	 * from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @alias contains, include
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {*} target The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	 * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	 * // => true
	 *
	 * _.includes('pebbles', 'eb');
	 * // => true
	 */
	function includes(collection, target, fromIndex, guard) {
	  var length = collection ? getLength(collection) : 0;
	  if (!isLength(length)) {
	    collection = values(collection);
	    length = collection.length;
	  }
	  if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	    fromIndex = 0;
	  } else {
	    fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	  }
	  return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	    ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, target, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 153 */
/*!******************************************!*\
  !*** ./~/lodash/collection/partition.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(/*! ../internal/createAggregator */ 192);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, while the second of which
	 * contains elements `predicate` returns falsey for. The predicate is bound
	 * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * _.partition([1, 2, 3], function(n) {
	 *   return n % 2;
	 * });
	 * // => [[1, 3], [2]]
	 *
	 * _.partition([1.2, 2.3, 3.4], function(n) {
	 *   return this.floor(n) % 2;
	 * }, Math);
	 * // => [[1.2, 3.4], [2.3]]
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * var mapper = function(array) {
	 *   return _.pluck(array, 'user');
	 * };
	 *
	 * // using the `_.matches` callback shorthand
	 * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	 * // => [['pebbles'], ['barney', 'fred']]
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.map(_.partition(users, 'active', false), mapper);
	 * // => [['barney', 'pebbles'], ['fred']]
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(_.partition(users, 'active'), mapper);
	 * // => [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ },
/* 154 */
/*!**************************************!*\
  !*** ./~/lodash/collection/pluck.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var map = __webpack_require__(/*! ./map */ 64),
	    property = __webpack_require__(/*! ../utility/property */ 80);
	
	/**
	 * Gets the property value of `path` from all elements in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Array|string} path The path of the property to pluck.
	 * @returns {Array} Returns the property values.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 }
	 * ];
	 *
	 * _.pluck(users, 'user');
	 * // => ['barney', 'fred']
	 *
	 * var userIndex = _.indexBy(users, 'user');
	 * _.pluck(userIndex, 'age');
	 * // => [36, 40] (iteration order is not guaranteed)
	 */
	function pluck(collection, path) {
	  return map(collection, property(path));
	}
	
	module.exports = pluck;


/***/ },
/* 155 */
/*!***************************************!*\
  !*** ./~/lodash/collection/reduce.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(/*! ../internal/arrayReduce */ 166),
	    baseEach = __webpack_require__(/*! ../internal/baseEach */ 13),
	    createReduce = __webpack_require__(/*! ../internal/createReduce */ 199);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` through `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not provided the first element of `collection` is used as the initial
	 * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	 * and `sortByOrder`
	 *
	 * @static
	 * @memberOf _
	 * @alias foldl, inject
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.reduce([1, 2], function(total, n) {
	 *   return total + n;
	 * });
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	 *   result[key] = n * 3;
	 *   return result;
	 * }, {});
	 * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	 */
	var reduce = createReduce(arrayReduce, baseEach);
	
	module.exports = reduce;


/***/ },
/* 156 */
/*!***************************************!*\
  !*** ./~/lodash/collection/reject.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(/*! ../internal/arrayFilter */ 65),
	    baseCallback = __webpack_require__(/*! ../internal/baseCallback */ 10),
	    baseFilter = __webpack_require__(/*! ../internal/baseFilter */ 68),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * _.reject([1, 2, 3, 4], function(n) {
	 *   return n % 2 == 0;
	 * });
	 * // => [1, 3]
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	 * // => ['barney']
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.pluck(_.reject(users, 'active', false), 'user');
	 * // => ['fred']
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.reject(users, 'active'), 'user');
	 * // => ['barney']
	 */
	function reject(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseCallback(predicate, thisArg, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}
	
	module.exports = reject;


/***/ },
/* 157 */
/*!*************************************!*\
  !*** ./~/lodash/collection/some.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(/*! ../internal/arraySome */ 67),
	    baseCallback = __webpack_require__(/*! ../internal/baseCallback */ 10),
	    baseSome = __webpack_require__(/*! ../internal/baseSome */ 185),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isIterateeCall = __webpack_require__(/*! ../internal/isIterateeCall */ 26);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * The function returns as soon as it finds a passing value and does not iterate
	 * over the entire collection. The predicate is bound to `thisArg` and invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias any
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.some(users, 'active', false);
	 * // => true
	 *
	 * // using the `_.property` callback shorthand
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	    predicate = undefined;
	  }
	  if (typeof predicate != 'function' || thisArg !== undefined) {
	    predicate = baseCallback(predicate, thisArg, 3);
	  }
	  return func(collection, predicate);
	}
	
	module.exports = some;


/***/ },
/* 158 */
/*!******************************!*\
  !*** ./~/lodash/date/now.js ***!
  \******************************/
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(/*! ../internal/getNative */ 25);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	module.exports = now;


/***/ },
/* 159 */
/*!***************************************!*\
  !*** ./~/lodash/function/debounce.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ../lang/isObject */ 7),
	    now = __webpack_require__(/*! ../date/now */ 158);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed invocations. Provide an options object to indicate that `func`
	 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	 * Subsequent calls to the debounced function return the result of the last
	 * `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it's invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 160 */
/*!***************************************!*\
  !*** ./~/lodash/function/throttle.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(/*! ./debounce */ 159),
	    isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed invocations. Provide an options object to indicate
	 * that `func` should be invoked on the leading and/or trailing edge of the
	 * `wait` timeout. Subsequent calls to the throttled function return the
	 * result of the last `func` call.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the throttled function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=true] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // avoid excessively updating the position while scrolling
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	 * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	 *   'trailing': false
	 * }));
	 *
	 * // cancel a trailing throttled call
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (options === false) {
	    leading = false;
	  } else if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	}
	
	module.exports = throttle;


/***/ },
/* 161 */
/*!***************************************!*\
  !*** ./~/lodash/internal/SetCache.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(/*! ./cachePush */ 191),
	    getNative = __webpack_require__(/*! ./getNative */ 25);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 162 */
/*!****************************************!*\
  !*** ./~/lodash/internal/arrayCopy.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ },
/* 163 */
/*!****************************************!*\
  !*** ./~/lodash/internal/arrayEach.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 164 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/arrayEvery.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 165 */
/*!****************************************!*\
  !*** ./~/lodash/internal/arrayPush.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 166 */
/*!******************************************!*\
  !*** ./~/lodash/internal/arrayReduce.js ***!
  \******************************************/
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initFromArray] Specify using the first element of `array`
	 *  as the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initFromArray) {
	  var index = -1,
	      length = array.length;
	
	  if (initFromArray && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 167 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/assignDefaults.js ***!
  \*********************************************/
/***/ function(module, exports) {

	/**
	 * Used by `_.defaults` to customize its `_.assign` use.
	 *
	 * @private
	 * @param {*} objectValue The destination object property value.
	 * @param {*} sourceValue The source object property value.
	 * @returns {*} Returns the value to assign to the destination object.
	 */
	function assignDefaults(objectValue, sourceValue) {
	  return objectValue === undefined ? sourceValue : objectValue;
	}
	
	module.exports = assignDefaults;


/***/ },
/* 168 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/assignWith.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(/*! ../object/keys */ 16);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 169 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/baseAssign.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(/*! ./baseCopy */ 170),
	    keys = __webpack_require__(/*! ../object/keys */ 16);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 170 */
/*!***************************************!*\
  !*** ./~/lodash/internal/baseCopy.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 171 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/baseDifference.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ./baseIndexOf */ 33),
	    cacheIndexOf = __webpack_require__(/*! ./cacheIndexOf */ 73),
	    createCache = __webpack_require__(/*! ./createCache */ 74);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 172 */
/*!****************************************!*\
  !*** ./~/lodash/internal/baseEvery.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./baseEach */ 13);
	
	/**
	 * The base implementation of `_.every` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 173 */
/*!***************************************!*\
  !*** ./~/lodash/internal/baseFind.js ***!
  \***************************************/
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 174 */
/*!********************************************!*\
  !*** ./~/lodash/internal/baseFindIndex.js ***!
  \********************************************/
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 175 */
/*!****************************************!*\
  !*** ./~/lodash/internal/baseForIn.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(/*! ./baseFor */ 70),
	    keysIn = __webpack_require__(/*! ../object/keysIn */ 46);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 176 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/baseForOwn.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(/*! ./baseFor */ 70),
	    keys = __webpack_require__(/*! ../object/keys */ 16);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 177 */
/*!**********************************************!*\
  !*** ./~/lodash/internal/baseIsEqualDeep.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(/*! ./equalArrays */ 200),
	    equalByTag = __webpack_require__(/*! ./equalByTag */ 201),
	    equalObjects = __webpack_require__(/*! ./equalObjects */ 202),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isTypedArray = __webpack_require__(/*! ../lang/isTypedArray */ 210);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 178 */
/*!******************************************!*\
  !*** ./~/lodash/internal/baseIsMatch.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(/*! ./baseIsEqual */ 42),
	    toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 179 */
/*!**************************************!*\
  !*** ./~/lodash/internal/baseMap.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./baseEach */ 13),
	    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 21);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 180 */
/*!******************************************!*\
  !*** ./~/lodash/internal/baseMatches.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(/*! ./baseIsMatch */ 178),
	    getMatchData = __webpack_require__(/*! ./getMatchData */ 203),
	    toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 181 */
/*!**************************************************!*\
  !*** ./~/lodash/internal/baseMatchesProperty.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(/*! ./baseGet */ 71),
	    baseIsEqual = __webpack_require__(/*! ./baseIsEqual */ 42),
	    baseSlice = __webpack_require__(/*! ./baseSlice */ 184),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isKey = __webpack_require__(/*! ./isKey */ 75),
	    isStrictComparable = __webpack_require__(/*! ./isStrictComparable */ 76),
	    last = __webpack_require__(/*! ../array/last */ 143),
	    toObject = __webpack_require__(/*! ./toObject */ 11),
	    toPath = __webpack_require__(/*! ./toPath */ 79);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 182 */
/*!***********************************************!*\
  !*** ./~/lodash/internal/basePropertyDeep.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(/*! ./baseGet */ 71),
	    toPath = __webpack_require__(/*! ./toPath */ 79);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 183 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/baseReduce.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight` without support
	 * for callback shorthands and `this` binding, which iterates over `collection`
	 * using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initFromCollection Specify using the first or last element
	 *  of `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initFromCollection
	      ? (initFromCollection = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 184 */
/*!****************************************!*\
  !*** ./~/lodash/internal/baseSlice.js ***!
  \****************************************/
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 185 */
/*!***************************************!*\
  !*** ./~/lodash/internal/baseSome.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(/*! ./baseEach */ 13);
	
	/**
	 * The base implementation of `_.some` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 186 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/baseToString.js ***!
  \*******************************************/
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 187 */
/*!***************************************!*\
  !*** ./~/lodash/internal/baseUniq.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(/*! ./baseIndexOf */ 33),
	    cacheIndexOf = __webpack_require__(/*! ./cacheIndexOf */ 73),
	    createCache = __webpack_require__(/*! ./createCache */ 74);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 188 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/baseValues.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  var index = -1,
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = object[props[index]];
	  }
	  return result;
	}
	
	module.exports = baseValues;


/***/ },
/* 189 */
/*!******************************************!*\
  !*** ./~/lodash/internal/binaryIndex.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var binaryIndexBy = __webpack_require__(/*! ./binaryIndexBy */ 190),
	    identity = __webpack_require__(/*! ../utility/identity */ 48);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295,
	    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	/**
	 * Performs a binary search of `array` to determine the index at which `value`
	 * should be inserted into `array` in order to maintain its sort order.
	 *
	 * @private
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {boolean} [retHighest] Specify returning the highest qualified index.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 */
	function binaryIndex(array, value, retHighest) {
	  var low = 0,
	      high = array ? array.length : low;
	
	  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	    while (low < high) {
	      var mid = (low + high) >>> 1,
	          computed = array[mid];
	
	      if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	        low = mid + 1;
	      } else {
	        high = mid;
	      }
	    }
	    return high;
	  }
	  return binaryIndexBy(array, value, identity, retHighest);
	}
	
	module.exports = binaryIndex;


/***/ },
/* 190 */
/*!********************************************!*\
  !*** ./~/lodash/internal/binaryIndexBy.js ***!
  \********************************************/
/***/ function(module, exports) {

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeMin = Math.min;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295,
	    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;
	
	/**
	 * This function is like `binaryIndex` except that it invokes `iteratee` for
	 * `value` and each element of `array` to compute their sort ranking. The
	 * iteratee is invoked with one argument; (value).
	 *
	 * @private
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {boolean} [retHighest] Specify returning the highest qualified index.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 */
	function binaryIndexBy(array, value, iteratee, retHighest) {
	  value = iteratee(value);
	
	  var low = 0,
	      high = array ? array.length : 0,
	      valIsNaN = value !== value,
	      valIsNull = value === null,
	      valIsUndef = value === undefined;
	
	  while (low < high) {
	    var mid = nativeFloor((low + high) / 2),
	        computed = iteratee(array[mid]),
	        isDef = computed !== undefined,
	        isReflexive = computed === computed;
	
	    if (valIsNaN) {
	      var setLow = isReflexive || retHighest;
	    } else if (valIsNull) {
	      setLow = isReflexive && isDef && (retHighest || computed != null);
	    } else if (valIsUndef) {
	      setLow = isReflexive && (retHighest || isDef);
	    } else if (computed == null) {
	      setLow = false;
	    } else {
	      setLow = retHighest ? (computed <= value) : (computed < value);
	    }
	    if (setLow) {
	      low = mid + 1;
	    } else {
	      high = mid;
	    }
	  }
	  return nativeMin(high, MAX_ARRAY_INDEX);
	}
	
	module.exports = binaryIndexBy;


/***/ },
/* 191 */
/*!****************************************!*\
  !*** ./~/lodash/internal/cachePush.js ***!
  \****************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ../lang/isObject */ 7);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 192 */
/*!***********************************************!*\
  !*** ./~/lodash/internal/createAggregator.js ***!
  \***********************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(/*! ./baseCallback */ 10),
	    baseEach = __webpack_require__(/*! ./baseEach */ 13),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	 *
	 * @private
	 * @param {Function} setter The function to set keys and values of the accumulator object.
	 * @param {Function} [initializer] The function to initialize the accumulator object.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee, thisArg) {
	    var result = initializer ? initializer() : {};
	    iteratee = baseCallback(iteratee, thisArg, 3);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        setter(result, value, iteratee(value, index, collection), collection);
	      }
	    } else {
	      baseEach(collection, function(value, key, collection) {
	        setter(result, value, iteratee(value, key, collection), collection);
	      });
	    }
	    return result;
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 193 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/createAssigner.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(/*! ./bindCallback */ 20),
	    isIterateeCall = __webpack_require__(/*! ./isIterateeCall */ 26),
	    restParam = __webpack_require__(/*! ../function/restParam */ 32);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 194 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/createBaseEach.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(/*! ./getLength */ 34),
	    isLength = __webpack_require__(/*! ./isLength */ 14),
	    toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 195 */
/*!********************************************!*\
  !*** ./~/lodash/internal/createBaseFor.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(/*! ./toObject */ 11);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 196 */
/*!*********************************************!*\
  !*** ./~/lodash/internal/createDefaults.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var restParam = __webpack_require__(/*! ../function/restParam */ 32);
	
	/**
	 * Creates a `_.defaults` or `_.defaultsDeep` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Function} Returns the new defaults function.
	 */
	function createDefaults(assigner, customizer) {
	  return restParam(function(args) {
	    var object = args[0];
	    if (object == null) {
	      return object;
	    }
	    args.push(customizer);
	    return assigner.apply(undefined, args);
	  });
	}
	
	module.exports = createDefaults;


/***/ },
/* 197 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/createFind.js ***!
  \*****************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(/*! ./baseCallback */ 10),
	    baseFind = __webpack_require__(/*! ./baseFind */ 173),
	    baseFindIndex = __webpack_require__(/*! ./baseFindIndex */ 174),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 198 */
/*!********************************************!*\
  !*** ./~/lodash/internal/createForEach.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(/*! ./bindCallback */ 20),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * Creates a function for `_.forEach` or `_.forEachRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createForEach(arrayFunc, eachFunc) {
	  return function(collection, iteratee, thisArg) {
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee)
	      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	  };
	}
	
	module.exports = createForEach;


/***/ },
/* 199 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/createReduce.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(/*! ./baseCallback */ 10),
	    baseReduce = __webpack_require__(/*! ./baseReduce */ 183),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4);
	
	/**
	 * Creates a function for `_.reduce` or `_.reduceRight`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over an array.
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @returns {Function} Returns the new each function.
	 */
	function createReduce(arrayFunc, eachFunc) {
	  return function(collection, iteratee, accumulator, thisArg) {
	    var initFromArray = arguments.length < 3;
	    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	      ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	      : baseReduce(collection, baseCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	  };
	}
	
	module.exports = createReduce;


/***/ },
/* 200 */
/*!******************************************!*\
  !*** ./~/lodash/internal/equalArrays.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(/*! ./arraySome */ 67);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 201 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/equalByTag.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 202 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/equalObjects.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(/*! ../object/keys */ 16);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 203 */
/*!*******************************************!*\
  !*** ./~/lodash/internal/getMatchData.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(/*! ./isStrictComparable */ 76),
	    pairs = __webpack_require__(/*! ../object/pairs */ 215);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 204 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/indexOfNaN.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 205 */
/*!***************************************!*\
  !*** ./~/lodash/internal/shimKeys.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(/*! ../lang/isArguments */ 35),
	    isArray = __webpack_require__(/*! ../lang/isArray */ 4),
	    isIndex = __webpack_require__(/*! ./isIndex */ 43),
	    isLength = __webpack_require__(/*! ./isLength */ 14),
	    keysIn = __webpack_require__(/*! ../object/keysIn */ 46);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 206 */
/*!*****************************************!*\
  !*** ./~/lodash/internal/sortedUniq.js ***!
  \*****************************************/
/***/ function(module, exports) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = sortedUniq;


/***/ },
/* 207 */
/*!**********************************!*\
  !*** ./~/lodash/lang/isEmpty.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(/*! ./isArguments */ 35),
	    isArray = __webpack_require__(/*! ./isArray */ 4),
	    isArrayLike = __webpack_require__(/*! ../internal/isArrayLike */ 21),
	    isFunction = __webpack_require__(/*! ./isFunction */ 44),
	    isObjectLike = __webpack_require__(/*! ../internal/isObjectLike */ 15),
	    isString = __webpack_require__(/*! ./isString */ 45),
	    keys = __webpack_require__(/*! ../object/keys */ 16);
	
	/**
	 * Checks if `value` is empty. A value is considered empty unless it's an
	 * `arguments` object, array, string, or jQuery-like collection with a length
	 * greater than `0` or an object with own enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Array|Object|string} value The value to inspect.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	      (isObjectLike(value) && isFunction(value.splice)))) {
	    return !value.length;
	  }
	  return !keys(value).length;
	}
	
	module.exports = isEmpty;


/***/ },
/* 208 */
/*!**********************************!*\
  !*** ./~/lodash/lang/isEqual.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(/*! ../internal/baseIsEqual */ 42),
	    bindCallback = __webpack_require__(/*! ../internal/bindCallback */ 20);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent. If `customizer` is provided it's invoked to compare values.
	 * If `customizer` returns `undefined` comparisons are handled by the method
	 * instead. The `customizer` is bound to `thisArg` and invoked with up to
	 * three arguments: (value, other [, index|key]).
	 *
	 * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	 * numbers, `Object` objects, regexes, and strings. Objects are compared by
	 * their own, not inherited, enumerable properties. Functions and DOM nodes
	 * are **not** supported. Provide a customizer function to extend support
	 * for comparing other values.
	 *
	 * @static
	 * @memberOf _
	 * @alias eq
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize value comparisons.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * object == other;
	 * // => false
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * // using a customizer callback
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqual(array, other, function(value, other) {
	 *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	 *     return true;
	 *   }
	 * });
	 * // => true
	 */
	function isEqual(value, other, customizer, thisArg) {
	  customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	}
	
	module.exports = isEqual;


/***/ },
/* 209 */
/*!***********************************!*\
  !*** ./~/lodash/lang/isNative.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(/*! ./isFunction */ 44),
	    isObjectLike = __webpack_require__(/*! ../internal/isObjectLike */ 15);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 210 */
/*!***************************************!*\
  !*** ./~/lodash/lang/isTypedArray.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(/*! ../internal/isLength */ 14),
	    isObjectLike = __webpack_require__(/*! ../internal/isObjectLike */ 15);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 211 */
/*!**********************************!*\
  !*** ./~/lodash/lang/toArray.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(/*! ../internal/arrayCopy */ 162),
	    getLength = __webpack_require__(/*! ../internal/getLength */ 34),
	    isLength = __webpack_require__(/*! ../internal/isLength */ 14),
	    values = __webpack_require__(/*! ../object/values */ 47);
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * (function() {
	 *   return _.toArray(arguments).slice(1);
	 * }(1, 2, 3));
	 * // => [2, 3]
	 */
	function toArray(value) {
	  var length = value ? getLength(value) : 0;
	  if (!isLength(length)) {
	    return values(value);
	  }
	  if (!length) {
	    return [];
	  }
	  return arrayCopy(value);
	}
	
	module.exports = toArray;


/***/ },
/* 212 */
/*!***********************************!*\
  !*** ./~/lodash/object/assign.js ***!
  \***********************************/
/***/ function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(/*! ../internal/assignWith */ 168),
	    baseAssign = __webpack_require__(/*! ../internal/baseAssign */ 169),
	    createAssigner = __webpack_require__(/*! ../internal/createAssigner */ 193);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it's invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 213 */
/*!*************************************!*\
  !*** ./~/lodash/object/defaults.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(/*! ./assign */ 212),
	    assignDefaults = __webpack_require__(/*! ../internal/assignDefaults */ 167),
	    createDefaults = __webpack_require__(/*! ../internal/createDefaults */ 196);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object for all destination properties that resolve to `undefined`. Once a
	 * property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var defaults = createDefaults(assign, assignDefaults);
	
	module.exports = defaults;


/***/ },
/* 214 */
/*!*********************************!*\
  !*** ./~/lodash/object/omit.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(/*! ../internal/arrayMap */ 66),
	    baseDifference = __webpack_require__(/*! ../internal/baseDifference */ 171),
	    baseFlatten = __webpack_require__(/*! ../internal/baseFlatten */ 69),
	    bindCallback = __webpack_require__(/*! ../internal/bindCallback */ 20),
	    keysIn = __webpack_require__(/*! ./keysIn */ 46),
	    pickByArray = __webpack_require__(/*! ../internal/pickByArray */ 77),
	    pickByCallback = __webpack_require__(/*! ../internal/pickByCallback */ 78),
	    restParam = __webpack_require__(/*! ../function/restParam */ 32);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to omit, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.omit(object, 'age');
	 * // => { 'user': 'fred' }
	 *
	 * _.omit(object, _.isNumber);
	 * // => { 'user': 'fred' }
	 */
	var omit = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  if (typeof props[0] != 'function') {
	    var props = arrayMap(baseFlatten(props), String);
	    return pickByArray(object, baseDifference(keysIn(object), props));
	  }
	  var predicate = bindCallback(props[0], props[1], 3);
	  return pickByCallback(object, function(value, key, object) {
	    return !predicate(value, key, object);
	  });
	});
	
	module.exports = omit;


/***/ },
/* 215 */
/*!**********************************!*\
  !*** ./~/lodash/object/pairs.js ***!
  \**********************************/
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(/*! ./keys */ 16),
	    toObject = __webpack_require__(/*! ../internal/toObject */ 11);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 216 */
/*!*********************************!*\
  !*** ./~/lodash/object/pick.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(/*! ../internal/baseFlatten */ 69),
	    bindCallback = __webpack_require__(/*! ../internal/bindCallback */ 20),
	    pickByArray = __webpack_require__(/*! ../internal/pickByArray */ 77),
	    pickByCallback = __webpack_require__(/*! ../internal/pickByCallback */ 78),
	    restParam = __webpack_require__(/*! ../function/restParam */ 32);
	
	/**
	 * Creates an object composed of the picked `object` properties. Property
	 * names may be specified as individual arguments or as arrays of property
	 * names. If `predicate` is provided it's invoked for each property of `object`
	 * picking the properties `predicate` returns truthy for. The predicate is
	 * bound to `thisArg` and invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|...(string|string[])} [predicate] The function invoked per
	 *  iteration or property names to pick, specified as individual property
	 *  names or arrays of property names.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.pick(object, 'user');
	 * // => { 'user': 'fred' }
	 *
	 * _.pick(object, _.isString);
	 * // => { 'user': 'fred' }
	 */
	var pick = restParam(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  return typeof props[0] == 'function'
	    ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	    : pickByArray(object, baseFlatten(props));
	});
	
	module.exports = pick;


/***/ },
/* 217 */
/*!******************************************!*\
  !*** ./~/putainde-localstorage/index.js ***!
  \******************************************/
/***/ function(module, exports) {

	/**
	 * global variables
	 */
	var namespace = ""
	var cache = {}
	
	function getCache(ns){
	  if(cache[ns] === undefined) {
	    cache[ns] = storageEngine.get(ns) || {}
	  }
	
	  return cache[ns]
	}
	
	function setCache(ns, c){
	  cache[ns] = c
	  return storageEngine.set(ns, cache[ns])
	}
	
	/**
	 * Expose library
	 */
	module.exports = Storage
	
	/**
	 * Constructor
	 * @param {Object} cfg options
	 */
	function Storage(cfg){
	  cfg = cfg || {}
	  this.ns = cfg.namespace || "storage"
	}
	
	/**
	 * nicer constructor
	 * @param  {Object} cfg options
	 * @return {Object} Storage instance
	 */
	Storage.create = function(cfg){
	  return new Storage(cfg)
	}
	
	/**
	 * Storage API
	 * @type {Object}
	 */
	Storage.prototype = {
	  /**
	   * setter
	   *
	   * @param {String|Object} key   key or an {key: value} object
	   * @param {Object} value value if first parameter is a key
	   */
	  set : function(key, value){
	    var c = getCache(this.ns)
	
	    // set({foo: "bar"})
	    if(arguments.length === 1 && typeof key === "object") {
	      Object.keys(key).forEach(function(k){
	        c[k] = key[k]
	      }, this)
	    }
	
	    // set("foo", "bar")
	    else {
	      c[key] = value
	    }
	
	    return setCache(this.ns, c)
	  },
	
	  /**
	   * getter
	   *
	   * @param  {Object} key
	   * @param  {Object} defaultValue
	   * @return {Object} value corresponding to key or all values if no key provided
	   */
	  get : function(key, defaultValue){
	    var c = getCache(this.ns)
	
	    if(arguments.length === 0) {
	      return c
	    }
	
	    return c[key] !== undefined ? c[key] : defaultValue
	  },
	
	  /**
	   * remove value corresponding to the given key
	   * @param  {String} key
	   */
	  remove : function(key){
	    var cache = getCache(this.ns)
	    delete cache[key]
	    setCache(this.ns, cache)
	  },
	
	  /**
	   * remove all values
	   */
	  clear : function(){
	    setCache(this.ns, {})
	  }
	}
	
	/**
	 * localStorage engine
	 * @type {Object}
	 */
	var storageEngine = {
	  get : function(key){
	    var value = window.localStorage.getItem(namespace + key)
	
	    try{
	      value = JSON.parse(value)
	    }
	    catch(e) {
	      if(console && console.warn) console.warn("'" + key + "'" + " isn't valid JSON: " + value)
	    }
	
	    return value || {}
	  },
	
	  set : function(key, value){
	    return window.localStorage.setItem(namespace + key, JSON.stringify(value))
	  },
	
	  remove : function(key){
	    return window.localStorage.removeItem(namespace + key)
	  }
	}


/***/ },
/* 218 */
/*!***********************!*\
  !*** ./~/qs/index.js ***!
  \***********************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./lib/ */ 219);


/***/ },
/* 219 */
/*!***************************!*\
  !*** ./~/qs/lib/index.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(/*! ./stringify */ 221);
	var Parse = __webpack_require__(/*! ./parse */ 220);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 220 */
/*!***************************!*\
  !*** ./~/qs/lib/parse.js ***!
  \***************************/
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(/*! ./utils */ 81);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 221 */
/*!*******************************!*\
  !*** ./~/qs/lib/stringify.js ***!
  \*******************************/
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(/*! ./utils */ 81);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 222 */
/*!**************************************************************************!*\
  !*** ./~/raw-loader!./~/inline-style-loader!./src/utils/ui/platform.css ***!
  \**************************************************************************/
/***/ function(module, exports) {

	module.exports = {".hull-banner-container":"position: fixed; top: 0; left: 0; right: 0; padding: 30px 0; background: white; -webkit-font-smoothing: antialiased; text-align: center",".hull-captcha-banner-container":"position: fixed; top: 0; left: 0; right: 0; height: 100%; padding: 30px 0; background: white; background: rgba(255,255,255,.95)\n  -webkit-font-smoothing: antialiased; text-align: center",".hull-banner-title":"color: #666; margin: 0 0 5px 0; font-size: 24px; font-weight: normal; font-family: 'Helvetica Neue',Helvetica,arial,sans-serif",".hull-banner-text":"font-size: 14px; margin: 0 0 10px 0; color: #838383; font-weight: normal; font-family: 'Helvetica Neue',Helvetica,arial,sans-serif",".hull-banner-button":"-webkit-border-radius: 3px; -moz-border-radius: 3px; -ms-border-radius: 3px; -o-border-radius: 3px; border-radius: 3px; margin: 0; background: white; color: #33ADEC; border: 1px solid #33ADEC; padding: 10px 30px; font-size: 14px; line-height: 50px; font-weight: normal",".hull-captcha-container":"width: 304px; margin: 30px auto 0 auto"}

/***/ },
/* 223 */
/*!***************************************************!*\
  !*** ./~/superagent/~/component-emitter/index.js ***!
  \***************************************************/
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 224 */
/*!**************************************************!*\
  !*** ./~/superagent/~/reduce-component/index.js ***!
  \**************************************************/
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 225 */
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 226 */
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 227 */
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** hull.js
 **/